import { makeTheme } from '@theme-ui/css/utils';
import 'deepmerge';
import { useThemeUI, jsx } from '@theme-ui/core';
export { ThemeProvider } from '@theme-ui/core';
import { get } from '@theme-ui/css';
import { Button as Button$1, Flex, Box, Input, Link, Container, Switch as Switch$1, Textarea as Textarea$1, Radio as Radio$1, Badge as Badge$1, Image as Image$1, AspectImage, Avatar as Avatar$1, Heading as Heading$1, Text, Spinner as Spinner$1, Alert as Alert$1, Close, Card as Card$1, NavLink } from '@theme-ui/components';
export { AspectRatio, Box, Divider, Flex, Grid } from '@theme-ui/components';
import React, { useState, useEffect } from 'react';
import * as icons from 'react-feather';
import { Mail, Lock, Eye, EyeOff, LogIn, Search, ChevronUp, ChevronDown, ChevronRight } from 'react-feather';
import ReactSelect, { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import Picker, { RangePicker } from 'rc-picker';
import dayjs from 'dayjs';
import { noteOnce } from 'rc-util/lib/warning';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { Global, keyframes } from '@emotion/react';
import Joyride from 'react-joyride';
var button = {
  alignItems: 'center',
  borderRadius: '8px',
  cursor: 'pointer',
  display: 'flex',
  lineHeight: '21px',
  fontWeight: '700',
  justifyContent: 'center'
};
var text = {
  body_lg_regular: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 400
  },
  body_lg_semibold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 600
  },
  body_lg_bold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 700
  },
  body_lg_italic: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 400,
    fontStyle: 'italic'
  },
  body_lg_underline: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 400,
    textDecoration: 'underline'
  },
  body_lg_underline_semibold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 600,
    textDecoration: 'underline'
  },
  body_lg_underline_bold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '18px',
    lineHeight: '28px',
    fontWeight: 700,
    textDecoration: 'underline'
  },
  body_sm_regular: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400
  },
  body_sm_semibold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600
  },
  body_sm_bold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 700
  },
  body_sm_italic: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    fontStyle: 'italic'
  },
  body_sm_underline: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    textDecoration: 'underline'
  },
  body_sm_underline_semibold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600,
    textDecoration: 'underline'
  },
  body_sm_underline_bold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 700,
    textDecoration: 'underline'
  },
  caption_lg_regular: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: 400
  },
  caption_lg_semibold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: 600
  },
  caption_lg_bold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: 700
  },
  caption_lg_italic: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: 400,
    fontStyle: 'italic'
  },
  caption_lg_underline: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: 400,
    textDecoration: 'underline'
  },
  caption_lg_underline_semibold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: 600,
    textDecoration: 'underline'
  },
  caption_lg_underline_bold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: 700,
    textDecoration: 'underline'
  },
  caption_sm_regular: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 400
  },
  caption_sm_semibold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 600
  },
  caption_sm_bold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 700
  },
  caption_sm_italic: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 400,
    fontStyle: 'italic'
  },
  caption_sm_underline: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 400,
    textDecoration: 'underline'
  },
  caption_sm_underline_semibold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 600,
    textDecoration: 'underline'
  },
  caption_sm_underline_bold: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 700,
    textDecoration: 'underline'
  },
  h1: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '60px',
    lineHeight: '72px',
    fontWeight: '700'
  },
  h2: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '48px',
    lineHeight: '56px',
    fontWeight: '700'
  },
  h3: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '36px',
    lineHeight: '44px',
    fontWeight: '700'
  },
  h4: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '30px',
    lineHeight: '40px',
    fontWeight: '700'
  },
  h5: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '24px',
    lineHeight: '36px',
    fontWeight: '700'
  },
  h6: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: '700'
  }
};
var color = {
  primary25: '#FBFAFF',
  primary50: '#F5F3FF',
  primary100: '#ECE9FE',
  primary200: '#DDD6FE',
  primary300: '#C3B5FD',
  primary400: '#A48AFB',
  primary500: '#875BF7',
  primary600: '#7839EE',
  primary700: '#6927DA',
  primary800: '#5720B7',
  primary900: '#491C96',
  secondary25: '#F5F8FF',
  secondary50: '#EFF4FF',
  secondary100: '#D1E0FF',
  secondary200: '#B2CCFF',
  secondary300: '#84ADFF',
  secondary400: '#528BFF',
  secondary500: '#2970FF',
  secondary600: '#155EEF',
  secondary700: '#004EEB',
  secondary800: '#0040C1',
  secondary900: '#00359E',
  tertiary25: '#FCFCFD',
  tertiary50: '#F9FAFB',
  tertiary60: '#8C8F93',
  tertiary100: '#F2F4F7',
  tertiary200: '#EAECF0',
  tertiary300: '#D0D5DD',
  tertiary400: '#98A2B3',
  tertiary500: '#667085',
  tertiary600: '#475467',
  tertiary700: '#344054',
  tertiary800: '#1D2939',
  tertiary900: '#101828',
  success25: '#F6FEF9',
  success50: '#ECFDF3',
  success100: '#D1FADF',
  success200: '#A6F4C5',
  success300: '#6CE9A6',
  success400: '#32D583',
  success500: '#12B76A',
  success600: '#039855',
  success700: '#027A48',
  success800: '#05603A',
  success900: '#054F31',
  warning25: '#FFFCF5',
  warning50: '#FFFAEB',
  warning100: '#FEF0C7',
  warning200: '#FEDF89',
  warning300: '#FEC84B',
  warning400: '#FDB022',
  warning500: '#F79009',
  warning600: '#DC6803',
  warning700: '#B54708',
  warning800: '#93370D',
  warning900: '#7A2E0E',
  error25: '#FFFBFA',
  error50: '#FEF3F2',
  error100: '#FEE4E2',
  error200: '#FECDCA',
  error300: '#FDA29B',
  error400: '#F97066',
  error500: '#F04438',
  error600: '#D92D20',
  error700: '#B42318',
  error800: '#912018',
  error900: '#7A271A',
  info25: '#F5FAFF',
  info50: '#EFF8FF',
  info100: '#D1E9FF',
  info200: '#B2DDFF',
  info300: '#84CAFF',
  info400: '#53B1FD',
  info500: '#2E90FA',
  info600: '#1570EF',
  info700: '#175CD3',
  info800: '#1849A9',
  info900: '#194185'
};

// Spacer
var radius = {
  radius0: '0px',
  radius1: '0.125rem',
  radius2: '0.25rem',
  radius3: '0.375rem',
  radius4: '0.5rem',
  radius5: '0.75rem',
  radius6: '1rem',
  radius7: '1.5rem',
  radius8: '1.75rem',
  radius9: '2rem'
};

// Spacer
var spacer = {
  spacing0: '1px',
  spacing1: '4px',
  spacing2: '0.5rem',
  spacing3: '0.75rem',
  spacing4: '1rem',
  spacing5: '1.25rem',
  spacing6: '1.5rem',
  spacing7: '1.75rem',
  spacing8: '2rem',
  spacing9: '2.25rem',
  spacing10: '2.5rem',
  spacing11: '3rem',
  spacing12: '3.5rem',
  spacing13: '4rem',
  spacing14: '5rem',
  spacing15: '6rem',
  spacing16: '7rem',
  spacing17: '8rem',
  spacing18: '9rem',
  spacing19: '10rem',
  spacing20: '11rem',
  spacing21: '12rem',
  spacing22: '13rem',
  spacing23: '14rem',
  spacing24: '15rem',
  spacing25: '16rem',
  spacing26: '18rem',
  spacing27: '20rem',
  spacing28: '24rem'
};
var alerts = {
  outerWrapper: {
    width: '100%',
    paddingTop: spacer.spacing2,
    paddingBottom: spacer.spacing2
  },
  iconWrapper: {
    borderRadius: radius.radius8,
    width: 24,
    height: 24
  },
  titleMargin: {
    marginRight: spacer.spacing3
  },
  descMargin: {
    marginLeft: '35px'
  },
  info: {
    bg: color.info25,
    border: "1px solid " + color.info500
  },
  success: {
    bg: color.success25,
    border: "1px solid " + color.success500
  },
  error: {
    bg: color.error25,
    border: "1px solid " + color.error500
  },
  warning: {
    bg: color.warning25,
    border: "1px solid " + color.warning500
  },
  infoIcon: {
    bg: color.info500
  },
  successIcon: {
    bg: color.success500
  },
  errorIcon: {
    bg: color.error500
  },
  warningIcon: {
    bg: color.warning500
  },
  title: {
    fontSize: 16,
    fontFamily: 'Nunito Sans, sans-serif',
    fontWeight: 700,
    color: color.tertiary800
  },
  desc: {
    fontSize: 12,
    fontFamily: 'Nunito Sans, sans-serif',
    fontWeight: 400,
    color: color.tertiary500
  },
  close: {
    width: 28,
    height: 28,
    color: color.tertiary800,
    cursor: 'pointer'
  }
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
var badges = {
  primary: {
    bg: "" + color.primary500,
    color: color.tertiary25
  },
  secondary: {
    bg: "" + color.secondary500,
    color: color.tertiary25
  },
  error: {
    bg: "" + color.error50,
    color: color.error500
  },
  info: {
    bg: "" + color.secondary50,
    color: color.secondary500
  },
  success: {
    bg: "" + color.success50,
    color: color.success500
  },
  warning: {
    bg: "" + color.warning50,
    color: color.warning500
  },
  small: /*#__PURE__*/_extends({
    width: 8,
    height: 8,
    borderRadius: 8 / 2
  }, text.body_sm_regular),
  smallWithBorder: /*#__PURE__*/_extends({
    border: '1px solid white',
    height: 10,
    borderRadius: 10 / 2
  }, text.body_sm_regular),
  largeWithBorder: /*#__PURE__*/_extends({
    border: '2px solid white'
  }, text.body_lg_regular),
  smallWithContent: /*#__PURE__*/_extends({
    display: 'inline-flex',
    alignItems: 'center',
    height: 21,
    borderRadius: 24,
    paddingX: '7px'
  }, text.body_sm_regular),
  largeWithContent: /*#__PURE__*/_extends({
    display: 'inline-flex',
    alignItems: 'center',
    height: 28,
    borderRadius: 24,
    paddingX: '14px'
  }, text.body_lg_regular),
  large: /*#__PURE__*/_extends({
    width: 12,
    height: 12,
    borderRadius: 12 / 2
  }, text.body_lg_regular)
};
var buttons = {
  sm: {
    minWidth: '32px',
    minHeight: '32px',
    padding: '5px 7px !important',
    fontSize: '14px !important',
    lineHeight: '20px'
  },
  md: {
    minWidth: '40px',
    minHeight: '40px',
    padding: '7px 11px !important',
    fontSize: '16px !important',
    lineHeight: '24px'
  },
  lg: {
    minWidth: '56px',
    minHeight: '56px',
    padding: '13px 15px !important',
    fontSize: '18px !important',
    lineHeight: '28px'
  },
  'btn-secondary': /*#__PURE__*/_extends({}, button, {
    backgroundColor: 'primary200',
    color: 'primary500',
    border: 'none',
    fontFamily: 'Nunito Sans, sans-serif',
    '& .wrapper-icon-left-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '& .wrapper-icon-both-children': {
      marginLeft: '10px',
      marginRight: '10px'
    },
    '& .wrapper-icon-left-children': {
      marginLeft: '10px'
    },
    '& .wrapper-icon-right-children': {
      marginRight: '10px'
    },
    '& .wrapper-two-icon': {
      marginRight: '10px'
    },
    '& .wrapperIconLeft': {
      marginRight: 10
    },
    '& .wrapperIconRight': {
      marginLeft: 10
    },
    '& .wrapper-icon-right-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '&:hover': {
      backgroundColor: 'primary300',
      boxShadow: 'none !important'
    },
    '&:focus': {
      boxShadow: "0px 0px 0px 2px " + color.primary400 + " !important"
    },
    '&:active': {
      backgroundColor: color.primary400 + " !important",
      boxShadow: 'none !important'
    },
    '&:disabled': {
      cursor: 'unset !important',
      backgroundColor: color.tertiary300 + " !important",
      color: color.tertiary500 + " !important"
    }
  }),
  'btn-primary': /*#__PURE__*/_extends({}, button, {
    backgroundColor: 'primary500',
    color: 'tertiary25',
    border: 'none',
    fontFamily: 'Nunito Sans, sans-serif',
    '& .wrapper-icon-left-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '& .wrapper-icon-both-children': {
      marginLeft: '10px',
      marginRight: '10px'
    },
    '& .wrapper-icon-left-children': {
      marginLeft: '10px'
    },
    '& .wrapper-icon-right-children': {
      marginRight: '10px'
    },
    '& .wrapper-two-icon': {
      marginRight: '10px'
    },
    '& .wrapperIconLeft': {
      marginRight: 10
    },
    '& .wrapperIconRight': {
      marginLeft: 10
    },
    '& .wrapper-icon-right-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '&:hover': {
      backgroundColor: 'primary600',
      boxShadow: 'none !important'
    },
    '&:focus': {
      boxShadow: "0px 0px 0px 2px " + color.primary400 + " !important"
    },
    '&:active': {
      backgroundColor: color.primary700 + " !important",
      boxShadow: 'none !important'
    },
    '&:disabled': {
      cursor: 'unset !important',
      backgroundColor: color.tertiary300 + " !important",
      color: color.tertiary500 + " !important"
    }
  }),
  solid: /*#__PURE__*/_extends({}, button, {
    fontFamily: 'Nunito Sans, sans-serif',
    '& .wrapper-icon-left-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '& .wrapper-icon-both-children': {
      marginLeft: '10px',
      marginRight: '10px'
    },
    '& .wrapper-icon-left-children': {
      marginLeft: '10px'
    },
    '& .wrapper-icon-right-children': {
      marginRight: '10px'
    },
    '& .wrapper-two-icon': {
      marginRight: '10px'
    },
    '& .wrapperIconLeft': {
      marginRight: 10
    },
    '& .wrapperIconRight': {
      marginLeft: 10
    },
    '& .wrapper-icon-right-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    primary: {
      backgroundColor: 'primary500',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: 'primary600',
        boxShadow: 'none !important'
      },
      '&:focus': {
        boxShadow: "inset 0px 0px 0px 2px " + color.primary400 + " !important"
      },
      '&:active': {
        backgroundColor: color.primary700 + " !important",
        border: 'none',
        boxShadow: 'none !important'
      },
      '&:disabled': {
        cursor: 'unset !important',
        backgroundColor: color.tertiary300 + " !important",
        color: color.tertiary500 + " !important"
      }
    },
    secondary: {
      backgroundColor: 'secondary500',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: 'secondary600',
        boxShadow: 'none !important'
      },
      '&:focus': {
        boxShadow: "inset 0px 0px 0px 2px " + color.secondary400 + " !important"
      },
      '&:active': {
        backgroundColor: color.secondary700 + " !important",
        border: 'none',
        boxShadow: 'none !important'
      },
      '&:disabled': {
        cursor: 'unset !important',
        backgroundColor: color.tertiary300 + " !important",
        color: color.tertiary500 + " !important"
      }
    },
    tertiary: {
      backgroundColor: 'tertiary500',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: 'tertiary600',
        boxShadow: 'none !important'
      },
      '&:focus': {
        boxShadow: "inset 0px 0px 0px 2px " + color.tertiary400 + " !important"
      },
      '&:active': {
        backgroundColor: color.tertiary700 + " !important",
        border: 'none',
        boxShadow: 'none !important'
      },
      '&:disabled': {
        cursor: 'unset !important',
        backgroundColor: color.tertiary300 + " !important",
        color: color.tertiary500 + " !important"
      }
    },
    success: {
      backgroundColor: 'success500',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: 'success600',
        boxShadow: 'none !important'
      },
      '&:focus': {
        boxShadow: "inset 0px 0px 0px 2px " + color.success400 + " !important"
      },
      '&:active': {
        backgroundColor: color.success700 + " !important",
        border: 'none',
        boxShadow: 'none !important'
      },
      '&:disabled': {
        cursor: 'unset !important',
        backgroundColor: color.tertiary300 + " !important",
        color: color.tertiary500 + " !important"
      }
    },
    warning: {
      backgroundColor: 'warning500',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: 'warning600',
        boxShadow: 'none !important'
      },
      '&:focus': {
        boxShadow: "inset 0px 0px 0px 2px " + color.warning400 + " !important"
      },
      '&:active': {
        backgroundColor: color.warning700 + " !important",
        border: 'none',
        boxShadow: 'none !important'
      },
      '&:disabled': {
        cursor: 'unset !important',
        backgroundColor: color.tertiary300 + " !important",
        color: color.tertiary500 + " !important"
      }
    },
    info: {
      backgroundColor: 'info500',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: 'info600',
        boxShadow: 'none !important'
      },
      '&:focus': {
        boxShadow: "inset 0px 0px 0px 2px " + color.info400 + " !important"
      },
      '&:active': {
        backgroundColor: color.info700 + " !important",
        border: 'none',
        boxShadow: 'none !important'
      },
      '&:disabled': {
        cursor: 'unset !important',
        backgroundColor: color.tertiary300 + " !important",
        color: color.tertiary500 + " !important"
      }
    },
    error: {
      backgroundColor: 'error500',
      color: '#ffffff',
      '&:hover': {
        backgroundColor: 'error600',
        boxShadow: 'none !important'
      },
      '&:focus': {
        boxShadow: "inset 0px 0px 0px 2px " + color.error400 + " !important"
      },
      '&:active': {
        backgroundColor: color.error700 + " !important",
        border: 'none',
        boxShadow: 'none !important'
      },
      '&:disabled': {
        cursor: 'unset !important',
        backgroundColor: color.tertiary300 + " !important",
        color: color.tertiary500 + " !important"
      }
    }
  }),
  outline: /*#__PURE__*/_extends({}, button, {
    fontFamily: 'Nunito Sans, sans-serif',
    '& .wrapper-icon-left-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '& .wrapper-icon-both-children': {
      marginLeft: '10px',
      marginRight: '10px'
    },
    '& .wrapper-icon-left-children': {
      marginLeft: '10px'
    },
    '& .wrapper-icon-right-children': {
      marginRight: '10px'
    },
    '& .wrapper-two-icon': {
      marginRight: '10px'
    },
    '& .wrapperIconLeft': {
      marginRight: 10
    },
    '& .wrapperIconRight': {
      marginLeft: 10
    },
    '& .wrapper-icon-right-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    primary: {
      backgroundColor: 'primary50',
      border: "2px solid " + color.primary500,
      color: 'primary500',
      '&:hover': {
        backgroundColor: 'primary100',
        border: 'primary600',
        color: 'primary600',
        boxShadow: 'none !important'
      },
      '&:active': {
        backgroundColor: color.primary200,
        border: "2px solid " + color.primary700,
        color: color.primary700,
        boxShadow: 'none !important'
      },
      '&:focus': {
        backgroundColor: 'primary100',
        boxShadow: "0px 0px 0px 2px " + color.primary400
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: color.tertiary200 + " !important",
        border: "none",
        color: color.tertiary500 + " !important"
      }
    },
    secondary: {
      backgroundColor: 'secondary50',
      border: "2px solid " + color.secondary500,
      color: 'secondary500',
      '&:hover': {
        backgroundColor: 'secondary100',
        border: 'secondary600',
        color: 'secondary600',
        boxShadow: 'none !important'
      },
      '&:active': {
        backgroundColor: color.secondary200,
        border: "2px solid " + color.secondary700,
        color: color.secondary700,
        boxShadow: 'none !important'
      },
      '&:focus': {
        backgroundColor: 'secondary100',
        boxShadow: "0px 0px 0px 2px " + color.secondary400
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: color.tertiary200 + " !important",
        border: "none",
        color: color.tertiary500 + " !important"
      }
    },
    tertiary: {
      backgroundColor: 'tertiary50',
      border: "2px solid " + color.tertiary500,
      color: 'tertiary500',
      '&:hover': {
        backgroundColor: 'tertiary100',
        border: 'tertiary600',
        color: 'tertiary600',
        boxShadow: 'none !important'
      },
      '&:active': {
        backgroundColor: color.tertiary200,
        border: "2px solid " + color.tertiary700,
        color: color.tertiary700,
        boxShadow: 'none !important'
      },
      '&:focus': {
        backgroundColor: 'tertiary100',
        boxShadow: "0px 0px 0px 2px " + color.tertiary400
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: color.tertiary200 + " !important",
        border: "none",
        color: color.tertiary500 + " !important"
      }
    },
    success: {
      backgroundColor: 'success50',
      border: "2px solid " + color.success500,
      color: 'success500',
      '&:hover': {
        backgroundColor: 'success100',
        border: 'success600',
        color: 'success600',
        boxShadow: 'none !important'
      },
      '&:active': {
        backgroundColor: color.success200,
        border: "2px solid " + color.success700,
        color: color.success700,
        boxShadow: 'none !important'
      },
      '&:focus': {
        backgroundColor: 'success100',
        boxShadow: "0px 0px 0px 2px " + color.success400
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: color.tertiary200 + " !important",
        border: "none",
        color: color.tertiary500 + " !important"
      }
    },
    warning: {
      backgroundColor: 'warning50',
      border: "2px solid " + color.warning500,
      color: 'warning500',
      '&:hover': {
        backgroundColor: 'warning100',
        border: 'warning600',
        color: 'warning600',
        boxShadow: 'none !important'
      },
      '&:active': {
        backgroundColor: color.warning200,
        border: "2px solid " + color.warning700,
        color: color.warning700,
        boxShadow: 'none !important'
      },
      '&:focus': {
        backgroundColor: 'warning100',
        boxShadow: "0px 0px 0px 2px " + color.warning400
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: color.tertiary200 + " !important",
        border: "none",
        color: color.tertiary500 + " !important"
      }
    },
    info: {
      backgroundColor: 'info50',
      border: "2px solid " + color.info500,
      color: 'info500',
      '&:hover': {
        backgroundColor: 'info100',
        border: 'info600',
        color: 'info600',
        boxShadow: 'none !important'
      },
      '&:active': {
        backgroundColor: color.info200,
        border: "2px solid " + color.info700,
        color: color.info700,
        boxShadow: 'none !important'
      },
      '&:focus': {
        backgroundColor: 'info100',
        boxShadow: "0px 0px 0px 2px " + color.info400
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: color.tertiary200 + " !important",
        border: "none",
        color: color.tertiary500 + " !important"
      }
    },
    error: {
      backgroundColor: 'error50',
      border: "2px solid " + color.error500,
      color: 'error500',
      '&:hover': {
        backgroundColor: 'error100',
        border: 'error600',
        color: 'error600',
        boxShadow: 'none !important'
      },
      '&:active': {
        backgroundColor: color.error200,
        border: "2px solid " + color.error700,
        color: color.error700,
        boxShadow: 'none !important'
      },
      '&:focus': {
        backgroundColor: 'error100',
        boxShadow: "0px 0px 0px 2px " + color.error400
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: color.tertiary200 + " !important",
        border: "none",
        color: color.tertiary500 + " !important"
      }
    }
  }),
  soft: /*#__PURE__*/_extends({}, button, {
    fontFamily: 'Nunito Sans, sans-serif',
    '& .wrapper-icon-left-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '& .wrapper-icon-both-children': {
      marginLeft: '10px',
      marginRight: '10px'
    },
    '& .wrapper-icon-left-children': {
      marginLeft: '10px'
    },
    '& .wrapper-icon-right-children': {
      marginRight: '10px'
    },
    '& .wrapper-two-icon': {
      marginRight: '10px'
    },
    '& .wrapperIconLeft': {
      marginRight: 10
    },
    '& .wrapperIconRight': {
      marginLeft: 10
    },
    '& .wrapper-icon-right-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    primary: {
      backgroundColor: 'primary50',
      color: 'primary500',
      '&:hover': {
        backgroundColor: 'primary200',
        boxShadow: 'none',
        color: 'primary600'
      },
      '&:focus': {
        backgroundColor: color.primary50,
        boxShadow: "inset 0px 0px 0px 2px " + color.primary400 + " !important",
        color: color.primary500
      },
      '&:active': {
        backgroundColor: color.primary300,
        border: 'none',
        boxShadow: 'none !important',
        color: color.primary700
      },
      '&:disabled': {
        appearance: 'none',
        backgroundColor: color.tertiary200,
        border: 'none',
        color: color.tertiary500,
        cursor: 'unset'
      }
    },
    secondary: {
      backgroundColor: 'secondary50',
      color: 'secondary500',
      '&:hover': {
        backgroundColor: 'secondary200',
        boxShadow: 'none',
        color: 'secondary600'
      },
      '&:focus': {
        backgroundColor: color.secondary50,
        boxShadow: "inset 0px 0px 0px 2px " + color.secondary400 + " !important",
        color: color.secondary500
      },
      '&:active': {
        backgroundColor: color.secondary300,
        border: 'none',
        boxShadow: 'none !important',
        color: color.secondary700
      },
      '&:disabled': {
        appearance: 'none',
        backgroundColor: color.tertiary200,
        border: 'none',
        color: color.tertiary500,
        cursor: 'unset'
      }
    },
    tertiary: {
      backgroundColor: 'tertiary50',
      color: 'tertiary500',
      '&:hover': {
        backgroundColor: 'tertiary200',
        boxShadow: 'none',
        color: 'tertiary600'
      },
      '&:focus': {
        backgroundColor: color.tertiary50,
        boxShadow: "inset 0px 0px 0px 2px " + color.tertiary400 + " !important",
        color: color.tertiary500
      },
      '&:active': {
        backgroundColor: color.tertiary300,
        border: 'none',
        boxShadow: 'none !important',
        color: color.tertiary700
      },
      '&:disabled': {
        appearance: 'none',
        backgroundColor: color.tertiary200,
        border: 'none',
        color: color.tertiary500,
        cursor: 'unset'
      }
    },
    success: {
      backgroundColor: 'success50',
      color: 'success500',
      '&:hover': {
        backgroundColor: 'success200',
        boxShadow: 'none',
        color: 'success600'
      },
      '&:focus': {
        backgroundColor: color.success50,
        boxShadow: "inset 0px 0px 0px 2px " + color.success400 + " !important",
        color: color.success500
      },
      '&:active': {
        backgroundColor: color.success300,
        border: 'none',
        boxShadow: 'none !important',
        color: color.success700
      },
      '&:disabled': {
        appearance: 'none',
        backgroundColor: color.tertiary200,
        border: 'none',
        color: color.tertiary500,
        cursor: 'unset'
      }
    },
    warning: {
      backgroundColor: 'warning50',
      color: 'warning500',
      '&:hover': {
        backgroundColor: 'warning200',
        boxShadow: 'none',
        color: 'warning600'
      },
      '&:focus': {
        backgroundColor: color.warning50,
        boxShadow: "inset 0px 0px 0px 2px " + color.warning400 + " !important",
        color: color.warning500
      },
      '&:active': {
        backgroundColor: color.warning300,
        border: 'none',
        boxShadow: 'none !important',
        color: color.warning700
      },
      '&:disabled': {
        appearance: 'none',
        backgroundColor: color.tertiary200,
        border: 'none',
        color: color.tertiary500,
        cursor: 'unset'
      }
    },
    info: {
      backgroundColor: 'info50',
      color: 'info500',
      '&:hover': {
        backgroundColor: 'info200',
        boxShadow: 'none',
        color: 'info600'
      },
      '&:focus': {
        backgroundColor: color.info50,
        boxShadow: "inset 0px 0px 0px 2px " + color.info400 + " !important",
        color: color.info500
      },
      '&:active': {
        backgroundColor: color.info300,
        border: 'none',
        boxShadow: 'none !important',
        color: color.info700
      },
      '&:disabled': {
        appearance: 'none',
        backgroundColor: color.tertiary200,
        border: 'none',
        color: color.tertiary500,
        cursor: 'unset'
      }
    },
    error: {
      backgroundColor: 'error50',
      color: 'error500',
      '&:hover': {
        backgroundColor: 'error200',
        boxShadow: 'none',
        color: 'error600'
      },
      '&:focus': {
        backgroundColor: color.error50,
        boxShadow: "inset 0px 0px 0px 2px " + color.error400 + " !important",
        color: color.error500
      },
      '&:active': {
        backgroundColor: color.error300,
        border: 'none',
        boxShadow: 'none !important',
        color: color.error700
      },
      '&:disabled': {
        appearance: 'none',
        backgroundColor: color.tertiary200,
        border: 'none',
        color: color.tertiary500,
        cursor: 'unset'
      }
    }
  }),
  transparent: /*#__PURE__*/_extends({}, button, {
    fontFamily: 'Nunito Sans, sans-serif',
    '& .wrapper-icon-left-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '& .wrapper-icon-both-children': {
      marginLeft: '10px',
      marginRight: '10px'
    },
    '& .wrapper-icon-left-children': {
      marginLeft: '10px'
    },
    '& .wrapper-icon-right-children': {
      marginRight: '10px'
    },
    '& .wrapper-two-icon': {
      marginRight: '10px'
    },
    '& .wrapperIconLeft': {
      marginRight: 10
    },
    '& .wrapperIconRight': {
      marginLeft: 10
    },
    '& .wrapper-icon-right-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    primary: {
      backgroundColor: 'transparent',
      color: 'primary500',
      '&:hover': {
        backgroundColor: 'primary100',
        color: 'primary600',
        boxShadow: 'none'
      },
      '&:focus': {
        backgroundColor: color.primary25,
        boxShadow: "inset 0px 0px 0px 2px " + color.primary400 + " !important",
        color: color.primary500
      },
      '&:active': {
        backgroundColor: color.primary100,
        border: 'none',
        color: color.primary700,
        boxShadow: 'none'
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        color: color.tertiary400
      }
    },
    secondary: {
      backgroundColor: 'transparent',
      color: 'secondary500',
      '&:hover': {
        backgroundColor: 'secondary100',
        color: 'secondary600',
        boxShadow: 'none'
      },
      '&:focus': {
        backgroundColor: color.secondary25,
        boxShadow: "inset 0px 0px 0px 2px " + color.secondary400 + " !important",
        color: color.secondary500
      },
      '&:active': {
        backgroundColor: color.secondary100,
        border: 'none',
        color: color.secondary700,
        boxShadow: 'none'
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        color: color.tertiary400
      }
    },
    tertiary: {
      backgroundColor: 'transparent',
      color: 'tertiary500',
      '&:hover': {
        backgroundColor: 'tertiary100',
        color: 'tertiary600',
        boxShadow: 'none'
      },
      '&:focus': {
        backgroundColor: color.tertiary25,
        boxShadow: "inset 0px 0px 0px 2px " + color.tertiary400 + " !important",
        color: color.tertiary500
      },
      '&:active': {
        backgroundColor: color.tertiary100,
        border: 'none',
        color: color.tertiary700,
        boxShadow: 'none'
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        color: color.tertiary400
      }
    },
    success: {
      backgroundColor: 'transparent',
      color: 'success500',
      '&:hover': {
        backgroundColor: 'success100',
        color: 'success600',
        boxShadow: 'none'
      },
      '&:focus': {
        backgroundColor: color.success25,
        boxShadow: "inset 0px 0px 0px 2px " + color.success400 + " !important",
        color: color.success500
      },
      '&:active': {
        backgroundColor: color.success100,
        border: 'none',
        color: color.success700,
        boxShadow: 'none'
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        color: color.tertiary400
      }
    },
    warning: {
      backgroundColor: 'transparent',
      color: 'warning500',
      '&:hover': {
        backgroundColor: 'warning100',
        color: 'warning600',
        boxShadow: 'none'
      },
      '&:focus': {
        backgroundColor: color.warning25,
        boxShadow: "inset 0px 0px 0px 2px " + color.warning400 + " !important",
        color: color.warning500
      },
      '&:active': {
        backgroundColor: color.warning100,
        border: 'none',
        color: color.warning700,
        boxShadow: 'none'
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        color: color.tertiary400
      }
    },
    info: {
      backgroundColor: 'transparent',
      color: 'info500',
      '&:hover': {
        backgroundColor: 'info100',
        color: 'info600',
        boxShadow: 'none'
      },
      '&:focus': {
        backgroundColor: color.info25,
        boxShadow: "inset 0px 0px 0px 2px " + color.info400 + " !important",
        color: color.info500
      },
      '&:active': {
        backgroundColor: color.info100,
        border: 'none',
        color: color.info700,
        boxShadow: 'none'
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        color: color.tertiary400
      }
    },
    error: {
      backgroundColor: 'transparent',
      color: 'error500',
      '&:hover': {
        backgroundColor: 'error100',
        color: 'error600',
        boxShadow: 'none'
      },
      '&:focus': {
        backgroundColor: color.error25,
        boxShadow: "inset 0px 0px 0px 2px " + color.error400 + " !important",
        color: color.error500
      },
      '&:active': {
        backgroundColor: color.error100,
        border: 'none',
        color: color.error700,
        boxShadow: 'none'
      },
      '&:disabled': {
        cursor: 'unset',
        appearance: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        color: color.tertiary400
      }
    }
  }),
  outlineSecondary: /*#__PURE__*/_extends({}, button, {
    backgroundColor: 'tertiary25',
    border: "1px solid " + color.tertiary500,
    color: 'tertiary800',
    fontFamily: 'Nunito Sans, sans-serif',
    '& .wrapper-icon-left-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '& .wrapper-icon-both-children': {
      marginLeft: '10px',
      marginRight: '10px'
    },
    '& .wrapper-icon-left-children': {
      marginLeft: '10px'
    },
    '& .wrapper-icon-right-children': {
      marginRight: '10px'
    },
    '& .wrapper-two-icon': {
      marginRight: '10px'
    },
    '& .wrapperIconLeft': {
      marginRight: 10
    },
    '& .wrapperIconRight': {
      marginLeft: 10
    },
    '& .wrapper-icon-right-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '&:hover': {
      backgroundColor: '#F6F7FC !important',
      border: "1px solid " + color.tertiary800 + " !important",
      color: color.tertiary800 + " !important",
      boxShadow: 'none !important'
    },
    '&:focus': {
      backgroundColor: color.tertiary25 + " !important",
      border: "1px solid " + color.tertiary500,
      boxShadow: "0px 0px 0px 2px " + color.secondary400,
      color: color.tertiary800
    },
    '&:active': {
      backgroundColor: '#EEF0F7 !important',
      color: color.tertiary25 + " !important",
      boxShadow: 'none !important'
    },
    '&:disabled': {
      cursor: 'unset',
      appearance: 'none',
      backgroundColor: color.tertiary25 + " !important",
      border: "1px solid " + color.tertiary500 + " !important",
      color: color.tertiary500 + " !important"
    }
  }),
  softSecondary: /*#__PURE__*/_extends({}, button, {
    backgroundColor: '#F6F7FC',
    color: 'tertiary800',
    fontFamily: 'Nunito Sans, sans-serif',
    '& .wrapper-icon-left-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '& .wrapper-icon-both-children': {
      marginLeft: '10px',
      marginRight: '10px'
    },
    '& .wrapper-icon-left-children': {
      marginLeft: '10px'
    },
    '& .wrapper-icon-right-children': {
      marginRight: '10px'
    },
    '& .wrapper-two-icon': {
      marginRight: '10px'
    },
    '& .wrapperIconLeft': {
      marginRight: 10
    },
    '& .wrapperIconRight': {
      marginLeft: 10
    },
    '& .wrapper-icon-right-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center'
    },
    '& .wrapper-icon-right-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center'
    },
    '&:hover': {
      backgroundColor: '#EEF0F7',
      color: 'tertiary800',
      boxShadow: 'none !important'
    },
    '&:focus': {
      backgroundColor: color.tertiary25,
      color: color.tertiary800,
      boxShadow: "0px 0px 0px 2px " + color.secondary400
    },
    '&:active': {
      backgroundColor: '#E5E6EF !important',
      color: color.tertiary25 + " !important",
      boxShadow: 'none !important'
    },
    '&:disabled': {
      appearance: 'none',
      cursor: 'context-menu',
      backgroundColor: color.tertiary200 + " !important",
      color: color.tertiary500 + " !important",
      border: 'none !important'
    }
  })
};
var styles = {
  a: {
    color: color.primary500,
    disabled: {
      color: color.tertiary300,
      pointerEvents: 'none'
    },
    '&:hover': {
      color: "" + color.primary600,
      textDecoration: 'underline',
      outline: 'none',
      cursor: 'pointer'
    },
    '&:active': {
      color: color.primary700 + " !important",
      outline: 'none !important',
      textDecoration: 'underline !important'
    },
    '&:focus': {
      outline: "2px solid " + color.primary300 + " !important",
      borderRadius: '4px !important',
      textDecoration: 'none !important'
    },
    '& .wrapper-anchor': {
      display: 'flex',
      alignItems: 'center'
    },
    '& .wrapper-icon-left-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center',
      marginRight: '5px'
    },
    '& .wrapper-icon-left-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center',
      marginRight: '5px'
    },
    '& .wrapper-icon-left-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center',
      marginRight: '5px'
    },
    '& .wrapper-icon-right-large': {
      display: 'flex',
      width: '20px',
      height: '20px',
      alignItems: 'center',
      marginLeft: '5px'
    },
    '& .wrapper-icon-right-medium': {
      display: 'flex',
      width: '16px',
      height: '16px',
      alignItems: 'center',
      marginLeft: '5px'
    },
    '& .wrapper-icon-right-small': {
      display: 'flex',
      width: '12px',
      height: '12px',
      alignItems: 'center',
      marginLeft: '5px'
    },
    sm: {
      color: color.primary500 + " !important",
      fontSize: '14px',
      lineHeight: '21px',
      fontWeight: '700',
      textDecoration: 'none',
      display: 'inline-flex',
      alignItems: 'center'
    },
    md: {
      color: color.primary500,
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '700',
      textDecoration: 'none',
      display: 'inline-flex',
      alignItems: 'center'
    },
    lg: {
      color: color.primary500,
      fontSize: '18px',
      lineHeight: '28px',
      fontWeight: '700',
      textDecoration: 'none',
      display: 'inline-flex',
      alignItems: 'center'
    }
  },
  background: {
    primary25: {
      background: "" + color.primary25
    },
    primary50: {
      background: "" + color.primary50
    },
    primary100: {
      background: "" + color.primary100
    },
    primary200: {
      background: "" + color.primary200
    },
    primary300: {
      background: "" + color.primary300
    },
    primary400: {
      background: "" + color.primary400
    },
    primary500: {
      background: "" + color.primary500
    },
    primary600: {
      background: "" + color.primary600
    },
    primary700: {
      background: "" + color.primary700
    },
    primary800: {
      background: "" + color.primary800
    },
    primary900: {
      background: "" + color.primary900
    },
    secondary25: {
      background: "" + color.secondary25
    },
    secondary50: {
      background: "" + color.secondary50
    },
    secondary100: {
      background: "" + color.secondary100
    },
    secondary200: {
      background: "" + color.secondary200
    },
    secondary300: {
      background: "" + color.secondary300
    },
    secondary400: {
      background: "" + color.secondary400
    },
    secondary500: {
      background: "" + color.secondary500
    },
    secondary600: {
      background: "" + color.secondary600
    },
    secondary700: {
      background: "" + color.secondary700
    },
    secondary800: {
      background: "" + color.secondary800
    },
    secondary900: {
      background: "" + color.secondary900
    },
    tertiary25: {
      background: "" + color.tertiary25
    },
    tertiary50: {
      background: "" + color.tertiary50
    },
    tertiary100: {
      background: "" + color.tertiary100
    },
    tertiary200: {
      background: "" + color.tertiary200
    },
    tertiary300: {
      background: "" + color.tertiary300
    },
    tertiary400: {
      background: "" + color.tertiary400
    },
    tertiary500: {
      background: "" + color.tertiary500
    },
    tertiary600: {
      background: "" + color.tertiary600
    },
    tertiary700: {
      background: "" + color.tertiary700
    },
    tertiary800: {
      background: "" + color.tertiary800
    },
    tertiary900: {
      background: "" + color.tertiary900
    },
    success25: {
      background: "" + color.success25
    },
    success50: {
      background: "" + color.success50
    },
    success100: {
      background: "" + color.success100
    },
    success200: {
      background: "" + color.success200
    },
    success300: {
      background: "" + color.success300
    },
    success400: {
      background: "" + color.success400
    },
    success500: {
      background: "" + color.success500
    },
    success600: {
      background: "" + color.success600
    },
    success700: {
      background: "" + color.success700
    },
    success800: {
      background: "" + color.success800
    },
    success900: {
      background: "" + color.success900
    },
    warning25: {
      background: "" + color.warning25
    },
    warning50: {
      background: "" + color.warning50
    },
    warning100: {
      background: "" + color.warning100
    },
    warning200: {
      background: "" + color.warning200
    },
    warning300: {
      background: "" + color.warning300
    },
    warning400: {
      background: "" + color.warning400
    },
    warning500: {
      background: "" + color.warning500
    },
    warning600: {
      background: "" + color.warning600
    },
    warning700: {
      background: "" + color.warning700
    },
    warning800: {
      background: "" + color.warning800
    },
    warning900: {
      background: "" + color.warning900
    },
    error25: {
      background: "" + color.error25
    },
    error50: {
      background: "" + color.error50
    },
    error100: {
      background: "" + color.error100
    },
    error200: {
      background: "" + color.error200
    },
    error300: {
      background: "" + color.error300
    },
    error400: {
      background: "" + color.error400
    },
    error500: {
      background: "" + color.error500
    },
    error600: {
      background: "" + color.error600
    },
    error700: {
      background: "" + color.error700
    },
    error800: {
      background: "" + color.error800
    },
    error900: {
      background: "" + color.error900
    },
    info25: {
      background: "" + color.info25
    },
    info50: {
      background: "" + color.info50
    },
    info100: {
      background: "" + color.info100
    },
    info200: {
      background: "" + color.info200
    },
    info300: {
      background: "" + color.info300
    },
    info400: {
      background: "" + color.info400
    },
    info500: {
      background: "" + color.info500
    },
    info600: {
      background: "" + color.info600
    },
    info700: {
      background: "" + color.info700
    },
    info800: {
      background: "" + color.info800
    },
    info900: {
      background: "" + color.info900
    }
  },
  text: {
    primary25: {
      color: "" + color.primary25
    },
    primary50: {
      color: "" + color.primary50
    },
    primary100: {
      color: "" + color.primary100
    },
    primary200: {
      color: "" + color.primary200
    },
    primary300: {
      color: "" + color.primary300
    },
    primary400: {
      color: "" + color.primary400
    },
    primary500: {
      color: "" + color.primary500
    },
    primary600: {
      color: "" + color.primary600
    },
    primary700: {
      color: "" + color.primary700
    },
    primary800: {
      color: "" + color.primary800
    },
    primary900: {
      color: "" + color.primary900
    },
    secondary25: {
      color: "" + color.secondary25
    },
    secondary50: {
      color: "" + color.secondary50
    },
    secondary100: {
      color: "" + color.secondary100
    },
    secondary200: {
      color: "" + color.secondary200
    },
    secondary300: {
      color: "" + color.secondary300
    },
    secondary400: {
      color: "" + color.secondary400
    },
    secondary500: {
      color: "" + color.secondary500
    },
    secondary600: {
      color: "" + color.secondary600
    },
    secondary700: {
      color: "" + color.secondary700
    },
    secondary800: {
      color: "" + color.secondary800
    },
    secondary900: {
      color: "" + color.secondary900
    },
    tertiary25: {
      color: "" + color.tertiary25
    },
    tertiary50: {
      color: "" + color.tertiary50
    },
    tertiary100: {
      color: "" + color.tertiary100
    },
    tertiary200: {
      color: "" + color.tertiary200
    },
    tertiary300: {
      color: "" + color.tertiary300
    },
    tertiary400: {
      color: "" + color.tertiary400
    },
    tertiary500: {
      color: "" + color.tertiary500
    },
    tertiary600: {
      color: "" + color.tertiary600
    },
    tertiary700: {
      color: "" + color.tertiary700
    },
    tertiary800: {
      color: "" + color.tertiary800
    },
    tertiary900: {
      color: "" + color.tertiary900
    },
    success25: {
      color: "" + color.success25
    },
    success50: {
      color: "" + color.success50
    },
    success100: {
      color: "" + color.success100
    },
    success200: {
      color: "" + color.success200
    },
    success300: {
      color: "" + color.success300
    },
    success400: {
      color: "" + color.success400
    },
    success500: {
      color: "" + color.success500
    },
    success600: {
      color: "" + color.success600
    },
    success700: {
      color: "" + color.success700
    },
    success800: {
      color: "" + color.success800
    },
    success900: {
      color: "" + color.success900
    },
    warning25: {
      color: "" + color.warning25
    },
    warning50: {
      color: "" + color.warning50
    },
    warning100: {
      color: "" + color.warning100
    },
    warning200: {
      color: "" + color.warning200
    },
    warning300: {
      color: "" + color.warning300
    },
    warning400: {
      color: "" + color.warning400
    },
    warning500: {
      color: "" + color.warning500
    },
    warning600: {
      color: "" + color.warning600
    },
    warning700: {
      color: "" + color.warning700
    },
    warning800: {
      color: "" + color.warning800
    },
    warning900: {
      color: "" + color.warning900
    },
    error25: {
      color: "" + color.error25
    },
    error50: {
      color: "" + color.error50
    },
    error100: {
      color: "" + color.error100
    },
    error200: {
      color: "" + color.error200
    },
    error300: {
      color: "" + color.error300
    },
    error400: {
      color: "" + color.error400
    },
    error500: {
      color: "" + color.error500
    },
    error600: {
      color: "" + color.error600
    },
    error700: {
      color: "" + color.error700
    },
    error800: {
      color: "" + color.error800
    },
    error900: {
      color: "" + color.error900
    },
    info25: {
      color: "" + color.info25
    },
    info50: {
      color: "" + color.info50
    },
    info100: {
      color: "" + color.info100
    },
    info200: {
      color: "" + color.info200
    },
    info300: {
      color: "" + color.info300
    },
    info400: {
      color: "" + color.info400
    },
    info500: {
      color: "" + color.info500
    },
    info600: {
      color: "" + color.info600
    },
    info700: {
      color: "" + color.info700
    },
    info800: {
      color: "" + color.info800
    },
    info900: {
      color: "" + color.info900
    }
  },
  elevation: {
    elevation0: {
      boxShadow: '0px 0px 0px 2px #ebf0ff'
    },
    elevation1: {
      boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)'
    },
    elevation2: {
      boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 1px rgba(0, 0, 0, 0.25)'
    },
    elevation3: {
      boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.2)'
    },
    elevation4: {
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15), 0px 0px 3px rgba(0, 0, 0, 0.1)'
    },
    elevation5: {
      boxShadow: '0px 8px 40px rgba(0, 0, 0, 0.2), 0px 0px 4px rgba(0, 0, 0, 0.1)'
    }
  }
};
var cards = {
  base: {
    borderRadius: radius.radius4,
    overflow: 'inherit',
    transition: 'box-shadow 0.15s ease-in-out 0s, transform 0.15s ease-in-out 0s'
  },
  flat: {
    backgroundColor: color.tertiary50
  },
  bordered: {
    backgroundColor: '#FFF',
    border: "1px solid " + color.tertiary200
  },
  shadow: /*#__PURE__*/_extends({
    backgroundColor: '#FFF'
  }, styles.elevation.elevation5),
  hoverable: {
    '&:hover': /*#__PURE__*/_extends({
      transform: 'translateY(-2px)'
    }, styles.elevation.elevation5)
  },
  pressable: {
    cursor: 'pointer',
    '&:active': {
      transform: 'scale(97%)'
    }
  },
  header: {
    padding: spacer.spacing4 + " " + spacer.spacing4 + " 0"
  },
  body: {
    padding: spacer.spacing4
  },
  footer: {
    padding: "0 " + spacer.spacing4 + " " + spacer.spacing4
  }
};
var carousel = {
  primary50: {
    backgroundColor: color.primary50
  },
  primary500: {
    backgroundColor: color.primary500
  },
  tertiary100: {
    backgroundColor: color.tertiary100
  },
  imageTitle: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontWeight: 700,
    color: color.tertiary800
  },
  imageDesc: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontWeight: 400,
    color: color.tertiary500
  }
};

/* eslint-disable max-lines */
var colorscard = {
  containerColors: {
    marginBottom: '20px'
  },
  wrappValueColors: {
    fontSize: '12px',
    fontWeight: '500',
    padding: '10px'
  },
  // Colors Primary
  primary25: {
    backgroundColor: "" + color.primary25,
    color: "" + color.primary900,
    padding: '1rem',
    width: '100%'
  },
  primary50: {
    backgroundColor: "" + color.primary50,
    color: "" + color.primary900,
    padding: '1rem',
    width: '100%'
  },
  primary100: {
    backgroundColor: "" + color.primary100,
    color: "" + color.primary900,
    padding: '1rem',
    width: '100%'
  },
  primary200: {
    backgroundColor: "" + color.primary200,
    color: "" + color.primary900,
    padding: '1rem',
    width: '100%'
  },
  primary300: {
    backgroundColor: "" + color.primary300,
    color: "" + color.primary900,
    padding: '1rem',
    width: '100%'
  },
  primary400: {
    backgroundColor: "" + color.primary400,
    color: "" + color.primary25,
    padding: '1rem',
    width: '100%'
  },
  primary500: {
    backgroundColor: "" + color.primary500,
    color: "" + color.primary25,
    padding: '1rem',
    width: '100%'
  },
  primary600: {
    backgroundColor: "" + color.primary600,
    color: "" + color.primary25,
    padding: '1rem',
    width: '100%'
  },
  primary700: {
    backgroundColor: "" + color.primary700,
    color: "" + color.primary25,
    padding: '1rem',
    width: '100%'
  },
  primary800: {
    backgroundColor: "" + color.primary800,
    color: "" + color.primary25,
    padding: '1rem',
    width: '100%'
  },
  primary900: {
    backgroundColor: "" + color.primary900,
    color: "" + color.primary25,
    padding: '1rem',
    width: '100%'
  },
  // Colors Secondary
  secondary25: {
    backgroundColor: "" + color.secondary25,
    color: "" + color.secondary900,
    padding: '1rem',
    width: '100%'
  },
  secondary50: {
    backgroundColor: "" + color.secondary50,
    color: "" + color.secondary900,
    padding: '1rem',
    width: '100%'
  },
  secondary100: {
    backgroundColor: "" + color.secondary100,
    color: "" + color.secondary900,
    padding: '1rem',
    width: '100%'
  },
  secondary200: {
    backgroundColor: "" + color.secondary200,
    color: "" + color.secondary900,
    padding: '1rem',
    width: '100%'
  },
  secondary300: {
    backgroundColor: "" + color.secondary300,
    color: "" + color.secondary900,
    padding: '1rem',
    width: '100%'
  },
  secondary400: {
    backgroundColor: "" + color.secondary400,
    color: "" + color.secondary25,
    padding: '1rem',
    width: '100%'
  },
  secondary500: {
    backgroundColor: "" + color.secondary500,
    color: "" + color.secondary25,
    padding: '1rem',
    width: '100%'
  },
  secondary600: {
    backgroundColor: "" + color.secondary600,
    color: "" + color.secondary25,
    padding: '1rem',
    width: '100%'
  },
  secondary700: {
    backgroundColor: "" + color.secondary700,
    color: "" + color.secondary25,
    padding: '1rem',
    width: '100%'
  },
  secondary800: {
    backgroundColor: "" + color.secondary800,
    color: "" + color.secondary25,
    padding: '1rem',
    width: '100%'
  },
  secondary900: {
    backgroundColor: "" + color.secondary900,
    color: "" + color.secondary25,
    padding: '1rem',
    width: '100%'
  },
  // Colors Tertiary
  tertiary25: {
    backgroundColor: "" + color.tertiary25,
    color: "" + color.tertiary900,
    padding: '1rem',
    width: '100%'
  },
  tertiary50: {
    backgroundColor: "" + color.tertiary50,
    color: "" + color.tertiary900,
    padding: '1rem',
    width: '100%'
  },
  tertiary100: {
    backgroundColor: "" + color.tertiary100,
    color: "" + color.tertiary900,
    padding: '1rem',
    width: '100%'
  },
  tertiary200: {
    backgroundColor: "" + color.tertiary200,
    color: "" + color.tertiary900,
    padding: '1rem',
    width: '100%'
  },
  tertiary300: {
    backgroundColor: "" + color.tertiary300,
    color: "" + color.tertiary900,
    padding: '1rem',
    width: '100%'
  },
  tertiary400: {
    backgroundColor: "" + color.tertiary400,
    color: "" + color.tertiary25,
    padding: '1rem',
    width: '100%'
  },
  tertiary500: {
    backgroundColor: "" + color.tertiary500,
    color: "" + color.tertiary25,
    padding: '1rem',
    width: '100%'
  },
  tertiary600: {
    backgroundColor: "" + color.tertiary600,
    color: "" + color.tertiary25,
    padding: '1rem',
    width: '100%'
  },
  tertiary700: {
    backgroundColor: "" + color.tertiary700,
    color: "" + color.tertiary25,
    padding: '1rem',
    width: '100%'
  },
  tertiary800: {
    backgroundColor: "" + color.tertiary800,
    color: "" + color.tertiary25,
    padding: '1rem',
    width: '100%'
  },
  tertiary900: {
    backgroundColor: "" + color.tertiary900,
    color: "" + color.tertiary25,
    padding: '1rem',
    width: '100%'
  },
  // Colors Success
  success25: {
    backgroundColor: "" + color.success25,
    color: "" + color.success900,
    padding: '1rem',
    width: '100%'
  },
  success50: {
    backgroundColor: "" + color.success50,
    color: "" + color.success900,
    padding: '1rem',
    width: '100%'
  },
  success100: {
    backgroundColor: "" + color.success100,
    color: "" + color.success900,
    padding: '1rem',
    width: '100%'
  },
  success200: {
    backgroundColor: "" + color.success200,
    color: "" + color.success900,
    padding: '1rem',
    width: '100%'
  },
  success300: {
    backgroundColor: "" + color.success300,
    color: "" + color.success900,
    padding: '1rem',
    width: '100%'
  },
  success400: {
    backgroundColor: "" + color.success400,
    color: "" + color.success25,
    padding: '1rem',
    width: '100%'
  },
  success500: {
    backgroundColor: "" + color.success500,
    color: "" + color.success25,
    padding: '1rem',
    width: '100%'
  },
  success600: {
    backgroundColor: "" + color.success600,
    color: "" + color.success25,
    padding: '1rem',
    width: '100%'
  },
  success700: {
    backgroundColor: "" + color.success700,
    color: "" + color.success25,
    padding: '1rem',
    width: '100%'
  },
  success800: {
    backgroundColor: "" + color.success800,
    color: "" + color.success25,
    padding: '1rem',
    width: '100%'
  },
  success900: {
    backgroundColor: "" + color.success900,
    color: "" + color.success25,
    padding: '1rem',
    width: '100%'
  },
  // Colors Warning
  warning25: {
    backgroundColor: "" + color.warning25,
    color: "" + color.warning900,
    padding: '1rem',
    width: '100%'
  },
  warning50: {
    backgroundColor: "" + color.warning50,
    color: "" + color.warning900,
    padding: '1rem',
    width: '100%'
  },
  warning100: {
    backgroundColor: "" + color.warning100,
    color: "" + color.warning900,
    padding: '1rem',
    width: '100%'
  },
  warning200: {
    backgroundColor: "" + color.warning200,
    color: "" + color.warning900,
    padding: '1rem',
    width: '100%'
  },
  warning300: {
    backgroundColor: "" + color.warning300,
    color: "" + color.warning900,
    padding: '1rem',
    width: '100%'
  },
  warning400: {
    backgroundColor: "" + color.warning400,
    color: "" + color.warning25,
    padding: '1rem',
    width: '100%'
  },
  warning500: {
    backgroundColor: "" + color.warning500,
    color: "" + color.warning25,
    padding: '1rem',
    width: '100%'
  },
  warning600: {
    backgroundColor: "" + color.warning600,
    color: "" + color.warning25,
    padding: '1rem',
    width: '100%'
  },
  warning700: {
    backgroundColor: "" + color.warning700,
    color: "" + color.warning25,
    padding: '1rem',
    width: '100%'
  },
  warning800: {
    backgroundColor: "" + color.warning800,
    color: "" + color.warning25,
    padding: '1rem',
    width: '100%'
  },
  warning900: {
    backgroundColor: "" + color.warning900,
    color: "" + color.warning25,
    padding: '1rem',
    width: '100%'
  },
  // Colors Information
  error25: {
    backgroundColor: "" + color.error25,
    color: "" + color.error900,
    padding: '1rem',
    width: '100%'
  },
  error50: {
    backgroundColor: "" + color.error50,
    color: "" + color.error900,
    padding: '1rem',
    width: '100%'
  },
  error100: {
    backgroundColor: "" + color.error100,
    color: "" + color.error900,
    padding: '1rem',
    width: '100%'
  },
  error200: {
    backgroundColor: "" + color.error200,
    color: "" + color.error900,
    padding: '1rem',
    width: '100%'
  },
  error300: {
    backgroundColor: "" + color.error300,
    color: "" + color.error900,
    padding: '1rem',
    width: '100%'
  },
  error400: {
    backgroundColor: "" + color.error400,
    color: "" + color.error25,
    padding: '1rem',
    width: '100%'
  },
  error500: {
    backgroundColor: "" + color.error500,
    color: "" + color.error25,
    padding: '1rem',
    width: '100%'
  },
  error600: {
    backgroundColor: "" + color.error600,
    color: "" + color.error25,
    padding: '1rem',
    width: '100%'
  },
  error700: {
    backgroundColor: "" + color.error700,
    color: "" + color.error25,
    padding: '1rem',
    width: '100%'
  },
  error800: {
    backgroundColor: "" + color.error800,
    color: "" + color.error25,
    padding: '1rem',
    width: '100%'
  },
  error900: {
    backgroundColor: "" + color.error900,
    color: "" + color.error25,
    padding: '1rem',
    width: '100%'
  },
  // Colors Error
  info25: {
    backgroundColor: "" + color.info25,
    color: "" + color.info900,
    padding: '1rem',
    width: '100%'
  },
  info50: {
    backgroundColor: "" + color.info50,
    color: "" + color.info900,
    padding: '1rem',
    width: '100%'
  },
  info100: {
    backgroundColor: "" + color.info100,
    color: "" + color.info900,
    padding: '1rem',
    width: '100%'
  },
  info200: {
    backgroundColor: "" + color.info200,
    color: "" + color.info900,
    padding: '1rem',
    width: '100%'
  },
  info300: {
    backgroundColor: "" + color.info300,
    color: "" + color.info900,
    padding: '1rem',
    width: '100%'
  },
  info400: {
    backgroundColor: "" + color.info400,
    color: "" + color.info25,
    padding: '1rem',
    width: '100%'
  },
  info500: {
    backgroundColor: "" + color.info500,
    color: "" + color.info25,
    padding: '1rem',
    width: '100%'
  },
  info600: {
    backgroundColor: "" + color.info600,
    color: "" + color.info25,
    padding: '1rem',
    width: '100%'
  },
  info700: {
    backgroundColor: "" + color.info700,
    color: "" + color.info25,
    padding: '1rem',
    width: '100%'
  },
  info800: {
    backgroundColor: "" + color.info800,
    color: "" + color.info25,
    padding: '1rem',
    width: '100%'
  },
  info900: {
    backgroundColor: "" + color.info900,
    color: "" + color.info25,
    padding: '1rem',
    width: '100%'
  }
};
var colors = /*#__PURE__*/_extends({}, color);
var datepicker = {
  wrapper: {
    color: '#1D2939',
    display: 'inline-flex',
    padding: 0,
    margin: 0,
    fontSize: 16,
    lineHeight: '24px'
  },
  rtl: {
    direction: 'rtl'
  },
  focusedInput: {
    outline: 'none',
    border: "1px solid " + color.primary500,
    boxShadow: "0px 0px 0px 2px " + color.primary100
  },
  panel: {
    display: 'inline-block',
    verticalAlign: 'top',
    background: '#ffffff',
    borderRadius: 12
  },
  focusedPanel: {
    borderColor: color.primary500
  },
  panelContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 20
  },
  table: {
    textAlign: 'center',
    borderCollapse: 'collapse'
  },
  header: {
    display: 'flex',
    marginBottom: 16
  },
  headerFlex: {
    flex: 'none'
  },
  headerView: {
    flex: 'auto',
    textAlign: 'center',
    fontSize: 18,
    lineHeight: '28px'
  },
  headerViewButton: {
    padding: 0,
    border: 0
  },
  tableCell: {
    padding: '2px 0',
    color: 'inherit'
  },
  disabledCell: {
    opacity: 0.2
  },
  cellInner: {
    position: 'relative',
    display: 'inline-block',
    boxSizing: 'border-box',
    width: '100%',
    margin: 0,
    padding: 0,
    fontSize: 16,
    lineHeight: '24px',
    background: 'transparent',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    transition: 'background 0.3s, border 0.3s',
    borderRadius: 50,
    zIndex: 2
  },
  cellInnerHover: {
    background: color.tertiary50
  },
  inRangeCell: {
    background: color.primary100,
    borderRadius: 0
  },
  rangeHoverContainer: {
    position: 'relative'
  },
  rangeHoverBorder: {
    position: 'absolute',
    top: 2,
    bottom: 2,
    right: 0,
    left: 0,
    border: "1px dashed " + color.primary300,
    borderRight: 0,
    borderLeft: 0,
    content: '""',
    pointerEvents: 'none',
    zIndex: 3,
    height: 41.57
  },
  rangeHoverStart: {
    borderLeft: "1px dashed " + color.primary300 + " !important",
    borderTopLeftRadius: 50,
    borderBottomLeftRadius: 50
  },
  rangeHoverEnd: {
    borderRight: "1px dashed " + color.primary300 + " !important",
    borderTopRightRadius: 50,
    borderBottomRightRadius: 50
  },
  cellToday: {
    border: "1px solid " + color.primary100,
    borderRadius: '50px',
    color: color.primary500,
    fontWeight: 'bold'
  },
  selectedCell: {
    background: color.primary500,
    color: '#ffffff',
    fontWeight: 'bold'
  },
  presetContainer: {
    background: '#ffffff',
    marginLeft: 20,
    paddingRight: 20,
    paddingTop: 18,
    paddingBottom: 18,
    borderRight: "1px solid " + color.tertiary200
  },
  presetList: {
    margin: 0,
    padding: 0,
    listStyle: 'none'
  },
  presetListItem: {
    padding: '8px 12px',
    listStyle: 'none',
    cursor: 'pointer',
    borderRadius: 4,
    minWidth: 150,
    marginTop: 6,
    marginBottom: 6
  },
  presetListItemHover: {
    backgroundColor: color.primary100,
    color: color.primary500,
    fontWeight: 600
  },
  footer: {
    padding: 8,
    borderTop: "1px solid " + color.tertiary200,
    fontSize: 'inherit',
    lineHeight: 'inherit'
  },
  ranges: {
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    listStyle: 'none'
  },
  rangeListItem: {
    display: 'inline-block'
  },
  pickerOk: {
    "float": 'right'
  },
  widthInnerCell: {
    width: 80,
    padding: '8px 0',
    height: 43.57,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  weekRowHover: {
    background: color.primary100
  },
  weekCellSelected: {
    background: color.primary500
  },
  weekCellContainer: {
    width: 43.57,
    height: 43.57
  },
  weekCell: {
    color: 'inherit',
    fontWeight: 'bold'
  },
  weekCellHover: {
    background: 'transparent'
  },
  cellInnerContainer: {
    width: 43.57,
    height: 43.57,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  timePanelContainer: {
    display: 'flex',
    maxHeight: 310,
    paddingTop: 4
  },
  contentCell: {
    position: 'relative'
  },
  timePanelColumn: {
    flex: 'none',
    width: 50,
    margin: 0,
    padding: '0 0 180px 0',
    overflowX: 'hidden',
    overflowY: 'hidden',
    textAlign: 'left',
    listStyle: 'none',
    transition: 'background 0.3s'
  },
  timePanelColumnActive: {
    background: color.primary500
  },
  timePanelColumnHover: {
    overflowY: 'auto'
  },
  timePanelColumnListItem: {
    margin: 0,
    padding: 0,
    cursor: 'pointer'
  },
  timePanelColumnDisabled: {
    opacity: 0.5
  },
  timePanelCellInner: {
    display: 'block',
    width: '100%',
    height: 24,
    margin: 0,
    padding: '0 0 0 12px',
    color: 'inherit',
    fontSize: 16,
    lineHeight: '24px',
    textAlign: 'left'
  },
  timePanelCellInnerRtl: {
    padding: '0 12px 0 0',
    textAlign: 'right'
  },
  datetimePanel: {
    display: 'flex'
  },
  datetimeTimePanel: {
    borderLeft: "1px solid " + color.tertiary200
  },
  datetimeTimeContainer: {
    transition: 'opacity 0.3s',
    padding: 20
  },
  pickerInput: {
    width: '100%',
    borderRadius: '4px',
    border: "1px solid " + color.tertiary300,
    transition: 'all 0.15s ease-in-out 0s'
  },
  pickerInputPlaceholder: {
    color: color.tertiary400
  },
  pickerDropdown: {
    position: 'absolute',
    boxShadow: "0 0 4px " + color.tertiary400,
    backgroundColor: '#ffffff',
    borderRadius: 12,
    zIndex: 2
  },
  '.legion-picker-dropdown .legion-picker-range-arrow::before': {
    width: 10,
    height: 10,
    border: '5px solid blue',
    borderColor: 'blue blue transparent transparent'
  },
  '.legion-picker-dropdown .legion-picker-range-arrow::after': {
    width: 8,
    height: 8,
    border: '4px solid blue',
    borderColor: '#fff0ff #fff0ff transparent transparent'
  },
  pickerRange: {
    position: 'relative',
    display: 'inline-flex',
    borderRadius: '4px',
    border: "1px solid " + color.tertiary300,
    transition: 'all 0.15s ease-in-out 0s'
  },
  rangePickerFocused: {
    border: "1px solid " + color.primary500,
    boxShadow: "0px 0px 0px 2px " + color.primary100
  },
  rangePickerActiveBar: {
    bottom: -1,
    height: 2,
    background: color.primary500,
    opacity: 0,
    transition: 'all 0.3s',
    pointerEvents: 'none'
  },
  inRangeBg: {
    background: color.primary100
  },
  inRangeStartEnd: {
    background: color.primary100
  },
  btnOk: {
    backgroundColor: color.primary50,
    color: color.primary500
  },
  btnNow: {
    color: color.primary500
  }
};
var forms = {
  radio: {
    // ':focus-within': {
    //   border: 'none !important',
    //   outline: 'none !important',
    // },
    // ':focus-visible': {
    //   border: 'none !important',
    //   outline: 'none !important',
    // },
    ':hover': {
      // border: 'none !important',
      // outline: 'none !important',
      color: 'red !important'
    },
    md: {
      ':focus': {
        border: 'none !important',
        outline: 'none !important'
      },
      appearance: 'none'
    }
  },
  // radio: {
  // appearance: 'none',
  // cursor: 'pointer',
  // backgroundColor: '#FFFFFF',
  // color: 'transparent',
  // border: '2px solid #D8DAE5',
  // width: '24px',
  // height: '20px',
  // position: 'absolute',
  // position: 'relative !important',
  // border: 'none !important',
  // ':hover': {
  // outline: 'none',
  // border: '2px solid #E42313',
  // background: '#F9E4E4',
  // color: 'transparent',
  // width: '20px',
  // height: '20px',
  // position: 'relative',
  // top: 0,
  // left: 0,
  // '&:after': {
  //   width: '12px !important',
  //   height: '12px !important',
  //   borderRadius: '50% !important',
  //   background: 'yellow !important',
  //   content: '""',
  // }
  // },
  // 'input:checked ~ &': {
  //   backgroundColor: '#52BD94 !important',
  // },
  // ':checked': {
  //   backgroundColor: 'blue !important',
  //   '&.css-xpp3tq': {
  //     display: 'block',
  //     zIndex: 2,
  //     width: '12px !important',
  //     height: '12px !important',
  //     borderRadius: '50% !important',
  //     background: 'blue !important',
  //   }
  // },
  // },
  textarea: {
    // labelTextArea: {
    //   color: '#2E3032',
    //   fontWeight: 600,
    //   marginBottom: '5px',
    //   fontFamily: 'Nunito Sans, sans-serif',
    // },
    fontFamily: 'Nunito Sans, sans-serif',
    '&::placeholder': {
      color: color.tertiary500
    },
    ':disabled': {
      border: '1px solid rgb(143, 149, 178) !important',
      backgroundColor: 'rgb(237, 239, 245) !important',
      ':hover': {
        border: '1px solid rgb(143, 149, 178) !important',
        outline: 'none'
      }
    },
    ':hover': {
      outline: 'none',
      border: "1px solid " + color.primary500 + " !important"
    },
    ':focus': {
      outline: 'none',
      border: "1px solid " + color.primary500,
      boxShadow: "0px 0px 0px 2px " + color.primary400
    },
    normal: {
      border: '1px solid #8F95B2'
    },
    success: {
      border: "1px solid " + color.success500
    },
    error: {
      border: "1px solid " + color.error500
    },
    '&:autofill': {
      backgroundColor: 'transparent',
      backgroundClip: 'text',
      boxShadow: '0 0 0 30px transparent inset',
      WebkitBoxShadow: '0 0 0 30px transparent inset',
      WebkitTextFillColor: '#1f1f1f',
      transition: 'background-color 5000s ease-in-out 0s',
      filter: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s',
        filter: 'none'
      },
      '&:focus': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s',
        filter: 'none'
      },
      '&:active': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s',
        filter: 'none'
      }
    },
    '&:-webkit-autofill': {
      backgroundColor: 'transparent',
      backgroundClip: 'text',
      boxShadow: '0 0 0 30px transparent inset',
      WebkitBoxShadow: '0 0 0 30px transparent inset',
      WebkitTextFillColor: '#1f1f1f',
      transition: 'background-color 5000s ease-in-out 0s',
      '&:hover': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s'
      },
      '&:focus': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s'
      },
      '&:active': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s'
      }
    }
  },
  "switch": {
    md: {
      height: '22px',
      width: '40px',
      marginTop: '-2px'
    },
    sm: {
      marginTop: '2px',
      height: '17px',
      width: '28px',
      div: {
        height: '12px !important',
        width: '12px !important'
      }
    },
    background: '#C8CCD2 !important',
    'input:checked ~ &': {
      backgroundColor: color.primary500 + " !important"
    },
    ':disabled': {
      background: '#D9DDE3 !important'
    }
  },
  checkbox: {
    sizeBoxLarge: {
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      width: 'fit-content',
      fontFamily: 'Nunito Sans, sans-serif'
    },
    sizeBoxSmall: {
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      width: 'fit-content',
      fontFamily: 'Nunito Sans, sans-serif'
    },
    wrappLabel: {
      marginLeft: '10px'
    },
    '& .container-checkbox': {
      display: 'flex',
      alignItems: 'center'
    },
    check: {
      sm: {
        height: '20px !important',
        width: '20px !important'
      },
      '&:disabled': {
        '&:hover': {
          '&:after': {
            content: '""'
          },
          cursor: 'pointer'
        },
        '&:checked': {
          '&:after': {
            content: '"\\2714"',
            color: color.tertiary600
          }
        },
        backgroundColor: color.tertiary300 + " !important",
        borderRadius: '4px !important',
        border: 'none !important'
      },
      height: '24px',
      width: '24px',
      appearance: 'none',
      border: "2px solid " + color.tertiary300,
      borderRadius: '4px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        border: "2px solid " + color.primary500,
        '&:after': {
          color: color.primary200,
          content: '"\\2714"'
        }
      },
      '&:checked': {
        backgroundColor: color.primary500,
        border: 'none',
        '&:after': {
          content: '"\\2714"',
          color: color.tertiary25
        },
        '&:hover': {
          backgroundColor: color.primary600
        }
      }
    },
    indeterminate: {
      sm: {
        height: '20px !important',
        width: '20px !important'
      },
      '&:disabled': {
        '&:hover': {
          '&:after': {
            content: '""'
          },
          cursor: 'pointer'
        },
        '&:checked': {
          '&:after': {
            content: '"\\2012"',
            color: color.tertiary600
          }
        },
        backgroundColor: color.tertiary300 + " !important",
        borderRadius: '4px !important',
        border: 'none !important'
      },
      height: '24px',
      width: '24px',
      appearance: 'none',
      border: "2px solid " + color.tertiary300,
      borderRadius: '4px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover': {
        border: "2px solid " + color.primary500,
        '&:after': {
          color: color.primary200,
          content: '"\\2012"'
        }
      },
      '&:checked': {
        backgroundColor: color.primary500,
        border: 'none',
        '&:after': {
          content: '"\\2012"',
          color: color.tertiary25
        },
        '&:hover': {
          backgroundColor: color.primary600
        }
      }
    }
  },
  input: {
    container: {
      position: 'relative',
      display: 'flex !important',
      flexDirection: 'row',
      alignItems: 'center !important',
      backgroundColor: '#FFFFFF',
      marginBottom: '30px',
      sm: {
        fontSize: '14px',
        lineHeight: '20px',
        '.wrap-icon-left': {
          width: '12px',
          height: '12px',
          marginLeft: '8px'
        },
        '.wrap-icon-right': {
          width: '12px',
          height: '12px',
          marginRight: '8px'
        },
        '.contain-prefix-left': {
          paddingLeft: '8px'
        },
        '.contain-prefix-right': {
          paddingRight: '8px'
        },
        '.limit-prefix-left': {
          marginLeft: '7px'
        },
        '.limit-prefix-right': {
          marginRight: '7px'
        }
      },
      md: {
        fontSize: '16px',
        lineHeight: '24px',
        '.wrap-icon-left': {
          width: '16px',
          height: '16px',
          marginLeft: '8px'
        },
        '.wrap-icon-right': {
          width: '16px',
          height: '16px',
          marginRight: '8px'
        },
        '.contain-prefix-left': {
          paddingLeft: '8px'
        },
        '.contain-prefix-right': {
          paddingRight: '8px'
        },
        '.limit-prefix-left': {
          marginLeft: '7px'
        },
        '.limit-prefix-right': {
          marginRight: '7px'
        }
      },
      lg: {
        fontSize: '18px',
        lineHeight: '28px',
        '.wrap-icon-left': {
          width: '20px',
          height: '20px',
          marginLeft: '16px'
        },
        '.wrap-icon-right': {
          width: '20px',
          height: '20px',
          marginRight: '16px'
        },
        '.contain-prefix-left': {
          paddingLeft: '16px'
        },
        '.contain-prefix-right': {
          paddingRight: '16px'
        },
        '.limit-prefix-left': {
          marginLeft: '15px'
        },
        '.limit-prefix-right': {
          marginRight: '15px'
        }
      }
    },
    containPrefLeft: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
      zIndex: 3
    },
    wrapperPrefLeft: {
      color: '#2E3032',
      fontWeight: '600'
    },
    limitPrefLeft: {
      height: '24px',
      borderRight: '1px solid #D9DDE3'
    },
    wrappPrefLeftIconLeft: {
      display: 'flex',
      alignItems: 'center',
      width: '16px',
      height: '16px',
      marginLeft: '12px',
      zIndex: 2
    },
    wrappIconLeft: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      alignItems: 'center',
      width: '16px',
      height: '16px',
      color: color.tertiary900
    },
    wrappField: {
      position: 'absolute',
      zIndex: 1,
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      borderRadius: '4px',
      border: '1px solid #8F95B2 !important',
      backgroundColor: '#EDEFF5 !important',
      transition: 'all 0.15s ease-in-out 0s'
    },
    wrappNormal: {
      position: 'absolute',
      zIndex: 1,
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      borderRadius: '4px',
      border: '1px solid #8F95B2',
      transition: 'all 0.15s ease-in-out 0s'
    },
    wrappSuccess: {
      zIndex: 1,
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      borderRadius: '4px',
      border: "1px solid " + color.success500,
      transition: 'all 0.15s ease-in-out 0s',
      position: 'absolute'
    },
    wrappError: {
      zIndex: 1,
      top: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      borderRadius: '4px',
      border: "1px solid " + color.error500,
      transition: 'all 0.15s ease-in-out 0s',
      position: 'absolute'
    },
    wrappPrefRightIconRight: {
      display: 'flex',
      alignItems: 'center',
      width: '16px',
      height: '16px',
      zIndex: 2,
      marginRight: '12px'
    },
    wrappIconRight: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      alignItems: 'center',
      width: '16px',
      height: '16px',
      cursor: 'pointer',
      color: color.tertiary900
    },
    containPrefRight: {
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      zIndex: 3
    },
    limitPrefRight: {
      height: '24px',
      borderRight: '1px solid #D9DDE3'
    },
    wrapperPrefRight: {
      color: '#2E3032',
      fontWeight: '600'
    },
    wrappLabelField: {
      justifyContent: 'space-between',
      marginBottom: '5px',
      fontSize: '16px',
      fontFamily: 'Nunito Sans, sans-serif',
      fontWeight: 600,
      '.label-field-text': {
        gap: '4px'
      },
      '.label-field-help': {
        color: color.tertiary600
      },
      '.label-field-optional': {
        color: color.tertiary500,
        fontSize: '14px',
        fontWeight: 400
      }
    },
    wrapperCaption: {
      alignItems: 'center',
      gap: '8px',
      marginTop: '8px',
      color: color.tertiary500,
      fontSize: '14px',
      lineHeight: '21px',
      '.container-textfield + &': {
        marginTop: '-22px'
      },
      '.container-textfield + & + .wrapper-field-caption': {
        marginTop: '8px'
      },
      error: {
        color: color.error500
      },
      success: {
        color: color.success500
      }
    },
    wrapperCaptionIcon: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        width: '20px',
        height: '20px'
      }
    },
    // wrapErrorMessage: {
    //   marginTop: '-25px',
    //   fontSize: '14px',
    //   color: color.error500,
    // },
    '&:disabled': {
      zIndex: 2,
      border: 0,
      backgroundColor: 'transparent !important'
    },
    normal: {
      '&:focus': {
        outline: 'none'
      },
      '&::placeholder': {
        color: color.tertiary500
      },
      '&:hover ~ .input-border': {
        outline: 'none',
        border: "1px solid " + color.primary500 + " !important"
      },
      '&:focus ~ .input-border': {
        outline: 'none',
        border: "1px solid " + color.primary500,
        boxShadow: "0px 0px 0px 2px " + color.primary400
      },
      '& .input-border': {
        paddingLeft: '30px !important'
      },
      border: '0',
      backgroundColor: 'transparent',
      zIndex: '2'
    },
    success: {
      '&:hover ~ .input-border': {
        outline: 'none',
        border: "1px solid " + color.primary500 + " !important"
      },
      '&:focus': {
        outline: 'none'
      },
      '&:focus ~ .input-border': {
        outline: 'none',
        border: "1px solid " + color.primary500,
        boxShadow: "0px 0px 0px 2px " + color.primary400
      },
      zIndex: 2,
      border: '0',
      backgroundColor: 'transparent'
    },
    error: {
      '&:hover ~ .input-border': {
        outline: 'none',
        border: "1px solid " + color.primary500 + " !important"
      },
      '&:focus': {
        outline: 'none'
      },
      '&:focus ~ .input-border': {
        outline: 'none',
        border: "1px solid " + color.primary500,
        boxShadow: "0px 0px 0px 2px " + color.primary400
      },
      zIndex: 2,
      border: '0',
      backgroundColor: 'transparent'
    },
    sm: {
      padding: '6px 8px'
    },
    md: {
      padding: '8px'
    },
    lg: {
      padding: '14px 16px'
    },
    '&:autofill': {
      backgroundColor: 'transparent',
      backgroundClip: 'text',
      boxShadow: '0 0 0 30px transparent inset',
      WebkitBoxShadow: '0 0 0 30px transparent inset',
      WebkitTextFillColor: '#1f1f1f',
      transition: 'background-color 5000s ease-in-out 0s',
      filter: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s',
        filter: 'none'
      },
      '&:focus': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s',
        filter: 'none'
      },
      '&:active': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s',
        filter: 'none'
      }
    },
    '&:-webkit-autofill': {
      backgroundColor: 'transparent',
      backgroundClip: 'text',
      boxShadow: '0 0 0 30px transparent inset',
      WebkitBoxShadow: '0 0 0 30px transparent inset',
      WebkitTextFillColor: '#1f1f1f',
      transition: 'background-color 5000s ease-in-out 0s',
      '&:hover': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s'
      },
      '&:focus': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s'
      },
      '&:active': {
        backgroundColor: 'transparent',
        backgroundClip: 'text',
        boxShadow: '0 0 0 30px transparent inset',
        WebkitBoxShadow: '0 0 0 30px transparent inset',
        WebkitTextFillColor: '#1f1f1f',
        transition: 'background-color 5000s ease-in-out 0s'
      }
    }
  }
};
var layout = {
  container: {
    fontFamily: 'Nunito Sans, sans-serif',
    '.container-login-center': {
      '@media (max-width:480px)': {
        '.container-side-right': {
          display: 'none'
        }
      },
      position: 'relative',
      overflow: 'hidden',
      height: '100vh',
      '.form-side-center': {
        '@media (max-width:480px)': {
          height: '90vh',
          width: '90%'
        },
        position: 'absolute',
        backgroundColor: color.tertiary25,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        padding: '50px 50px 20px 50px',
        overflowY: 'scroll',
        height: '70vh',
        '.container-logo': {
          textAlign: 'center',
          '.wrapper-logo': {
            width: '150px'
          }
        },
        '.wrapper-title': {
          color: color.secondary700,
          fontWeight: 700,
          fontSize: '36px',
          marginTop: spacer.spacing8,
          marginBottom: spacer.spacing3,
          textAlign: 'center'
        },
        '.wrapper-desc': {
          color: color.tertiary500,
          lineHeight: '24px',
          fontSize: '16px',
          marginBottom: spacer.spacing6,
          textAlign: 'center'
        },
        '.wrapper-remember': {
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: spacer.spacing6,
          marginBottom: spacer.spacing6
        },
        '.wrapper-button': {
          width: '100%'
        },
        '.wrapper-or': {
          display: 'flex',
          alignItems: 'center',
          marginTop: spacer.spacing4,
          marginBottom: spacer.spacing4,
          '.wrapper-line': {
            width: '50%',
            borderBottom: "1px solid " + color.tertiary400
          },
          '.or': {
            marginLeft: '20px',
            marginRight: '20px'
          }
        },
        '.wrapper-register': {
          color: color.tertiary700,
          fontWeight: 600,
          fontSize: '16px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: spacer.spacing4,
          marginBottom: spacer.spacing10
        },
        '.wrapper-footer': {
          color: color.tertiary800,
          fontWeight: 600,
          fontSize: '14px',
          display: 'flex',
          justifyContent: 'center',
          fontFamily: 'Nunito Sans, sans-serif'
        }
      },
      '.container-side-right': {
        width: '100%',
        '.wrapper-background': {
          width: '100% !important',
          height: '100vh !important',
          objectFit: 'cover'
        }
      }
    },
    '.container-login': {
      '@media (max-width:768px)': {
        '.container-side-right': {
          display: 'none'
        }
      },
      display: 'flex',
      overflow: 'hidden',
      height: '100vh',
      '.form-side-right': {
        '@media (max-width:480px)': {
          padding: '20px',
          width: '100%'
        },
        order: 1,
        width: '75%',
        padding: '50px 100px',
        overflowY: 'scroll',
        height: '100vh',
        position: 'relative',
        '.wrapper-logo': {
          width: '150px'
        },
        '.wrapper-title': {
          color: color.secondary700,
          fontWeight: 700,
          fontSize: '36px',
          marginTop: spacer.spacing8,
          marginBottom: spacer.spacing3
        },
        '.wrapper-desc': {
          color: color.tertiary500,
          lineHeight: '24px',
          fontSize: '16px',
          marginBottom: spacer.spacing6
        },
        '.wrapper-title-email': {
          color: color.tertiary800,
          fontWeight: 600,
          fontSize: '16px'
        },
        '.wrapper-title-pass': {
          color: color.tertiary800,
          marginTop: spacer.spacing6,
          fontWeight: 600,
          fontSize: '16px'
        },
        '.wrapper-remember': {
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: spacer.spacing6,
          marginBottom: spacer.spacing6
        },
        '.wrapper-button': {
          width: '100%'
        },
        '.wrapper-or': {
          display: 'flex',
          alignItems: 'center',
          marginTop: spacer.spacing4,
          marginBottom: spacer.spacing4,
          '.wrapper-line': {
            width: '50%',
            borderBottom: "1px solid " + color.tertiary400
          },
          '.or': {
            marginLeft: '20px',
            marginRight: '20px'
          }
        },
        '.wrapper-register': {
          color: color.tertiary700,
          fontWeight: 600,
          fontSize: '16px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: spacer.spacing4,
          marginBottom: spacer.spacing10
        },
        '.wrapper-footer': {
          color: color.tertiary800,
          fontWeight: 600,
          fontSize: '14px',
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '70px',
          fontFamily: 'Nunito Sans, sans-serif'
        }
      },
      '.form-side-left': {
        '@media (max-width:480px)': {
          padding: '20px',
          width: '100%'
        },
        width: '75%',
        padding: '50px 100px',
        overflowY: 'scroll',
        height: '100vh',
        position: 'relative',
        '.wrapper-logo': {
          width: '150px'
        },
        '.wrapper-title': {
          color: color.secondary700,
          fontWeight: 700,
          fontSize: '36px',
          marginTop: spacer.spacing8,
          marginBottom: spacer.spacing3
        },
        '.wrapper-desc': {
          color: color.tertiary500,
          lineHeight: '24px',
          fontSize: '16px',
          marginBottom: spacer.spacing6
        },
        '.wrapper-title-email': {
          color: color.tertiary800,
          fontWeight: 600,
          fontSize: '16px'
        },
        '.wrapper-title-pass': {
          color: color.tertiary800,
          marginTop: spacer.spacing6,
          fontWeight: 600,
          fontSize: '16px'
        },
        '.wrapper-remember': {
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: spacer.spacing6,
          marginBottom: spacer.spacing6
        },
        '.wrapper-button': {
          width: '100%'
        },
        '.wrapper-or': {
          display: 'flex',
          alignItems: 'center',
          marginTop: spacer.spacing4,
          marginBottom: spacer.spacing4,
          '.wrapper-line': {
            width: '50%',
            borderBottom: "1px solid " + color.tertiary400
          },
          '.or': {
            marginLeft: '20px',
            marginRight: '20px'
          }
        },
        '.wrapper-register': {
          color: color.tertiary700,
          fontWeight: 600,
          fontSize: '16px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: spacer.spacing4,
          marginBottom: spacer.spacing10
        },
        '.wrapper-footer': {
          color: color.tertiary800,
          fontWeight: 600,
          fontSize: '14px',
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '70px',
          fontFamily: 'Nunito Sans, sans-serif'
        }
      },
      '.container-side-right': {
        width: '100%',
        '.wrapper-background': {
          width: '100% !important',
          height: '100vh !important',
          objectFit: 'cover'
        }
      }
    }
  }
};
var links = {
  nav: /*#__PURE__*/_extends({}, text.caption_lg_bold, {
    color: color.tertiary900,
    padding: spacer.spacing3,
    margin: spacer.spacing1,
    '&:hover': {
      background: "" + color.primary400,
      cursor: 'pointer'
    },
    '&:active': {
      background: "" + color.primary400,
      borderRight: spacer.spacing1 + " solid " + color.primary500,
      cursor: 'pointer'
    },
    svg: {
      height: '14px',
      width: '14px',
      marginRight: spacer.spacing3
    }
  }),
  primary: {
    bg: "" + color.primary500,
    color: "" + color.tertiary25
  },
  secondary: {
    bg: "" + color.secondary50,
    color: "" + color.tertiary900
  }
};
var megamenu = {
  primary50: {
    backgroundColor: "" + color.primary50
  },
  primary500: {
    color: "" + color.primary500
  },
  tertiary800: {
    color: "" + color.tertiary800
  },
  flexWrapper: {
    display: 'flex',
    flexDirection: 'row'
  },
  leftWrapper: {
    width: '25%',
    borderRight: "1px solid " + color.primary100,
    padding: '0.625rem',
    height: 350,
    overflow: 'auto',
    item: {
      display: 'flex',
      padding: spacer.spacing2 + " " + spacer.spacing3,
      marginBottom: '0.625rem',
      cursor: 'pointer',
      title: {
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: 600,
        fontSize: "" + spacer.spacing4
      }
    }
  },
  rightWrapper: {
    width: '75%',
    height: 350,
    overflow: 'auto',
    padding: spacer.spacing3 + " " + spacer.spacing5 + " " + spacer.spacing3 + " " + spacer.spacing8,
    layoutWrapper: {
      display: 'flex',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
      gap: '1.875rem'
    },
    item: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginBottom: "" + spacer.spacing5,
      marginLeft: '0.625rem',
      title: {
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: 700,
        fontSize: "" + spacer.spacing8
      },
      children: {
        layout: {
          flex: 1,
          marginBottom: "" + spacer.spacing8,
          title: {
            fontFamily: 'Nunito Sans, sans-serif',
            fontWeight: 700,
            fontSize: '1.125rem',
            marginBottom: '0.9375rem',
            marginLeft: '0.625rem'
          },
          desc: {
            color: color.tertiary800 + " !important",
            fontFamily: 'Nunito Sans, sans-serif',
            fontWeight: 600,
            padding: spacer.spacing2 + " " + spacer.spacing3,
            fontSize: "" + spacer.spacing4,
            '&:hover': {
              display: 'flex',
              textDecoration: 'none',
              background: "" + color.primary50,
              color: color.primary500 + " !important",
              padding: spacer.spacing2 + " " + spacer.spacing3
            }
          }
        }
      }
    }
  }
};
var spacers = /*#__PURE__*/_extends({}, spacer);
var navbar = {
  hideIn: {
    sm: {
      '@media screen and (max-width: 640px)': {
        display: 'none'
      }
    },
    md: {
      '@media screen and (max-width: 768px)': {
        display: 'none'
      }
    },
    lg: {
      '@media screen and (max-width: 1024px)': {
        display: 'none'
      }
    },
    xl: {
      '@media screen and (max-width: 1280px)': {
        display: 'none'
      }
    }
  },
  showIn: {
    sm: {
      display: 'none',
      '@media screen and (max-width: 640px)': {
        display: 'flex'
      }
    },
    md: {
      display: 'none',
      '@media screen and (max-width: 768px)': {
        display: 'flex'
      }
    },
    lg: {
      display: 'none',
      '@media screen and (max-width: 1024px)': {
        display: 'flex'
      }
    },
    xl: {
      display: 'none',
      '@media screen and (max-width: 1280px)': {
        display: 'flex'
      }
    }
  },
  navbarBrand: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    '@media screen and (max-width: 768px)': {
      alignItems: 'center',
      height: '100%'
    }
  },
  navbarCollapse: {
    div: {
      p: spacers.spacing4,
      li: {
        fontSize: '1rem',
        fontWeight: '600',
        lineHeight: '1.5rem',
        listStyleType: 'none'
      }
    },
    '@media screen and (max-width: 768px)': {
      borderTop: "2px solid " + color.tertiary200,
      background: 'rgba(255, 255, 255, 0.95)',
      height: '100vh',
      left: 0,
      position: 'absolute',
      width: '100%',
      top: spacers.spacing14,
      borderRadius: radius.radius4
    }
  },
  navbarContent: {
    "default": {
      display: 'flex',
      alignItems: 'center',
      listStyleType: 'none',
      gap: spacers.spacing10,
      margin: 0,
      padding: 0,
      li: {
        fontWeight: '600',
        a: {
          '&:hover': {
            opacity: '0.8'
          }
        }
      }
    }
  },
  navbarItem: {
    active: {
      background: color.primary500,
      borderRadius: radius.radius2,
      color: '#ffffff',
      fontWeight: '600',
      padding: spacers.spacing2
    }
  },
  mode: {
    light: {
      background: '#ffffff',
      color: color.tertiary800
    },
    dark: {
      background: '#000000',
      color: color.tertiary500
    }
  },
  variant: {
    floating: {
      borderRadius: radius.radius4,
      marginTop: spacers.spacing4,
      marginLeft: spacers.spacing4,
      marginRight: spacers.spacing4,
      position: 'sticky',
      left: 0,
      right: 0,
      top: spacers.spacing4,
      '@media screen and (max-width: 768px)': {
        p: "0px " + spacers.spacing4
      }
    },
    "static": {
      position: 'static',
      borderBottom: "1px solid " + color.tertiary300,
      '@media screen and (max-width: 768px)': {
        display: 'block',
        p: "0px " + spacers.spacing4
      }
    },
    sticky: {
      position: 'sticky',
      top: 0,
      borderBottom: "1px solid " + color.tertiary300,
      '@media screen and (max-width: 768px)': {
        display: 'block',
        p: "0px " + spacers.spacing4
      }
    }
  }
};
var sidebar = {
  padding: spacer.spacing2 + " 0 " + spacer.spacing11,
  width: spacer.spacing25,
  overflowY: 'inherit',
  '.sidebar-top-content': {
    marginBottom: spacer.spacing6
  },
  '.sidebar-menu-wrapper': {
    padding: 0,
    '& a': {
      position: 'relative',
      '&:hover, &:focus, &.active': {
        background: "" + color.primary50,
        borderLeft: "3px solid " + color.primary500
      }
    },
    '& .badgeMenu': {
      position: 'absolute',
      right: '12px'
    }
  }
};
var spinner = {
  primary: {
    color: color.primary500
  },
  secondary: {
    color: color.secondary500
  }
};
var text$1 = {
  "default": {
    fontFamily: 'Nunito Sans, sans-serif',
    color: color.tertiary800,
    // Body
    lg_regular: /*#__PURE__*/_extends({}, text.body_lg_regular),
    lg_regular_respon: /*#__PURE__*/_extends({}, text.body_lg_regular, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '16px',
        lineHeight: '24px'
      }
    }),
    lg_semibold: /*#__PURE__*/_extends({}, text.body_lg_semibold),
    lg_semibold_respon: /*#__PURE__*/_extends({}, text.body_lg_semibold, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '16px',
        lineHeight: '24px'
      }
    }),
    lg_bold: /*#__PURE__*/_extends({}, text.body_lg_bold),
    lg_bold_respon: /*#__PURE__*/_extends({}, text.body_lg_bold, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '16px',
        lineHeight: '24px'
      }
    }),
    lg_italic: /*#__PURE__*/_extends({}, text.body_lg_italic),
    lg_italic_respon: /*#__PURE__*/_extends({}, text.body_lg_italic, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '16px',
        lineHeight: '24px'
      }
    }),
    lg_underline: /*#__PURE__*/_extends({}, text.body_lg_underline),
    lg_underline_respon: /*#__PURE__*/_extends({}, text.body_lg_underline, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '16px',
        lineHeight: '24px'
      }
    }),
    lg_underline_semibold: /*#__PURE__*/_extends({}, text.body_lg_underline_semibold),
    lg_underline_semibold_respon: /*#__PURE__*/_extends({}, text.body_lg_underline_semibold, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '16px',
        lineHeight: '24px'
      }
    }),
    lg_underline_bold: /*#__PURE__*/_extends({}, text.body_lg_underline_bold),
    lg_underline_bold_respon: /*#__PURE__*/_extends({}, text.body_lg_underline_bold, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '16px',
        lineHeight: '24px'
      }
    }),
    sm_regular: /*#__PURE__*/_extends({}, text.body_sm_regular),
    sm_regular_respon: /*#__PURE__*/_extends({}, text.body_sm_regular, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
        lineHeight: '21px'
      }
    }),
    sm_semibold: /*#__PURE__*/_extends({}, text.body_sm_semibold),
    sm_semibold_respon: /*#__PURE__*/_extends({}, text.body_sm_semibold, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
        lineHeight: '21px'
      }
    }),
    sm_bold: /*#__PURE__*/_extends({}, text.body_sm_bold),
    sm_bold_respon: /*#__PURE__*/_extends({}, text.body_sm_semibold, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
        lineHeight: '21px'
      }
    }),
    sm_italic: /*#__PURE__*/_extends({}, text.body_sm_italic),
    sm_italic_respon: /*#__PURE__*/_extends({}, text.body_sm_italic, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
        lineHeight: '21px'
      }
    }),
    sm_underline: /*#__PURE__*/_extends({}, text.body_sm_underline),
    sm_underline_respon: /*#__PURE__*/_extends({}, text.body_sm_underline, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
        lineHeight: '21px'
      }
    }),
    sm_underline_semibold: /*#__PURE__*/_extends({}, text.body_sm_underline_semibold),
    sm_underline_semibold_respon: /*#__PURE__*/_extends({}, text.body_sm_underline_semibold, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
        lineHeight: '21px'
      }
    }),
    sm_underline_bold: /*#__PURE__*/_extends({}, text.body_sm_underline_bold),
    sm_underline_bold_respon: /*#__PURE__*/_extends({}, text.body_sm_underline_bold, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
        lineHeight: '21px'
      }
    }),
    // Caption
    sizes: {
      lg_regular: /*#__PURE__*/_extends({}, text.caption_lg_regular),
      lg_regular_respon: /*#__PURE__*/_extends({}, text.caption_lg_regular, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '12px',
          lineHeight: '18px'
        }
      }),
      lg_semibold: /*#__PURE__*/_extends({}, text.caption_lg_semibold),
      lg_semibold_respon: /*#__PURE__*/_extends({}, text.caption_lg_semibold, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '12px',
          lineHeight: '18px'
        }
      }),
      lg_bold: /*#__PURE__*/_extends({}, text.caption_lg_bold),
      lg_bold_respon: /*#__PURE__*/_extends({}, text.caption_lg_bold, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '12px',
          lineHeight: '18px'
        }
      }),
      lg_italic: /*#__PURE__*/_extends({}, text.caption_lg_italic),
      lg_italic_respon: /*#__PURE__*/_extends({}, text.caption_lg_italic, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '12px',
          lineHeight: '18px'
        }
      }),
      lg_underline: /*#__PURE__*/_extends({}, text.caption_lg_underline),
      lg_underline_respon: /*#__PURE__*/_extends({}, text.caption_lg_underline, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '12px',
          lineHeight: '18px'
        }
      }),
      lg_underline_semibold: /*#__PURE__*/_extends({}, text.caption_lg_underline_semibold),
      lg_underline_semibold_respon: /*#__PURE__*/_extends({}, text.caption_lg_underline_semibold, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '12px',
          lineHeight: '18px'
        }
      }),
      lg_underline_bold: /*#__PURE__*/_extends({}, text.caption_lg_underline_bold),
      lg_underline_bold_respon: /*#__PURE__*/_extends({}, text.caption_lg_underline_bold, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '12px',
          lineHeight: '18px'
        }
      }),
      sm_regular: /*#__PURE__*/_extends({}, text.caption_sm_regular),
      sm_regular_respon: /*#__PURE__*/_extends({}, text.caption_sm_regular, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '10px',
          lineHeight: '18px'
        }
      }),
      sm_semibold: /*#__PURE__*/_extends({}, text.caption_sm_semibold),
      sm_semibold_respon: /*#__PURE__*/_extends({}, text.caption_sm_semibold, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '10px',
          lineHeight: '18px'
        }
      }),
      sm_bold: /*#__PURE__*/_extends({}, text.caption_sm_bold),
      sm_bold_respon: /*#__PURE__*/_extends({}, text.caption_sm_bold, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '10px',
          lineHeight: '18px'
        }
      }),
      sm_italic: /*#__PURE__*/_extends({}, text.caption_sm_italic),
      sm_italic_respon: /*#__PURE__*/_extends({}, text.caption_sm_italic, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '10px',
          lineHeight: '18px'
        }
      }),
      sm_underline: /*#__PURE__*/_extends({}, text.caption_sm_underline),
      sm_underline_respon: /*#__PURE__*/_extends({}, text.caption_sm_underline, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '10px',
          lineHeight: '18px'
        }
      }),
      sm_underline_semibold: /*#__PURE__*/_extends({}, text.caption_sm_underline_semibold),
      sm_underline_semibold_respon: /*#__PURE__*/_extends({}, text.caption_sm_underline_semibold, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '10px',
          lineHeight: '18px'
        }
      }),
      sm_underline_bold: /*#__PURE__*/_extends({}, text.caption_sm_underline_bold),
      sm_underline_bold_respon: /*#__PURE__*/_extends({}, text.caption_sm_underline_bold, {
        '@media screen and (max-width: 400px)': {
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '10px',
          lineHeight: '18px'
        }
      })
    }
  },
  // Heading
  heading: {
    h1: /*#__PURE__*/_extends({}, text.h1),
    h1Respon: /*#__PURE__*/_extends({}, text.h1, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '34px',
        lineHeight: '48px',
        fontWeight: '700'
      }
    }),
    h2: /*#__PURE__*/_extends({}, text.h2),
    h2Respon: /*#__PURE__*/_extends({}, text.h2, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '28px',
        lineHeight: '42px',
        fontWeight: '700'
      }
    }),
    h3: /*#__PURE__*/_extends({}, text.h3),
    h3Respon: /*#__PURE__*/_extends({}, text.h3, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '24px',
        lineHeight: '36px',
        fontWeight: '700'
      }
    }),
    h4: /*#__PURE__*/_extends({}, text.h4),
    h4Respon: /*#__PURE__*/_extends({}, text.h4, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '22px',
        lineHeight: '32px',
        fontWeight: '700'
      }
    }),
    h5: /*#__PURE__*/_extends({}, text.h5),
    h5Respon: /*#__PURE__*/_extends({}, text.h5, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '20px',
        lineHeight: '28px',
        fontWeight: '700'
      }
    }),
    h6: /*#__PURE__*/_extends({}, text.h6),
    h6Respon: /*#__PURE__*/_extends({}, text.h6, {
      '@media screen and (max-width: 400px)': {
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '18px',
        lineHeight: '26px',
        fontWeight: '700'
      }
    })
  }
};
var tooltip = {
  position: 'relative',
  display: 'inline-block',
  '&:hover .wrapper-tooltip': {
    opacity: 1
  },
  wrapper: {
    width: 'max-content',
    maxWidth: '50vw',
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '18xpx',
    color: '#fff',
    backgroundColor: color.tertiary800,
    padding: '12px',
    borderRadius: '8px',
    position: 'absolute',
    zIndex: 1,
    opacity: 0,
    transition: 'opacity 0.15s ease-in-out 0s',
    pointerEvents: 'none',
    arrow: {
      width: '12px',
      height: '12px',
      backgroundColor: color.tertiary800,
      borderRadius: '1px',
      transform: 'rotate(45deg)',
      position: 'absolute',
      'top-start': {
        bottom: '-3px',
        left: '12px'
      },
      'top-end': {
        bottom: '-3px',
        right: '12px'
      },
      top: {
        bottom: '-3px',
        left: '50%',
        transform: 'translateX(-50%) rotate(45deg)'
      },
      'bottom-start': {
        top: '-3px',
        left: '12px'
      },
      'bottom-end': {
        top: '-3px',
        right: '12px'
      },
      bottom: {
        top: '-3px',
        left: '50%',
        transform: 'translateX(-50%) rotate(45deg)'
      },
      left: {
        right: '-3px',
        top: '50%',
        transform: 'translateY(-50%) rotate(45deg)'
      },
      right: {
        left: '-3px',
        top: '50%',
        transform: 'translateY(-50%) rotate(45deg)'
      }
    },
    'top-start': {
      bottom: '100%',
      marginBottom: '10px',
      left: '-12px'
    },
    'top-end': {
      bottom: '100%',
      marginBottom: '10px',
      right: '-12px'
    },
    top: {
      bottom: '100%',
      marginBottom: '10px',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    'bottom-start': {
      top: '100%',
      marginTop: '10px',
      left: '-12px'
    },
    'bottom-end': {
      top: '100%',
      marginTop: '10px',
      right: '-12px'
    },
    bottom: {
      top: '100%',
      marginTop: '10px',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    left: {
      right: '100%',
      marginRight: '10px',
      top: '50%',
      transform: 'translateY(-50%)'
    },
    right: {
      left: '100%',
      marginLeft: '10px',
      top: '50%',
      transform: 'translateY(-50%)'
    }
  }
};
var table = {
  borderCollapse: 'collapse !important',
  width: '100% !important'
};
var tableCell = /*#__PURE__*/_extends({
  borderBottom: "1px solid " + color.tertiary300,
  padding: spacer.spacing3 + " " + spacer.spacing4
}, text.caption_lg_regular);
var headCell = /*#__PURE__*/_extends({
  borderBottom: "1px solid " + color.tertiary400,
  color: '#000',
  backgroundColor: color.tertiary200,
  padding: spacer.spacing3 + " " + spacer.spacing4
}, text.body_sm_bold);
var tableRow = {
  '&:nth-child(even)': {
    backgroundColor: "" + color.tertiary50
  }
};
var cssBaseText = {
  lineHeight: '150%',
  display: 'block'
};
var cssBaseLabel = /*#__PURE__*/_extends({}, cssBaseText, {
  fontWeight: '600',
  fontSize: '16px',
  marginBottom: '8px'
});
var cssBaseIconLeft = {
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center'
};
var cassBaseCaption = /*#__PURE__*/_extends({}, cssBaseText, {
  fontWeight: '400',
  fontSize: '14px',
  marginTop: '8px',
  display: 'flex',
  alignItems: 'center',
  svg: {
    height: '16px'
  }
});
var cssSelectControl = function cssSelectControl(borderColor, pseudoBorderColor, pseudoShadowColor) {
  return {
    borderRadius: '4px',
    boxShadow: "none",
    border: "1px solid " + borderColor,
    '&:hover,&:active,&:focus': {
      borderColor: pseudoBorderColor,
      boxShadow: "0px 0px 0px 2px " + pseudoShadowColor
    }
  };
};
var ccsSelectOption = {
  borderRadius: '4px',
  color: color.tertiary800,
  '&:hover': {
    background: color.primary50,
    color: color.primary500
  }
};
var cssSelectControlNormal = /*#__PURE__*/_extends({}, /*#__PURE__*/cssSelectControl(color.tertiary300, color.primary500, color.tertiary300));
var cssSelectControlError = /*#__PURE__*/_extends({}, /*#__PURE__*/cssSelectControl(color.error500, color.error500, color.error100));
var cssSelectControlSuccess = /*#__PURE__*/_extends({}, /*#__PURE__*/cssSelectControl(color.success500, color.success500, color.success100));
var select = {
  label: {
    normal: /*#__PURE__*/_extends({}, cssBaseLabel),
    error: /*#__PURE__*/_extends({}, cssBaseLabel),
    success: /*#__PURE__*/_extends({}, cssBaseLabel)
  },
  iconLeft: {
    sm: /*#__PURE__*/_extends({}, cssBaseIconLeft, {
      paddingLeft: '6px',
      marginRight: '-6px',
      svg: {
        height: '16px',
        color: color.tertiary800
      }
    }),
    md: /*#__PURE__*/_extends({}, cssBaseIconLeft, {
      paddingLeft: '8px',
      marginRight: '-4px',
      svg: {
        height: '20px',
        color: color.tertiary800
      }
    }),
    lg: /*#__PURE__*/_extends({}, cssBaseIconLeft, {
      paddingLeft: '10px',
      marginRight: '-2px',
      svg: {
        height: '24px',
        color: color.tertiary800
      }
    })
  },
  core: {
    control: {
      sm: {
        normal: /*#__PURE__*/_extends({}, cssSelectControlNormal, {
          minHeight: '32px'
        }),
        error: /*#__PURE__*/_extends({}, cssSelectControlError, {
          minHeight: '32px'
        }),
        success: /*#__PURE__*/_extends({}, cssSelectControlSuccess, {
          minHeight: '32px'
        })
      },
      md: {
        normal: /*#__PURE__*/_extends({}, cssSelectControlNormal, {
          minHeight: '40px'
        }),
        error: /*#__PURE__*/_extends({}, cssSelectControlError, {
          minHeight: '40px'
        }),
        success: /*#__PURE__*/_extends({}, cssSelectControlSuccess, {
          minHeight: '40px'
        })
      },
      lg: {
        normal: /*#__PURE__*/_extends({}, cssSelectControlNormal, {
          minHeight: '56px'
        }),
        error: /*#__PURE__*/_extends({}, cssSelectControlError, {
          minHeight: '56px'
        }),
        success: /*#__PURE__*/_extends({}, cssSelectControlSuccess, {
          minHeight: '56px'
        })
      }
    },
    menu: {
      boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.2)',
      padding: '0 4px',
      zIndex: 99999
    },
    option: {
      sm: /*#__PURE__*/_extends({}, ccsSelectOption, {
        padding: '6px 10px',
        fontSize: '14px'
      }),
      md: /*#__PURE__*/_extends({}, ccsSelectOption, {
        padding: '8px 10px',
        fontSize: '16px'
      }),
      lg: /*#__PURE__*/_extends({}, ccsSelectOption, {
        padding: '8px 10px',
        fontSize: '18px'
      })
    },
    multiValue: {
      borderRadius: '24px',
      background: color.primary50
    },
    multiValueLabel: {
      padding: '2px 2px 2px 7px',
      color: color.primary500
    },
    multiValueRemove: {
      padding: '2px 4px 2px 2px',
      color: color.primary500
    },
    indicatorsContainer: {
      padding: 0
    },
    dropdownIndicator: {
      padding: '4px 8px'
    },
    placeholder: {
      sm: {
        fontSize: '14px',
        lineHeight: 1
      },
      md: {
        fontSize: '16px',
        lineHeight: 1
      },
      lg: {
        fontSize: '18px',
        lineHeight: 1
      }
    }
  },
  hint: /*#__PURE__*/_extends({}, cassBaseCaption, {
    color: "" + color.tertiary60
  }),
  caption: {
    normal: /*#__PURE__*/_extends({}, cassBaseCaption, {
      color: "" + color.tertiary60
    }),
    error: /*#__PURE__*/_extends({}, cassBaseCaption, {
      color: "" + color.error500
    }),
    success: /*#__PURE__*/_extends({}, cassBaseCaption, {
      color: "" + color.success500
    }),
    icon: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: '4px'
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      lineHeight: 1
    }
  },
  '&:autofill': {
    backgroundColor: 'transparent',
    backgroundClip: 'text',
    boxShadow: '0 0 0 30px transparent inset',
    WebkitBoxShadow: '0 0 0 30px transparent inset',
    WebkitTextFillColor: '#1f1f1f',
    transition: 'background-color 5000s ease-in-out 0s',
    filter: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
      backgroundClip: 'text',
      boxShadow: '0 0 0 30px transparent inset',
      WebkitBoxShadow: '0 0 0 30px transparent inset',
      WebkitTextFillColor: '#1f1f1f',
      transition: 'background-color 5000s ease-in-out 0s',
      filter: 'none'
    },
    '&:focus': {
      backgroundColor: 'transparent',
      backgroundClip: 'text',
      boxShadow: '0 0 0 30px transparent inset',
      WebkitBoxShadow: '0 0 0 30px transparent inset',
      WebkitTextFillColor: '#1f1f1f',
      transition: 'background-color 5000s ease-in-out 0s',
      filter: 'none'
    },
    '&:active': {
      backgroundColor: 'transparent',
      backgroundClip: 'text',
      boxShadow: '0 0 0 30px transparent inset',
      WebkitBoxShadow: '0 0 0 30px transparent inset',
      WebkitTextFillColor: '#1f1f1f',
      transition: 'background-color 5000s ease-in-out 0s',
      filter: 'none'
    }
  },
  '&:-webkit-autofill': {
    backgroundColor: 'transparent',
    backgroundClip: 'text',
    boxShadow: '0 0 0 30px transparent inset',
    WebkitBoxShadow: '0 0 0 30px transparent inset',
    WebkitTextFillColor: '#1f1f1f',
    transition: 'background-color 5000s ease-in-out 0s',
    '&:hover': {
      backgroundColor: 'transparent',
      backgroundClip: 'text',
      boxShadow: '0 0 0 30px transparent inset',
      WebkitBoxShadow: '0 0 0 30px transparent inset',
      WebkitTextFillColor: '#1f1f1f',
      transition: 'background-color 5000s ease-in-out 0s'
    },
    '&:focus': {
      backgroundColor: 'transparent',
      backgroundClip: 'text',
      boxShadow: '0 0 0 30px transparent inset',
      WebkitBoxShadow: '0 0 0 30px transparent inset',
      WebkitTextFillColor: '#1f1f1f',
      transition: 'background-color 5000s ease-in-out 0s'
    },
    '&:active': {
      backgroundColor: 'transparent',
      backgroundClip: 'text',
      boxShadow: '0 0 0 30px transparent inset',
      WebkitBoxShadow: '0 0 0 30px transparent inset',
      WebkitTextFillColor: '#1f1f1f',
      transition: 'background-color 5000s ease-in-out 0s'
    }
  }
};
var accordion = {
  width: '100%',
  '&> input[type="checkbox"]': {
    position: 'absolute',
    left: '-100vw',
    '&:checked ~ .content': {
      height: 'auto',
      overflow: 'visible',
      borderBottom: "1px solid " + color.tertiary300,
      padding: spacer.spacing3,
      borderTop: 0
    },
    '&:checked ~ label': {
      borderBottom: 'none',
      '.toggle-up': {
        display: 'inline-block !important'
      },
      '.toggle-down': {
        display: 'none !important'
      }
    },
    '&:checked ~ label + .content': {
      opacity: 1,
      transition: '.3s',
      height: 'auto',
      '&.menu-content > div': {
        display: 'block'
      }
    }
  },
  'label': {
    display: 'block',
    color: color.tertiary800,
    cursor: 'pointer',
    padding: spacer.spacing3,
    background: '#FFF',
    fontSize: '16px',
    borderBottom: "1px solid " + color.tertiary300,
    position: 'relative',
    '&.menu-label': {
      fontWeight: 'bold',
      fontSize: '14px',
      borderBottom: '0 !important',
      '&.is-menu:hover, &.is-menu-active': {
        background: "" + color.primary50,
        cursor: 'pointer',
        borderLeft: "3px solid " + color.primary500
      }
    },
    '> svg': {
      marginRight: spacer.spacing3,
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: '28px',
      verticalAlign: 'middle',
      position: 'absolute',
      right: '-8px',
      top: '14px',
      '&.toggle-down': {
        display: 'inline-block'
      },
      '&.toggle-up': {
        display: 'none'
      }
    },
    '.left-icon': {
      marginRight: spacer.spacing2,
      position: 'relative',
      top: '2px'
    },
    '.right-icon': {
      marginRight: spacer.spacing2,
      position: 'absolute',
      right: '12px'
    }
  },
  '.content': {
    opacity: 0,
    transition: '.3s',
    height: 0,
    background: '#FFF',
    '&.menu-content': {
      padding: "0 " + spacer.spacing3 + " !important",
      borderBottom: '0 !important',
      '&> div': {
        display: 'none'
      }
    }
  }
};
var dataTable = {
  search: {
    alignItems: 'center',
    display: 'flex',
    width: '300px !important'
  },
  filter: {
    height: '44px',
    marginLeft: 10,
    marginRight: 20,
    width: '100px'
  },
  headWithAction: {
    alignItems: 'center',
    display: 'flex',
    "float": 'left',
    justifyContent: 'center'
  },
  headWithoutAction: {
    alignItems: 'center',
    display: 'flex'
  },
  table: {
    width: '100%'
  },
  tableCell: {
    borderBottom: '1px solid #CDD5DF',
    padding: 10
  },
  tableHead: {
    borderBottom: '1px solid #CDD5DF',
    borderTop: '1px solid #CDD5DF',
    padding: 10,
    fontSize: 18
  },
  tableRow: {
    textAlign: 'left'
  },
  wrappSort: {
    display: 'inline-grid',
    marginLeft: 10
  }
};
var SidebarWrapper = {
  position: 'fixed',
  top: 0,
  width: '280px',
  height: 'auto',
  overflow: 'hidden',
  zIndex: 99,
  textAlign: 'left',
  left: 0,
  '.sidebarHeader, .sidebarBody, .sidebarFooter': {
    padding: spacer.spacing4
  },
  '.sidebarHeader': {
    borderBottom: "1px solid " + color.tertiary100
  },
  '.sidebarBody': {
    overflowX: 'hidden',
    overflowY: 'auto',
    maxHeight: '85vh'
  },
  '.sidebarFooter': {
    bottom: 0,
    position: 'absolute',
    width: '100%',
    background: 'white',
    borderTop: "1px solid " + color.tertiary100
  },
  '#sidebarMenu': {
    height: '100%',
    position: 'fixed',
    left: 0,
    zIndex: 99,
    width: '280px',
    marginTop: 0,
    transform: 'translateX(-280px)',
    transition: 'transform 250ms ease-in-out',
    background: 'white',
    boxShadow: "6px 6px 6px -2px " + color.tertiary100,
    '.menu-label:not(:hover), .menu-content': {
      backgroundColor: 'unset'
    }
  },
  'input[type="checkbox"]': {
    '&:checked ~ ': {
      '#sidebarMenu': {
        transform: 'translateX(0)'
      }
    }
  },
  'input[type=checkbox]': {
    transition: 'all 0.3s',
    boxSizing: 'border-box',
    display: 'none',
    '&:checked ~': {
      '.sidebarIconToggle': {
        transform: 'translateX(280px)',
        transition: 'transform 250ms ease-in-out',
        '>.horizontal': {
          transition: 'all 0.3s',
          boxSizing: 'border-box',
          opacity: 0
        },
        '>.hamburger': {
          display: 'none'
        },
        '>.close': {
          display: 'block'
        }
      }
    }
  },
  '.sidebarIconToggle': {
    boxSizing: 'border-box',
    cursor: 'pointer',
    position: 'fixed',
    zIndex: 999,
    height: '40px',
    width: '48px',
    boxShadow: "6px 6px 6px -2px " + color.tertiary100,
    background: 'white',
    borderRadius: '0 5px 5px 0',
    top: '12px',
    padding: '10px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    border: "1px solid " + color.tertiary100,
    borderLeft: 'none'
  },
  '.spinner': {
    transition: 'all 0.3s',
    boxSizing: 'border-box',
    position: 'absolute',
    width: '100%',
    '&.close': {
      display: 'none'
    }
  }
};
var Modal = {
  '.modal': {
    opacity: 0,
    visibility: 'hidden',
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    textAlign: 'left',
    background: 'rgba(0,0,0, .5)',
    transition: 'opacity .25s ease',
    zIndex: 99999,
    '&__bg': {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      cursor: 'pointer'
    },
    '&-state': {
      display: 'none',
      '&:checked + .modal': {
        opacity: 1,
        visibility: 'visible',
        '.modal__inner': {
          top: '50%'
        }
      }
    },
    '&__inner': {
      transition: 'top .25s ease',
      position: 'relative',
      top: 0,
      left: '50%',
      width: '50%',
      transform: 'translate(-50%, -50%)',
      height: 'auto',
      maxHeight: '90%',
      maxWidth: '90%',
      overflow: 'auto',
      background: '#FFF',
      borderRadius: '6px',
      padding: 0,
      '&_wrapper': {
        height: '100%'
      }
    },
    '&__title': {
      padding: spacer.spacing6 + " " + spacer.spacing11 + " " + spacer.spacing3 + " " + spacer.spacing6,
      'span': {
        fontSize: '18px',
        fontWeight: 700,
        lineHeight: spacer.spacing7
      },
      'svg': {
        marginRight: spacer.spacing3
      }
    },
    '&__content': {
      padding: spacer.spacing3 + " " + spacer.spacing6
    },
    '&__footer': {
      padding: spacer.spacing3 + " " + spacer.spacing6 + " " + spacer.spacing6,
      position: 'relative',
      bottom: 0,
      width: '100%',
      '&.fixed': {
        position: 'fixed'
      }
    },
    '&__close': {
      position: 'absolute',
      right: spacer.spacing6,
      top: '30px',
      cursor: 'pointer'
    }
  }
};
var defaultChipStyle = {
  borderRadius: '24px',
  fontSize: '12px',
  display: 'flex',
  alignItems: 'center'
};
var defaultChipIconSpacing = {
  '.chip--prefix:not(.icon-only)': {
    marginRight: spacer.spacing1
  },
  '.chip--postfix:not(.icon-only)': {
    marginLeft: spacer.spacing1
  }
};
var Chip = {
  display: 'inline-block',
  '.chip': {
    '&--sm': /*#__PURE__*/_extends({}, defaultChipStyle, {
      padding: "0 " + spacer.spacing1,
      height: '18px',
      lineHeight: '18px',
      '&.outline': {
        lineHeight: '16px'
      }
    }, defaultChipIconSpacing, {
      'svg, img': {
        width: '12px',
        height: '12px',
        position: 'relative',
        top: '1.5px'
      }
    }),
    '&--md': /*#__PURE__*/_extends({}, defaultChipStyle, {
      padding: "3px " + spacer.spacing2,
      height: '24px',
      lineHeight: '18px',
      '&.outline': {
        lineHeight: '16px'
      }
    }, defaultChipIconSpacing, {
      'svg, img': {
        width: '18px',
        height: '18px',
        position: 'relative',
        top: '2px'
      }
    }),
    '&--lg': /*#__PURE__*/_extends({}, defaultChipStyle, {
      padding: "" + spacer.spacing2,
      height: '32px',
      lineHeight: '15px',
      '.chip--prefix:not(.icon-only)': {
        marginRight: spacer.spacing2
      },
      '.chip--postfix:not(.icon-only)': {
        marginLeft: spacer.spacing2
      },
      'svg, img': {
        width: '24px',
        height: '24px',
        position: 'relative',
        top: '1.5px'
      }
    })
  },
  '& input[type="checkbox"]': {
    display: 'none',
    '&:not(disabled) ~ .chip': {
      cursor: 'pointer'
    },
    '&:disabled ~ .chip': {
      cursor: 'text'
    },
    '&:checked ~ .chip': {
      '&.soft, &.outline': {
        '&--primary, &--tertiary, &--error, &--warning, &--success, &--info': {
          color: '#FFF'
        },
        '&--primary': {
          background: color.primary500
        },
        '&--tertiary': {
          background: color.tertiary500
        },
        '&--error': {
          background: color.error500
        },
        '&--warning': {
          background: color.warning500
        },
        '&--success': {
          background: color.success500
        },
        '&--info': {
          background: color.info500
        }
      }
    }
  },
  '.soft': {
    '&--primary': {
      backgroundColor: color.primary100,
      color: color.primary500,
      '&:hover': {
        background: color.primary200
      }
    },
    '&--tertiary': {
      backgroundColor: color.tertiary100,
      color: color.tertiary500,
      '&:hover': {
        background: color.tertiary200
      }
    },
    '&--error': {
      backgroundColor: color.error100,
      color: color.error500,
      '&:hover': {
        background: color.error200
      }
    },
    '&--warning': {
      backgroundColor: color.warning100,
      color: color.warning500,
      '&:hover': {
        background: color.warning200
      }
    },
    '&--success': {
      backgroundColor: color.success100,
      color: color.success500,
      '&:hover': {
        background: color.success200
      }
    },
    '&--info': {
      backgroundColor: color.info100,
      color: color.info500,
      '&:hover': {
        background: color.info200
      }
    }
  },
  '.outline': {
    backgroundColor: 'transparent',
    border: '1px solid',
    '&--primary': {
      borderColor: color.primary500,
      color: color.primary500,
      '&:hover': {
        background: color.primary100
      }
    },
    '&--tertiary': {
      borderColor: color.tertiary500,
      color: color.tertiary500,
      '&:hover': {
        background: color.tertiary100
      }
    },
    '&--error': {
      borderColor: color.error500,
      color: color.error500,
      '&:hover': {
        background: color.error100
      }
    },
    '&--info': {
      borderColor: color.info500,
      color: color.info500,
      '&:hover': {
        background: color.info100
      }
    },
    '&--success': {
      borderColor: color.success500,
      color: color.success500,
      '&:hover': {
        background: color.success100
      }
    },
    '&--warning': {
      borderColor: color.warning500,
      color: color.warning500,
      '&:hover': {
        background: color.warning100
      }
    }
  }
};
var tabbar = {
  position: 'relative',
  wrapper: {
    width: '100%',
    margin: spacer.spacing6 + " 0",
    textAlign: 'left',
    paddingLeft: 0,
    paddingBottom: spacer.spacing4
  },
  horizontal: {
    display: 'flex',
    overflowX: 'auto'
  },
  vertical: {
    display: 'block',
    overflowY: 'auto',
    maxWidth: '220px',
    '& .tab-item': {
      display: 'block !important',
      label: {
        whiteSpace: 'break-spaces !important',
        '&:hover': {
          borderBottom: 'none !important',
          borderRight: "4px solid " + color.primary500
        }
      },
      '& .tab-content': {
        top: '4px !important',
        left: '225px !important',
        width: 'calc( 100% - 240px ) !important'
      },
      '[id^="legionTab_"]:checked + label': {
        borderRight: "4px solid " + color.primary500,
        borderBottom: 'none !important',
        color: color.primary500
      }
    }
  },
  tabItem: {
    display: 'flex',
    justifyContent: 'flex-start',
    '& input[type="radio"]': {
      display: 'none'
    },
    label: {
      display: 'block',
      padding: spacer.spacing5,
      fontSize: '16px',
      lineHeight: spacer.spacing6,
      fontWeight: '600',
      background: 'white',
      cursor: 'pointer',
      position: 'relative',
      top: '4px',
      transition: 'all 0.2s ease-in-out',
      whiteSpace: 'nowrap',
      color: color.tertiary700,
      '& .prefix': {
        marginRight: '6px',
        position: 'relative',
        top: '1px'
      },
      '& .tab-badges': {
        marginLeft: '6px',
        background: '#E4EAF3',
        borderRadius: '8px',
        color: '#0077BC',
        fontSize: '14px',
        padding: '3px 6px'
      },
      '&:hover': {
        borderBottom: "4px solid " + color.primary500,
        background: color.primary25
      }
    },
    '.tab-content': {
      zIndex: 2,
      display: 'none',
      overflow: 'hidden',
      width: '100%',
      fontSize: '17px',
      lineHeight: spacer.spacing6,
      padding: spacer.spacing5,
      position: 'absolute',
      top: '74px',
      left: 0,
      background: 'white'
    },
    '[id^="legionTab_"]:checked + label': {
      borderBottom: "4px solid " + color.primary500,
      color: color.primary500
    },
    '[id^="legionTab"]:checked ~ [id^="legionTabContent"]': {
      display: 'block'
    },
    '[id^="legionTab"]:disabled + label': {
      color: color.tertiary400,
      '&:hover': {
        background: 'white',
        borderBottom: 'none !important',
        borderRight: 'none !important',
        cursor: 'not-allowed'
      }
    }
  }
};
var stepper = {
  success: {
    backgroundColor: color.success500,
    borderColor: color.success500
  },
  warning: {
    backgroundColor: color.warning500,
    borderColor: color.warning500
  },
  error: {
    backgroundColor: color.error500,
    borderColor: color.error500
  },
  stepItem: {
    width: '40px',
    height: '40px',
    border: '2px solid #ddd',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    margin: '0',
    fontSize: '20px',
    fontWeight: 'bold'
  },
  stepItemActive: {
    backgroundColor: '#ddd',
    borderColor: '#000',
    color: '#000',
    boxShadow: '0 0 10px #ddd'
  },
  stepTitle: {
    fontWeight: 'bold',
    mt: 1
  },
  stepDescription: {
    fontSize: '14px',
    color: '#A0A0A0'
  }
};
var styles$1 = {
  __proto__: null,
  alerts: alerts,
  badges: badges,
  buttons: buttons,
  cards: cards,
  carousel: carousel,
  colorscard: colorscard,
  colors: colors,
  datepicker: datepicker,
  forms: forms,
  layout: layout,
  links: links,
  megamenu: megamenu,
  navbar: navbar,
  sidebar: sidebar,
  spacers: spacers,
  spinner: spinner,
  styles: styles,
  text: text$1,
  tooltip: tooltip,
  table: table,
  tableCell: tableCell,
  headCell: headCell,
  tableRow: tableRow,
  select: select,
  accordion: accordion,
  dataTable: dataTable,
  SidebarWrapper: SidebarWrapper,
  Modal: Modal,
  Chip: Chip,
  tabbar: tabbar,
  stepper: stepper
};

/* eslint-disable max-lines */
var theme = /*#__PURE__*/makeTheme(styles$1);
var _excluded = ["color", "iconLeft", "iconRight", "disabled", "size", "variant", "children", "sx"];
var Button = function Button(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'primary' : _ref$color,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    disabled = _ref.disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'solid' : _ref$variant,
    children = _ref.children,
    sx = _ref.sx,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var context = useThemeUI();
  var sizes = get(context.theme, "buttons." + size);
  var variants = get(context.theme, "buttons." + variant);
  var colors = get(context.theme, "buttons." + variant + "." + color);
  return jsx(Button$1, Object.assign({
    sx: _extends({}, variants, sizes, colors, sx)
  }, rest, {
    disabled: disabled
  }), iconLeft && size === 'lg' && jsx("span", {
    className: "wrapper-icon-left-large"
  }, iconLeft) || iconLeft && size === 'md' && jsx("span", {
    className: "wrapper-icon-left-medium"
  }, iconLeft) || iconLeft && size === 'sm' && jsx("span", {
    className: "wrapper-icon-left-small"
  }, iconLeft), children && jsx("span", {
    /* eslint-disable no-nested-ternary */
    className: /* eslint-disable indent */
    iconRight && iconLeft && size ? 'wrapper-icon-both-children' : iconLeft && size ? 'wrapper-icon-left-children' : iconRight && size ? 'wrapper-icon-right-children' : ''
  }, children), !children && iconLeft && iconRight && size && jsx("span", {
    className: "wrapper-two-icon"
  }), iconRight && size === 'lg' && jsx("span", {
    className: "wrapper-icon-right-large"
  }, iconRight) || iconRight && size === 'md' && jsx("span", {
    className: "wrapper-icon-right-medium"
  }, iconRight) || iconRight && size === 'sm' && jsx("span", {
    className: "wrapper-icon-right-small"
  }, iconRight));
};
Button.displayName = 'Button';
var _excluded$1 = ["children", "icon", "variant"];
var FieldCaption = function FieldCaption(_ref) {
  var children = _ref.children,
    icon = _ref.icon,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'normal' : _ref$variant,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var context = useThemeUI();
  var wrapperCaptionVariant = get(context.theme, "forms.input.wrapperCaption." + variant);
  var wrapperCaption = get(context.theme, "forms.input.wrapperCaption");
  var wrapperCaptionIcon = get(context.theme, "forms.input.wrapperCaptionIcon");
  return jsx(Flex, Object.assign({
    className: "wrapper-field-caption",
    sx: _extends({}, wrapperCaption, wrapperCaptionVariant)
  }, rest), icon && jsx("span", {
    sx: _extends({}, wrapperCaptionIcon)
  }, icon), children);
};
FieldCaption.displayName = 'FieldCaption';
var _excluded$2 = ["children", "title", "placement", "arrow", "sx"];
var Tooltip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    title = _ref.title,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? true : _ref$arrow,
    sx = _ref.sx,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  var context = useThemeUI();
  var styles = get(context.theme, "tooltip");
  var wrapper = get(context.theme, "tooltip.wrapper");
  var wrapperPlacement = get(context.theme, "tooltip.wrapper." + placement);
  var wrapperArrow = get(context.theme, "tooltip.wrapper.arrow");
  var wrapperArrowPlacement = get(context.theme, "tooltip.wrapper.arrow." + placement);
  return jsx(Box, Object.assign({
    as: "span",
    ref: ref,
    sx: _extends({}, styles, sx)
  }, rest), children, jsx(Box, {
    className: "wrapper-tooltip",
    sx: _extends({}, wrapper, wrapperPlacement)
  }, title, arrow && jsx("span", {
    className: "wrapper-tooltip-arrow",
    sx: _extends({}, wrapperArrow, wrapperArrowPlacement)
  })));
});
Tooltip.displayName = 'Tooltip';

/**
 * Check email validation
 * @param email string
 * @returns boolean
 */
var isValidEmail = function isValidEmail(email) {
  var REGEX = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  var value = email.toLowerCase();
  return !!REGEX.test(value);
};
/**
 * Check URL validation
 * @param url string
 * @returns boolean
 */
var isValidURL = function isValidURL(url) {
  var REGEX = new RegExp('^(https?:\\/\\/)?' +
  // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
  // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' +
  // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
  // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' +
  // query string
  '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return !!REGEX.test(url);
};
/**
 * Check if user is scrolling down or scrolling up
 * @returns string
 */
var useScrollDirection = function useScrollDirection() {
  var _useState = useState(null),
    scrollDirection = _useState[0],
    setScrollDirection = _useState[1];
  useEffect(function () {
    var lastScrollY = window.scrollY;
    var updateScrollDirection = function updateScrollDirection() {
      var scrollY = window.scrollY;
      var direction = scrollY > lastScrollY ? 'down' : 'up';
      if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener('scroll', updateScrollDirection); // add event listener
    return function () {
      window.removeEventListener('scroll', updateScrollDirection); // clean up
    };
  }, [scrollDirection]);
  return scrollDirection;
};
/**
 * Calculates SVG Weight with size being contention
 * @param size number
 * @param weight 'light' | 'regular' | 'bold'
 * @returns number
 */
var calculateSvgWeight = function calculateSvgWeight(size, weight) {
  switch (weight) {
    case 'light':
      return size / 16;
    case 'regular':
      return size / 12;
    case 'bold':
      return size / 9.6;
  }
};
var _excluded$3 = ["name", "color", "size", "weight"];
function DynamicIcon(_ref) {
  var name = _ref.name,
    color = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size,
    _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 'bold' : _ref$weight,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
  var IconComponent = icons[name];
  var calculatedWeight = calculateSvgWeight(size, weight);
  var icon = React.createElement(IconComponent, Object.assign({
    size: size,
    strokeWidth: calculatedWeight + "px",
    color: "currentColor"
  }, rest));
  if (color) return React.createElement(Box, {
    as: "span",
    color: color
  }, icon);
  return icon;
}
DynamicIcon.displayName = 'DynamicIcon';
var _excluded$4 = ["children", "help", "optional"];
var FieldLabel = function FieldLabel(_ref) {
  var children = _ref.children,
    help = _ref.help,
    _ref$optional = _ref.optional,
    optional = _ref$optional === void 0 ? false : _ref$optional,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var context = useThemeUI();
  var wrappLabelField = get(context.theme, "forms.input.wrappLabelField");
  return jsx(Flex, Object.assign({
    sx: _extends({}, wrappLabelField)
  }, rest), jsx(Flex, {
    as: "span",
    className: 'label-field-text'
  }, children, help && jsx(Tooltip, {
    className: 'label-field-help',
    title: help
  }, jsx(DynamicIcon, {
    name: "HelpCircle",
    size: 16
  }))), optional && jsx("span", {
    className: "label-field-optional"
  }, "Optional"));
};
FieldLabel.displayName = 'FieldLabel';
var _excluded$5 = ["disabled", "errorMessage", "errorMessageIcon", "iconLeft", "iconRight", "label", "labelHelp", "labelOptional", "prefixLeft", "prefixRight", "addonLeft", "addonRight", "type", "size", "variant", "caption", "captionIcon"];
var Textfield = function Textfield(_ref) {
  var disabled = _ref.disabled,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? '' : _ref$errorMessage,
    errorMessageIcon = _ref.errorMessageIcon,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    labelHelp = _ref.labelHelp,
    labelOptional = _ref.labelOptional,
    prefixLeft = _ref.prefixLeft,
    prefixRight = _ref.prefixRight,
    addonLeft = _ref.addonLeft,
    addonRight = _ref.addonRight,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'input' : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'normal' : _ref$variant,
    caption = _ref.caption,
    captionIcon = _ref.captionIcon,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var context = useThemeUI();
  var variants = get(context.theme, "forms.input." + variant);
  var sizes = get(context.theme, "forms.input." + size);
  var container = get(context.theme, "forms.input.container");
  var containerSize = get(context.theme, "forms.input.container." + size);
  var containPrefLeft = get(context.theme, "forms.input.containPrefLeft");
  var wrapperPrefLeft = get(context.theme, "forms.input.wrapperPrefLeft");
  var limitPrefLeft = get(context.theme, "forms.input.limitPrefLeft");
  var wrappPrefLeftIconLeft = get(context.theme, "forms.input.wrappPrefLeftIconLeft");
  var wrappIconLeft = get(context.theme, "forms.input.wrappIconLeft");
  var wrappField = get(context.theme, "forms.input.wrappField");
  var wrappNormal = get(context.theme, "forms.input.wrappNormal");
  var wrappSuccess = get(context.theme, "forms.input.wrappSuccess");
  var wrappError = get(context.theme, "forms.input.wrappError");
  var wrappPrefRightIconRight = get(context.theme, "forms.input.wrappPrefRightIconRight");
  var wrappIconRight = get(context.theme, "forms.input.wrappIconRight");
  var containPrefRight = get(context.theme, "forms.input.containPrefRight");
  var limitPrefRight = get(context.theme, "forms.input.limitPrefRight");
  var wrapperPrefRight = get(context.theme, "forms.input.wrapperPrefRight");
  return jsx(React.Fragment, null, label && jsx(FieldLabel, {
    help: labelHelp,
    optional: labelOptional
  }, label), jsx("div", {
    className: "container-textfield",
    sx: _extends({}, container, containerSize)
  }, (prefixLeft || addonLeft) && jsx("div", {
    className: "contain-prefix-left",
    sx: _extends({}, containPrefLeft)
  }, jsx("span", {
    sx: _extends({}, wrapperPrefLeft)
  }, prefixLeft || addonLeft), jsx("span", {
    className: "limit-prefix-left",
    sx: _extends({}, limitPrefLeft)
  })), (prefixLeft || addonLeft) && iconLeft && jsx("span", {
    sx: _extends({}, wrappPrefLeftIconLeft)
  }, iconLeft) || iconLeft && jsx("span", {
    className: "wrap-icon-left",
    sx: _extends({}, wrappIconLeft)
  }, iconLeft), jsx(Input, Object.assign({}, rest, {
    disabled: disabled,
    sx: _extends({}, variants, sizes),
    type: type
  })), variant && disabled && jsx("div", {
    sx: _extends({}, wrappField)
  }) || variant === 'normal' && jsx("div", {
    className: "input-border",
    sx: _extends({}, wrappNormal)
  }) || variant === 'success' && jsx("div", {
    className: "input-border",
    sx: _extends({}, wrappSuccess)
  }) || variant === 'error' && jsx("div", {
    className: "input-border",
    sx: _extends({}, wrappError)
  }), (prefixRight || addonRight) && iconRight && jsx("span", {
    sx: _extends({}, wrappPrefRightIconRight)
  }, iconRight) || iconRight && jsx("span", {
    className: "wrap-icon-right",
    sx: _extends({}, wrappIconRight)
  }, iconRight), (prefixRight || addonRight) && jsx("div", {
    className: "contain-prefix-right",
    sx: _extends({}, containPrefRight)
  }, jsx("span", {
    className: "limit-prefix-right",
    sx: _extends({}, limitPrefRight)
  }), jsx("span", {
    sx: _extends({}, wrapperPrefRight)
  }, prefixRight || addonRight))), caption && jsx(FieldCaption, {
    variant: variant,
    icon: captionIcon
  }, caption), errorMessage && jsx(FieldCaption, {
    variant: "error",
    icon: errorMessageIcon
  }, errorMessage));
};
Textfield.displayName = 'Textfield';
var _excluded$6 = ["disabled", "label", "variant", "size", "sizeBox"];
var Checkbox = function Checkbox(_ref) {
  var disabled = _ref.disabled,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'check' : _ref$variant,
    size = _ref.size,
    sizeBox = _ref.sizeBox,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var sizes;
  var context = useThemeUI();
  var labels = get(context.theme, "forms.checkbox." + label);
  var variants = get(context.theme, "forms.checkbox." + variant);
  if (size) {
    sizes = get(context.theme, "forms.checkbox." + variant + "." + size);
  }
  if (sizeBox) {
    sizes = get(context.theme, "forms.checkbox." + variant + "." + sizeBox);
  }
  var sizeBoxLarge = get(context.theme, "forms.checkbox.sizeBoxLarge");
  var sizeBoxSmall = get(context.theme, "forms.checkbox.sizeBoxSmall");
  var wrappLabel = get(context.theme, "forms.checkbox.wrappLabel");
  return jsx(React.Fragment, null, label ? jsx("label", {
    sx: sizeBox === 'lg' || size === 'lg' ? _extends({}, sizeBoxLarge) : _extends({}, sizeBoxSmall)
  }, jsx(Input, Object.assign({
    disabled: disabled,
    sx: _extends({}, labels, variants, sizes),
    type: "checkbox"
  }, rest)), jsx("div", {
    sx: _extends({}, wrappLabel)
  }, label)) : jsx(Input, Object.assign({
    disabled: disabled,
    sx: _extends({}, labels, variants, sizes),
    type: "checkbox"
  }, rest)));
};
Checkbox.displayName = 'Checkbox';
var _excluded$7 = ["disabledAnchor", "disabled", "size", "type", "iconLeft", "iconRight", "children"];
var Anchor = function Anchor(_ref) {
  var disabledAnchor = _ref.disabledAnchor,
    disabled = _ref.disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var disabledTheme;
  var context = useThemeUI();
  var sizes = get(context.theme, "styles.a." + size);
  if (disabledAnchor || disabled) {
    disabledTheme = get(context.theme, "styles.a.disabled");
  }
  return jsx(React.Fragment, null, jsx(Link, Object.assign({}, rest, {
    sx: _extends({}, sizes, disabledTheme)
  }), iconLeft && size === 'lg' && jsx("span", {
    className: "wrapper-icon-left-large"
  }, iconLeft) || iconLeft && size === 'md' && jsx("span", {
    className: "wrapper-icon-left-medium"
  }, iconLeft) || iconLeft && size === 'sm' && jsx("span", {
    className: "wrapper-icon-left-small"
  }, iconLeft), children, iconRight && size === 'lg' && jsx("span", {
    className: "wrapper-icon-right-large"
  }, iconRight) || iconRight && size === 'md' && jsx("span", {
    className: "wrapper-icon-right-medium"
  }, iconRight) || iconRight && size === 'sm' && jsx("span", {
    className: "wrapper-icon-right-small"
  }, iconRight)));
};
Anchor.displayName = 'Anchor';
var _excluded$8 = ["background", "titleLoginPage", "descLoginPage", "formPosition", "logo", "disabledForm", "onChangeLogin", "onSubmitLogin", "form"];
var LoginPage = function LoginPage(_ref) {
  var background = _ref.background,
    _ref$titleLoginPage = _ref.titleLoginPage,
    titleLoginPage = _ref$titleLoginPage === void 0 ? '' : _ref$titleLoginPage,
    _ref$descLoginPage = _ref.descLoginPage,
    descLoginPage = _ref$descLoginPage === void 0 ? '' : _ref$descLoginPage,
    _ref$formPosition = _ref.formPosition,
    formPosition = _ref$formPosition === void 0 ? 'left' : _ref$formPosition,
    logo = _ref.logo,
    disabledForm = _ref.disabledForm,
    _ref$onChangeLogin = _ref.onChangeLogin,
    onChangeLogin = _ref$onChangeLogin === void 0 ? function () {} : _ref$onChangeLogin,
    _ref$onSubmitLogin = _ref.onSubmitLogin,
    onSubmitLogin = _ref$onSubmitLogin === void 0 ? function () {} : _ref$onSubmitLogin,
    form = _ref.form,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  var _React$useState = React.useState(''),
    email = _React$useState[0],
    setEmail = _React$useState[1];
  var _React$useState2 = React.useState(''),
    password = _React$useState2[0],
    setPassword = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    remember = _React$useState3[0],
    setRemember = _React$useState3[1];
  var _React$useState4 = React.useState(false),
    showPass = _React$useState4[0],
    setshowPass = _React$useState4[1];
  var onChangeFields = function onChangeFields(name, value) {
    if (name === 'email') {
      setEmail(value);
      return onChangeLogin({
        email: value,
        password: password,
        remember: remember
      });
    }
    if (name === 'password') {
      setPassword(value);
      return onChangeLogin({
        email: email,
        password: value,
        remember: remember
      });
    }
    if (name === 'remember') {
      setRemember(value);
      return onChangeLogin({
        email: email,
        password: password,
        remember: value
      });
    }
  };
  var onChangeEmail = function onChangeEmail(name, value) {
    onChangeFields(name, value);
  };
  var onChangePassword = function onChangePassword(name, value) {
    onChangeFields(name, value);
  };
  var onChangeRemember = function onChangeRemember(checked) {
    onChangeFields('remember', checked);
  };
  var onSubmit = function onSubmit() {
    var data = {
      email: email,
      password: password,
      remember: remember
    };
    onSubmitLogin(data);
    return data;
  };
  var _onSubmitLogin = function _onSubmitLogin(e) {
    e.preventDefault();
    var data = {
      email: email,
      password: password,
      remember: remember
    };
    return data;
  };
  var onClickShowPass = function onClickShowPass() {
    setshowPass(!showPass);
  };
  var position;
  if (formPosition === 'left') {
    position = 'form-side-left';
  } else if (formPosition === 'right') {
    position = 'form-side-right';
  } else {
    position = 'form-side-center';
  }
  return jsx(Container, Object.assign({}, rest), jsx("div", {
    className: formPosition === 'center' ? 'container-login-center' : 'container-login'
  }, form ? jsx("div", {
    className: position
  }, form) : jsx("div", {
    className: position
  }, jsx("div", {
    className: "container-logo"
  }, jsx("img", {
    alt: "logo",
    className: "wrapper-logo",
    src: logo
  })), jsx("div", {
    className: "wrapper-title"
  }, titleLoginPage), jsx("div", {
    className: "wrapper-desc"
  }, descLoginPage), jsx("form", {
    onSubmit: function onSubmit(e) {
      return _onSubmitLogin(e);
    }
  }, jsx(Textfield, {
    disabled: disabledForm,
    iconLeft: jsx(Mail, null),
    label: "Email Address",
    name: "email",
    onChange: function onChange(e) {
      return onChangeEmail(e.target.name, e.target.value);
    },
    placeholder: "Insert Email"
  }), jsx(Textfield, {
    disabled: disabledForm,
    iconLeft: jsx(Lock, null),
    iconRight: showPass ? jsx(Eye, {
      onClick: function onClick() {
        return onClickShowPass();
      }
    }) : jsx(EyeOff, {
      onClick: function onClick() {
        return onClickShowPass();
      }
    }),
    label: "Password",
    name: "password",
    onChange: function onChange(e) {
      return onChangePassword(e.target.name, e.target.value);
    },
    placeholder: "Insert Password",
    type: showPass ? 'text' : 'password'
  }), jsx("div", {
    className: "wrapper-remember"
  }, jsx(Checkbox, {
    disabled: disabledForm,
    label: "Remember me",
    onChange: function onChange(e) {
      return onChangeRemember(e.target.checked);
    }
  }), jsx(Anchor, {
    disabledAnchor: disabledForm
  }, "Forgot Password")), jsx(Button, {
    className: "wrapper-button",
    disabled: disabledForm,
    iconLeft: jsx(LogIn, null),
    onClick: function onClick() {
      return onSubmit();
    },
    size: "lg",
    type: "submit",
    variant: "solid"
  }, "Sign in")), jsx("div", {
    className: "wrapper-or"
  }, jsx("div", {
    className: "wrapper-line"
  }), jsx("div", {
    className: "or"
  }, "or"), jsx("div", {
    className: "wrapper-line"
  })), jsx(Button, {
    className: "wrapper-button",
    size: "md",
    variant: "outlineSecondary"
  }, "Sign in with Google"), jsx("br", null), jsx(Button, {
    className: "wrapper-button",
    size: "md",
    variant: "outlineSecondary"
  }, "Sign in with Facebook"), jsx("div", {
    className: "wrapper-register"
  }, "Don't have an account?\xA0", ' ', jsx(Anchor, {
    disabledAnchor: disabledForm
  }, "Register Now")), jsx("div", {
    className: "wrapper-footer"
  }, "\xA9 Legion Design System by Telkom Indonesia")), jsx("div", {
    className: "container-side-right"
  }, jsx("img", {
    alt: "wrapper-bg",
    className: "wrapper-background",
    src: background
  }))));
};
LoginPage.displayName = 'LoginPage';
var _excluded$9 = ["checked", "label", "sizeSwitch", "size"];
var Switch = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
    label = _ref.label,
    sizeSwitch = _ref.sizeSwitch,
    size = _ref.size,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  var sizes;
  var context = useThemeUI();
  if (size) {
    sizes = get(context.theme, "forms.switch." + size);
  }
  if (sizeSwitch) {
    sizes = get(context.theme, "forms.switch." + sizeSwitch);
  }
  return jsx(Switch$1, Object.assign({}, rest, {
    checked: checked,
    label: label,
    ref: ref,
    sx: _extends({}, sizes)
  }));
});
Switch.displayName = 'Switch';
var _excluded$a = ["label", "labelHelp", "labelOptional", "variant", "caption", "captionIcon", "errorMessage", "errorMessageIcon"];
var Textarea = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    labelHelp = _ref.labelHelp,
    labelOptional = _ref.labelOptional,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'normal' : _ref$variant,
    caption = _ref.caption,
    captionIcon = _ref.captionIcon,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? '' : _ref$errorMessage,
    errorMessageIcon = _ref.errorMessageIcon,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  var context = useThemeUI();
  var variants = get(context.theme, "forms.textarea." + variant);
  return jsx(React.Fragment, null, label && jsx(FieldLabel, {
    help: labelHelp,
    optional: labelOptional
  }, label), jsx(Textarea$1, Object.assign({}, rest, {
    ref: ref,
    sx: _extends({}, variants)
  })), caption && jsx(FieldCaption, {
    variant: variant,
    icon: captionIcon
  }, caption), errorMessage && jsx(FieldCaption, {
    variant: "error",
    icon: errorMessageIcon
  }, errorMessage));
});
Textarea.displayName = 'Textarea';
var Radio = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsx("div", {
    sx: {
      position: 'relative'
    }
  }, jsx(Radio$1, Object.assign({}, rest, {
    ref: ref,
    sx: {
      'input:checked ~ &': {
        border: '.5px solid #E42313',
        color: '#FFFFFF',
        background: '#E42313'
      }
    }
  })));
});
Radio.displayName = 'Radio';
var _excluded$b = ["variant", "size", "bordered"];
var sizeOption = {
  small: 'small',
  sm: 'small',
  large: 'large',
  lg: 'large'
};
var Badge = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$bordered = _ref.bordered,
    bordered = _ref$bordered === void 0 ? false : _ref$bordered,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  var context = useThemeUI();
  var variants = get(context.theme, "badges." + variant);
  var borders = get(context.theme, "badges." + (bordered ? sizeOption[size] + "WithBorder" : sizeOption[size] + "NoBorder"));
  var sizes = get(context.theme, "badges." + (rest.children ? sizeOption[size] + "WithContent" : sizeOption[size]));
  return jsx(Badge$1, Object.assign({
    ref: ref,
    sx: _extends({}, variants, sizes, borders)
  }, rest));
});
Badge.displayName = 'Badge';
var _excluded$c = ["ratio", "sx"];
var Image = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var ratio = _ref.ratio,
    sx = _ref.sx,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  // Regular image
  if (!ratio) return jsx(Image$1, Object.assign({
    sx: _extends({}, sx),
    ref: ref
  }, rest));
  // Image constrained by aspect ratio
  return jsx(AspectImage, Object.assign({
    ratio: ratio,
    sx: _extends({
      width: '100%',
      height: '100%'
    }, sx),
    ref: ref
  }, rest));
});
Image.displayName = 'Image';
var _excluded$d = ["size"];
var Avatar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'large' : _ref$size,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  var tableSize = {
    small: 32,
    sm: 32,
    medium: 40,
    md: 40,
    large: 64,
    lg: 64
  };
  return jsx(Avatar$1, Object.assign({
    height: tableSize[size],
    ref: ref,
    width: tableSize[size]
  }, rest));
});
Avatar.displayName = 'Avatar';
var _excluded$e = ["color", "size", "responsive", "children"];
var Heading = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var color = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'h2' : _ref$size,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? false : _ref$responsive,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  var context = useThemeUI();
  var sizes = get(context.theme, "text.heading." + size);
  var textColors = get(context.theme, "styles.text." + color);
  var newSize;
  switch (size) {
    case 'h1':
      newSize = 'h1Respon';
      break;
    case 'h2':
      newSize = 'h2Respon';
      break;
    case 'h3':
      newSize = 'h3Respon';
      break;
    case 'h4':
      newSize = 'h4Respon';
      break;
    case 'h5':
      newSize = 'h5Respon';
      break;
    case 'h6':
      newSize = 'h6Respon';
      break;
  }
  var sizesResponsive = get(context.theme, "text.heading." + newSize);
  var responsiveHeading = responsive ? _extends({}, sizesResponsive) : _extends({}, sizes);
  return jsx(Heading$1, Object.assign({}, rest, {
    as: size,
    ref: ref,
    sx: _extends({}, textColors, responsiveHeading)
  }), children);
});
Heading.displayName = 'Heading';
var _excluded$f = ["color", "size", "responsive", "children"];
var Body = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var color = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg_regular' : _ref$size,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? false : _ref$responsive,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  var context = useThemeUI();
  var sizes = get(context.theme, "text.default." + size);
  var textColors = get(context.theme, "styles.text." + color);
  var newSize;
  switch (size) {
    case 'lg_regular':
      newSize = 'lg_regular_respon';
      break;
    case 'lg_semibold':
      newSize = 'lg_semibold_respon';
      break;
    case 'lg_bold':
      newSize = 'lg_bold_respon';
      break;
    case 'lg_italic':
      newSize = 'lg_italic_respon';
      break;
    case 'lg_underline':
      newSize = 'lg_underline_respon';
      break;
    case 'lg_underline_semibold':
      newSize = 'lg_underline_semibold_respon';
      break;
    case 'lg_underline_bold':
      newSize = 'lg_underline_bold_respon';
      break;
    case 'sm_regular':
      newSize = 'sm_regular_respon';
      break;
    case 'sm_semibold':
      newSize = 'sm_semibold_respon';
      break;
    case 'sm_bold':
      newSize = 'sm_bold_respon';
      break;
    case 'sm_italic':
      newSize = 'sm_italic_respon';
      break;
    case 'sm_underline':
      newSize = 'sm_underline_respon';
      break;
    case 'sm_underline_semibold':
      newSize = 'sm_underline_semibold_respon';
      break;
    case 'sm_underline_bold':
      newSize = 'sm_underline_bold_respon';
      break;
    default:
      newSize = 'lg_regular';
  }
  var sizesResponsive = get(context.theme, "text.default." + newSize);
  var responsiveBody = responsive ? _extends({}, sizesResponsive) : _extends({}, sizes);
  return jsx(Text, Object.assign({}, rest, {
    ref: ref,
    sx: _extends({}, textColors, responsiveBody)
  }), children);
});
Body.displayName = 'Body';
var _excluded$g = ["color", "size", "responsive", "children"];
var Caption = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var color = _ref.color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'lg_regular' : _ref$size,
    _ref$responsive = _ref.responsive,
    responsive = _ref$responsive === void 0 ? false : _ref$responsive,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$g);
  var context = useThemeUI();
  var sizes = get(context.theme, "text.default.sizes." + size);
  var textColors = get(context.theme, "styles.text." + color);
  var newSize;
  switch (size) {
    case 'lg_regular':
      newSize = 'lg_regular_respon';
      break;
    case 'lg_semibold':
      newSize = 'lg_semibold_respon';
      break;
    case 'lg_bold':
      newSize = 'lg_bold_respon';
      break;
    case 'lg_italic':
      newSize = 'lg_italic_respon';
      break;
    case 'lg_underline':
      newSize = 'lg_underline_respon';
      break;
    case 'lg_underline_semibold':
      newSize = 'lg_underline_semibold_respon';
      break;
    case 'lg_underline_bold':
      newSize = 'lg_underline_bold_respon';
      break;
    case 'sm_regular':
      newSize = 'sm_regular_respon';
      break;
    case 'sm_semibold':
      newSize = 'sm_semibold_respon';
      break;
    case 'sm_bold':
      newSize = 'sm_bold_respon';
      break;
    case 'sm_italic':
      newSize = 'sm_italic_respon';
      break;
    case 'sm_underline':
      newSize = 'sm_underline_respon';
      break;
    case 'sm_underline_semibold':
      newSize = 'sm_underline_semibold_respon';
      break;
    case 'sm_underline_bold':
      newSize = 'sm_underline_bold_respon';
      break;
    default:
      newSize = 'lg_regular';
  }
  var sizesResponsive = get(context.theme, "text.default.sizes." + newSize);
  var responsiveCaption = responsive ? _extends({}, sizesResponsive) : _extends({}, sizes);
  return jsx(Text, Object.assign({}, rest, {
    ref: ref,
    sx: _extends({}, textColors, responsiveCaption)
  }), children);
});
Caption.displayName = 'Caption';
var _excluded$h = ["size", "variant", "children"];
var Spinner = function Spinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$h);
  var context = useThemeUI();
  var variants = get(context.theme, "spinner." + variant);
  return jsx(React.Fragment, null, size === 'sm' && jsx(Spinner$1, Object.assign({
    size: 24,
    strokeWidth: 4,
    sx: _extends({}, variants)
  }, rest)), size === 'md' && jsx(Spinner$1, Object.assign({
    sx: _extends({}, variants)
  }, rest)), size === 'lg' && jsx(Spinner$1, Object.assign({
    size: 72,
    strokeWidth: 6,
    sx: _extends({}, variants)
  }, rest)));
};
Spinner.displayName = 'Spinner';
var _excluded$i = ["desc", "onClose", "title", "variant"];
var Alert = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var desc = _ref.desc,
    onClose = _ref.onClose,
    title = _ref.title,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'info' : _ref$variant,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$i);
  var context = useThemeUI();
  var variants = get(context.theme, "alerts." + variant);
  var variantIcon = variant === 'info' ? 'infoIcon' : variant === 'warning' ? 'warningIcon' : variant === 'success' ? 'successIcon' : variant === 'error' ? 'errorIcon' : 'infoIcon';
  var variantsIcon = get(context.theme, "alerts." + variantIcon);
  var outerWrapper = get(context.theme, "alerts.outerWrapper");
  var iconWrapper = get(context.theme, "alerts.iconWrapper");
  var titleMargin = get(context.theme, "alerts.titleMargin");
  var descMargin = get(context.theme, "alerts.descMargin");
  var alertTitle = get(context.theme, "alerts.title");
  var alertDesc = get(context.theme, "alerts.desc");
  var close = get(context.theme, "alerts.close");
  return jsx(Alert$1, Object.assign({
    ref: ref,
    sx: _extends({}, variants, {
      borderLeftWidth: 5
    })
  }, rest), jsx(Box, {
    sx: _extends({}, outerWrapper)
  }, jsx("div", {
    sx: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, jsx("div", {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, jsx("div", {
    sx: _extends({}, titleMargin)
  }, jsx("div", {
    sx: _extends({}, variantsIcon, iconWrapper, {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    })
  }, jsx(DynamicIcon, {
    name: variant === 'info' ? 'Info' : variant === 'warning' ? 'AlertTriangle' : variant === 'success' ? 'Check' : variant === 'error' ? 'X' : 'Info',
    size: 14,
    color: "white",
    strokeWidth: 3
  }))), jsx(Text, {
    sx: _extends({}, alertTitle)
  }, title)), jsx(Close, {
    onClick: onClose,
    sx: _extends({}, close)
  })), jsx("div", {
    sx: _extends({}, descMargin)
  }, jsx(Text, {
    sx: _extends({}, alertDesc)
  }, desc))));
});
Alert.displayName = 'Alert';
var _excluded$j = ["children", "isCompact", "isBordered", "mode", "variant"];
var Navbar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$isCompact = _ref.isCompact,
    isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact,
    _ref$isBordered = _ref.isBordered,
    isBordered = _ref$isBordered === void 0 ? false : _ref$isBordered,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'light' : _ref$mode,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'static' : _ref$variant,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$j);
  var context = useThemeUI();
  var navbarMode = get(context.theme, "navbar.mode." + mode);
  var navbarPosition = get(context.theme, "navbar.variant." + variant);
  return jsx(Flex, Object.assign({
    as: "nav",
    ref: ref,
    sx: _extends({
      border: variant === 'floating' && isBordered && "1px solid " + color.tertiary200,
      p: "0px " + spacer.spacing8,
      height: isCompact ? '0px' : "" + spacer.spacing14,
      justifyContent: 'space-between',
      alignItems: 'center'
    }, navbarMode, navbarPosition)
  }, rest), children);
});
Navbar.displayName = 'Navbar';
var NavbarBrand = function NavbarBrand(_ref) {
  var children = _ref.children;
  var context = useThemeUI();
  var defaultStyle = get(context.theme, "navbar.navbarBrand");
  return jsx(Box, {
    sx: _extends({}, defaultStyle)
  }, children);
};
NavbarBrand.displayName = 'NavbarBrand';
var NavbarContent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$hideIn = _ref.hideIn,
    hideIn = _ref$hideIn === void 0 ? 'md' : _ref$hideIn;
  var context = useThemeUI();
  var defaultStyle = get(context.theme, "navbar.navbarContent.default");
  var hideInStyle = get(context.theme, "navbar.hideIn." + hideIn);
  return jsx("ul", {
    ref: ref,
    sx: _extends({}, defaultStyle, hideInStyle)
  }, children);
});
NavbarContent.displayName = 'NavbarContent';
var NavbarCollapse = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive;
  var context = useThemeUI();
  var defaultStyle = get(context.theme, "navbar.navbarCollapse");
  return jsx(Box, {
    ref: ref,
    sx: _extends({
      display: isActive ? 'block' : 'none'
    }, defaultStyle)
  }, children);
});
NavbarCollapse.displayName = 'NavbarCollapse';
var NavbarItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    href = _ref.href,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive;
  var literalPath = 'navbar.navbarItem.active';
  var context = useThemeUI();
  var activeStyle = get(context.theme, literalPath);
  // const activeStyleAnchor = get(context.theme, `${literalPath}.a`);
  return jsx("li", {
    ref: ref,
    sx: isActive && _extends({}, activeStyle)
  }, jsx("a", {
    href: href
  }, children));
});
NavbarItem.displayName = 'NavbarItem';
var NavbarToggle = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var onClick = _ref.onClick,
    _ref$showIn = _ref.showIn,
    showIn = _ref$showIn === void 0 ? 'md' : _ref$showIn;
  var context = useThemeUI();
  var showInStyle = get(context.theme, "navbar.showIn." + showIn);
  return jsx(Button, {
    iconLeft: jsx(DynamicIcon, {
      name: "Menu"
    }),
    onClick: onClick,
    ref: ref,
    sx: _extends({}, showInStyle),
    variant: "transparent"
  });
});
NavbarToggle.displayName = 'NavbarToggle';
var _excluded$k = ["children", "logo", "title", "variant"];
var Navigation = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    logo = _ref.logo,
    title = _ref.title,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$k);
  var context = useThemeUI();
  var variants = get(context.theme, "links." + variant);
  return jsx(Flex, Object.assign({
    as: "nav",
    ref: ref,
    sx: {
      justifyContent: 'space-between',
      p: '0.5rem 1rem'
    }
  }, rest, variants), jsx(Flex, {
    sx: {
      alignItems: 'center'
    }
  }, logo && logo, title && jsx(Heading, {
    size: "h5",
    sx: {
      ml: '0.5rem'
    }
  }, title)), children && jsx(Box, {
    sx: {
      display: 'flex',
      placeItems: 'center'
    }
  }, children));
});
Navigation.displayName = 'Navigation';
var _excluded$l = ["variant", "isHoverable", "isPressable", "hoverable", "pressable", "bg", "background", "color", "borderColor", "elevation", "sx", "children"];
var Card = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'flat' : _ref$variant,
    _ref$isHoverable = _ref.isHoverable,
    isHoverable = _ref$isHoverable === void 0 ? false : _ref$isHoverable,
    _ref$isPressable = _ref.isPressable,
    isPressable = _ref$isPressable === void 0 ? false : _ref$isPressable,
    hoverable = _ref.hoverable,
    pressable = _ref.pressable,
    bg = _ref.bg,
    background = _ref.background,
    color = _ref.color,
    borderColor = _ref.borderColor,
    elevation = _ref.elevation,
    sx = _ref.sx,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$l);
  var context = useThemeUI();
  var styles = get(context.theme, 'cards.base');
  var variantStyles = get(context.theme, "cards." + variant);
  var hoverableStyles = (isHoverable || hoverable) && get(context.theme, 'cards.hoverable');
  var pressableStyles = (isPressable || pressable) && get(context.theme, 'cards.pressable');
  var elevationStyles = get(context.theme, "styles.elevation." + elevation);
  return jsx(Card$1, Object.assign({
    ref: ref,
    sx: _extends({}, styles, variantStyles, hoverableStyles, pressableStyles, {
      bg: bg,
      background: background,
      color: color,
      borderColor: borderColor
    }, elevationStyles, sx),
    role: isPressable || pressable ? 'button' : undefined,
    tabIndex: isPressable || pressable ? 0 : undefined
  }, rest), children);
});
Card.displayName = 'Card';
var _excluded$m = ["sx", "children"];
var CardBody = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var sx = _ref.sx,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$m);
  var context = useThemeUI();
  var styles = get(context.theme, 'cards.body');
  return jsx(Box, Object.assign({
    ref: ref,
    sx: _extends({}, styles, sx)
  }, rest), children);
});
CardBody.displayName = 'CardBody';
var _excluded$n = ["sx", "children"];
var CardFooter = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var sx = _ref.sx,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$n);
  var context = useThemeUI();
  var styles = get(context.theme, 'cards.footer');
  return jsx(Box, Object.assign({
    ref: ref,
    sx: _extends({}, styles, sx)
  }, rest), children);
});
CardFooter.displayName = 'CardFooter';
var _excluded$o = ["sx", "children"];
var CardHeader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var sx = _ref.sx,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$o);
  var context = useThemeUI();
  var styles = get(context.theme, 'cards.header');
  return jsx(Box, Object.assign({
    ref: ref,
    sx: _extends({}, styles, sx)
  }, rest), children);
});
CardHeader.displayName = 'CardHeader';
var _excluded$p = ["children", "badge", "cardTitle", "date", "logo", "subtitle", "supportingSubtitle", "totalPayment"];
var PaymentCard = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$badge = _ref.badge,
    badge = _ref$badge === void 0 ? null : _ref$badge,
    cardTitle = _ref.cardTitle,
    date = _ref.date,
    _ref$logo = _ref.logo,
    logo = _ref$logo === void 0 ? null : _ref$logo,
    subtitle = _ref.subtitle,
    supportingSubtitle = _ref.supportingSubtitle,
    totalPayment = _ref.totalPayment,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$p);
  return jsx(Box, Object.assign({
    ref: ref,
    sx: {
      bg: 'primary',
      borderRadius: '.5rem',
      boxShadow: '0 0 2px 3px rgba(0, 0, 0, .125)',
      p: '1.5rem'
    }
  }, rest), jsx(Flex, {
    sx: {
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, jsx("div", null, logo, cardTitle && jsx(Body, {
    sx: {
      ml: '.5rem'
    },
    variant: "lg_bold"
  }, cardTitle), date && jsx(Caption, {
    size: "sm_regular",
    sx: {
      ml: '1rem',
      mr: '1.5rem'
    }
  }, date), badge), totalPayment && jsx(Body, {
    variant: "sm_bold"
  }, totalPayment)), jsx("div", {
    sx: {
      marginTop: '1.5rem'
    }
  }, subtitle && jsx(Caption, {
    size: "sm_regular",
    sx: {
      display: 'block'
    }
  }, subtitle), supportingSubtitle && jsx(Body, {
    variant: "sm_bold"
  }, supportingSubtitle)));
});
PaymentCard.displayName = 'PaymentCard';
var _excluded$q = ["variant"];
var ColorsCard = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary500' : _ref$variant,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$q);
  var context = useThemeUI();
  var variants = get(context.theme, "colorscard." + variant);
  var containerColors = get(context.theme, 'colorscard.containerColors');
  var wrappValueColors = get(context.theme, 'colorscard.wrappValueColors');
  var valVariants;
  switch (variant) {
    case 'primary25':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'primary50':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'primary100':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'primary200':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'primary300':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'primary400':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'primary500':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'primary600':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'primary700':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'primary800':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'primary900':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'secondary25':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'secondary50':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'secondary100':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'secondary200':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'secondary300':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'secondary400':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'secondary500':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'secondary600':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'secondary700':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'secondary800':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'secondary900':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'tertiary25':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'tertiary50':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'tertiary100':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'tertiary200':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'tertiary300':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'tertiary400':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'tertiary500':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'tertiary600':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'tertiary700':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'tertiary800':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'tertiary900':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'success25':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'success50':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'success100':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'success200':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'success300':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'success400':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'success500':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'success600':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'success700':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'success800':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'success900':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'warning25':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'warning50':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'warning100':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'warning200':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'warning300':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'warning400':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'warning500':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'warning600':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'warning700':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'warning800':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'warning900':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'error25':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'error50':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'error100':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'error200':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'error300':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'error400':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'error500':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'error600':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'error700':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'error800':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'error900':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'info25':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'info50':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'info100':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'info200':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'info300':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'info400':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'info500':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'info600':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'info700':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'info800':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
    case 'info900':
      valVariants = variants == null ? void 0 : variants.backgroundColor;
      break;
  }
  return jsx("span", {
    sx: _extends({}, containerColors)
  }, jsx(Card$1, Object.assign({}, rest, {
    ref: ref,
    sx: _extends({}, variants)
  }), valVariants), jsx("div", {
    sx: _extends({}, wrappValueColors)
  }, variant));
});
ColorsCard.displayName = 'ColorsCard';
var _excluded$r = ["children", "id", "title", "leftIcon", "iconLeft", "iconRight", "isBordered", "bordered", "isMenu", "isMenuActive"];
var Accordion = function Accordion(_ref) {
  var children = _ref.children,
    id = _ref.id,
    title = _ref.title,
    leftIcon = _ref.leftIcon,
    iconLeft = _ref.iconLeft,
    iconRight = _ref.iconRight,
    isBordered = _ref.isBordered,
    bordered = _ref.bordered,
    isMenu = _ref.isMenu,
    isMenuActive = _ref.isMenuActive,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$r);
  var AccordionContext = useThemeUI();
  var accordion = get(AccordionContext.theme, 'accordion');
  return jsx(Box, Object.assign({
    sx: _extends({
      textAlign: 'left'
    }, accordion)
  }, rest), jsx("input", {
    type: "checkbox",
    name: "collapse",
    id: "" + id
  }), jsx("label", {
    htmlFor: "" + id,
    className: (isBordered || bordered ? '' : 'menu-label') + " " + (isMenu ? 'is-menu' : '') + " " + (isMenuActive ? 'is-menu-active' : '')
  }, (leftIcon || iconLeft) && jsx("span", {
    className: "left-icon"
  }, iconLeft ? iconLeft : jsx(DynamicIcon, {
    name: leftIcon || 'Activity',
    size: 16
  })), title && title, iconRight && jsx("span", {
    className: 'right-icon'
  }, iconRight), jsx(DynamicIcon, {
    className: "toggle-down",
    name: "ChevronDown",
    size: 16
  }), jsx(DynamicIcon, {
    className: "toggle-up",
    name: "ChevronUp",
    size: 16
  })), jsx("div", {
    className: "content " + (isBordered || bordered ? '' : 'menu-content')
  }, children));
};
Accordion.displayName = 'Accordion';
var _excluded$s = ["children", "listItems", "activeMenu"];
var navLinkMenu = function navLinkMenu(id, route, icon, title, isActive, isHidden, badgeMenu, onClick) {
  return jsx("div", null, !isHidden && jsx(NavLink, {
    href: route,
    key: id,
    className: isActive ? 'active' : '',
    sx: {
      display: 'flex',
      alignItems: 'center',
      margin: '0 !important'
    },
    onClick: onClick
  }, icon && jsx(DynamicIcon, {
    name: icon
  }), jsx("span", null, title), badgeMenu && jsx(Badge, {
    size: "small",
    variant: "secondary",
    className: 'badgeMenu'
  }, badgeMenu)));
};
var _renderListItems = function _renderListItems(listItems, activeMenu) {
  return jsx(React.Fragment, null, listItems.map(function (val, idx) {
    var isActive = (val == null ? void 0 : val.title) === activeMenu;
    return jsx("div", {
      key: idx
    }, !(val != null && val.isParent) && navLinkMenu(idx, val == null ? void 0 : val.route, val == null ? void 0 : val.icon, val == null ? void 0 : val.title, isActive, val == null ? void 0 : val.isHidden, val == null ? void 0 : val.badgeMenu, val == null ? void 0 : val.onClick), (val == null ? void 0 : val.isParent) && (val == null ? void 0 : val.submenuItems) && jsx(Accordion, {
      id: "navLink_" + idx,
      title: val == null ? void 0 : val.title,
      leftIcon: val == null ? void 0 : val.icon,
      iconRight: val != null && val.badgeMenu ? jsx(Badge, {
        size: "small",
        variant: "secondary",
        className: 'badgeMenu'
      }, val == null ? void 0 : val.badgeMenu) : '',
      isBordered: false,
      isMenu: true,
      isMenuActive: isActive
    }, val == null ? void 0 : val.submenuItems.map(function (child, id) {
      var isChildActive = (child == null ? void 0 : child.title) === activeMenu;
      return jsx("div", {
        key: id
      }, navLinkMenu(id, child == null ? void 0 : child.route, child == null ? void 0 : child.icon, child == null ? void 0 : child.title, isChildActive, child == null ? void 0 : child.isHidden, child == null ? void 0 : child.badgeMenu, child == null ? void 0 : child.onClick));
    })));
  }));
};
var SidebarNavLink = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$listItems = _ref.listItems,
    listItems = _ref$listItems === void 0 ? [] : _ref$listItems,
    _ref$activeMenu = _ref.activeMenu,
    activeMenu = _ref$activeMenu === void 0 ? "" : _ref$activeMenu,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$s);
  var context = useThemeUI();
  var nav = get(context.theme, "sidebar");
  return jsx(Flex, Object.assign({
    as: "nav",
    ref: ref,
    sx: _extends({
      flexDirection: 'column'
    }, nav)
  }, rest, {
    "aria-label": "Sidebar"
  }), children && jsx("div", {
    className: 'sidebar-top-content'
  }, children), jsx("div", {
    className: 'sidebar-menu-wrapper'
  }, _renderListItems(listItems, activeMenu)));
});
SidebarNavLink.displayName = 'SidebarNavLink';
var _excluded$t = ["children"];
var Table = function Table(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$t);
  var context = useThemeUI();
  var tables = get(context.theme, "table");
  return jsx(React.Fragment, null, jsx("table", Object.assign({}, rest, {
    sx: _extends({}, tables)
  }), children));
};
Table.displayName = 'Table';
var _excluded$u = ["children"];
var TableCell = function TableCell(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$u);
  var context = useThemeUI();
  var tableCells = get(context.theme, "tableCell");
  return jsx(React.Fragment, null, jsx("td", Object.assign({}, rest, {
    sx: _extends({}, tableCells)
  }), children));
};
TableCell.displayName = 'TableCell';
var _excluded$v = ["children"];
var HeadCell = function HeadCell(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$v);
  var context = useThemeUI();
  var headCells = get(context.theme, "headCell");
  return jsx(React.Fragment, null, jsx("th", Object.assign({}, rest, {
    sx: _extends({}, headCells)
  }), children));
};
HeadCell.displayName = 'HeadCell';
var _excluded$w = ["children"];
var TableRow = function TableRow(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$w);
  var context = useThemeUI();
  var tableRows = get(context.theme, "tableRow");
  return jsx(React.Fragment, null, jsx("tr", Object.assign({}, rest, {
    sx: _extends({}, tableRows)
  }), children));
};
TableRow.displayName = 'TableRow';
var _excluded$x = ["children"];
var TableHead = function TableHead(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$x);
  return jsx(React.Fragment, null, jsx("thead", Object.assign({}, rest), children));
};
TableHead.displayName = 'TableHead';
var _excluded$y = ["children"];
var TableBody = function TableBody(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$y);
  return jsx(React.Fragment, null, jsx("tbody", Object.assign({}, rest), children));
};
TableBody.displayName = 'TableBody';
var _excluded$z = ["label", "iconLeft", "hint", "size", "variant", "caption", "captionIcon", "async", "cacheOptions", "loadOptions"],
  _excluded2 = ["children"];
var Select = function Select(_ref) {
  var label = _ref.label,
    iconLeft = _ref.iconLeft,
    hint = _ref.hint,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'normal' : _ref$variant,
    caption = _ref.caption,
    captionIcon = _ref.captionIcon,
    async = _ref.async,
    _ref$cacheOptions = _ref.cacheOptions,
    cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions,
    loadOptions = _ref.loadOptions,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$z);
  var context = useThemeUI();
  var styleSelect = get(context.theme, "select");
  var styleIconLeft = get(context.theme, "select.iconLeft." + size);
  var styleSelectLabel = get(context.theme, "select.label." + variant);
  var styleSelectHint = get(context.theme, "select.hint");
  var styleSelectCaption = get(context.theme, "select.caption." + variant);
  var styleSelectCaptionIcon = get(context.theme, "select.caption.icon");
  var styleSelectCaptionText = get(context.theme, "select.caption.text");
  // style react-select component
  var styleCoreControl = get(context.theme, "select.core.control." + size + "." + variant);
  var styleCoreMenu = get(context.theme, "select.core.menu");
  var styleCoreOption = get(context.theme, "select.core.option." + size);
  var styleCorePlaceholder = get(context.theme, "select.core.placeholder." + size);
  var styleCoreIndicatorsContainer = get(context.theme, "select.core.indicatorsContainer");
  var styleCoreIndicator = get(context.theme, "select.core.dropdownIndicator");
  var styleCoreMultiValue = get(context.theme, "select.core.multiValue");
  var styleCoreMultiValueLabel = get(context.theme, "select.core.multiValueLabel");
  var styleCoreMultiValueRemove = get(context.theme, "select.core.multiValueRemove");
  var stylesCore = {
    control: function control(provided, state) {
      return _extends({}, provided, styleCoreControl, {
        background: state.isDisabled ? color.tertiary100 : '#ffffff',
        borderColor: state.isDisabled ? color.tertiary300 + " !important" : 'inherit'
      });
    },
    indicatorSeparator: function indicatorSeparator() {
      return {
        display: 'none'
      };
    },
    indicatorsContainer: function indicatorsContainer(provided) {
      return _extends({}, provided, styleCoreIndicatorsContainer);
    },
    dropdownIndicator: function dropdownIndicator(provided) {
      return _extends({}, provided, styleCoreIndicator);
    },
    clearIndicator: function clearIndicator(provided) {
      return _extends({}, provided, {
        padding: '4px'
      });
    },
    menu: function menu(provided) {
      return _extends({}, provided, styleCoreMenu);
    },
    option: function option(provided, state) {
      return _extends({}, provided, styleCoreOption, {
        backgroundColor: state.isSelected ? styleCoreMultiValue.background : null,
        color: state.isSelected ? styleCoreMultiValueLabel.color : null
      });
    },
    multiValue: function multiValue(provided) {
      return _extends({}, provided, styleCoreMultiValue);
    },
    multiValueLabel: function multiValueLabel(provided) {
      return _extends({}, provided, styleCoreMultiValueLabel);
    },
    multiValueRemove: function multiValueRemove(provided) {
      return _extends({}, provided, styleCoreMultiValueRemove);
    },
    placeholder: function placeholder(provided) {
      return _extends({}, provided, styleCorePlaceholder);
    },
    valueContainer: function valueContainer(provided) {
      return _extends({}, provided, {
        padding: '0 0 0 8px'
      });
    },
    input: function input(provided) {
      return _extends({}, provided, {
        margin: 0
      });
    }
  };
  var Control = function Control(_ref2) {
    var children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return jsx(components.Control, Object.assign({}, props), iconLeft && jsx("span", {
      sx: _extends({}, styleIconLeft)
    }, iconLeft), " ", children);
  };
  return jsx("div", {
    sx: _extends({}, styleSelect)
  }, (label == null ? void 0 : label.length) && jsx("span", {
    sx: _extends({}, styleSelectLabel)
  }, label), async ? jsx(AsyncSelect, {
    defaultOptions: true,
    cacheOptions: cacheOptions,
    loadOptions: loadOptions,
    components: {
      Control: Control
    },
    styles: stylesCore,
    id: "rect-select",
    instanceId: "react-select"
  }) : jsx(ReactSelect, Object.assign({
    components: {
      Control: Control
    },
    id: "rect-select",
    instanceId: "react-select",
    styles: stylesCore
  }, rest)), (caption == null ? void 0 : caption.length) && jsx("span", {
    sx: _extends({}, styleSelectCaption)
  }, captionIcon && jsx("span", {
    sx: _extends({}, styleSelectCaptionIcon)
  }, captionIcon), jsx("span", {
    sx: _extends({}, styleSelectCaptionText)
  }, caption)), (hint == null ? void 0 : hint.length) && jsx("span", {
    sx: _extends({}, styleSelectHint)
  }, hint));
};
Select.displayName = 'Select';
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(function (_, c) {
  // todo support Wo (ISO week)
  var proto = c.prototype;
  var oldFormat = proto.format;
  proto.format = function f(formatStr) {
    var str = (formatStr || '').replace('Wo', 'wo');
    return oldFormat.bind(this)(str);
  };
});
var localeMap = {
  // ar_EG:
  // az_AZ:
  // bg_BG:
  bn_BD: 'bn-bd',
  by_BY: 'be',
  // ca_ES:
  // cs_CZ:
  // da_DK:
  // de_DE:
  // el_GR:
  en_GB: 'en-gb',
  en_US: 'en',
  // es_ES:
  // et_EE:
  // fa_IR:
  // fi_FI:
  fr_BE: 'fr',
  fr_CA: 'fr-ca',
  // fr_FR:
  // ga_IE:
  // gl_ES:
  // he_IL:
  // hi_IN:
  // hr_HR:
  // hu_HU:
  hy_AM: 'hy-am',
  id_ID: 'id',
  // is_IS:
  // it_IT:
  // ja_JP:
  // ka_GE:
  // kk_KZ:
  // km_KH:
  kmr_IQ: 'ku',
  // kn_IN:
  // ko_KR:
  // ku_IQ: // previous ku in antd
  // lt_LT:
  // lv_LV:
  // mk_MK:
  // ml_IN:
  // mn_MN:
  // ms_MY:
  // nb_NO:
  // ne_NP:
  nl_BE: 'nl-be',
  // nl_NL:
  // pl_PL:
  pt_BR: 'pt-br',
  // pt_PT:
  // ro_RO:
  // ru_RU:
  // sk_SK:
  // sl_SI:
  // sr_RS:
  // sv_SE:
  // ta_IN:
  // th_TH:
  // tr_TR:
  // uk_UA:
  // ur_PK:
  // vi_VN:
  zh_CN: 'zh-cn',
  zh_HK: 'zh-hk',
  zh_TW: 'zh-tw'
};
var parseLocale = function parseLocale(locale) {
  var mapLocale = localeMap[locale];
  return mapLocale || locale.split('_')[0];
};
var parseNoMatchNotice = function parseNoMatchNotice() {
  /* istanbul ignore next */
  noteOnce(false, 'Not match any format. Please help to fire a issue about this.');
};
var generateConfig = {
  // get
  getNow: function getNow() {
    return dayjs();
  },
  getFixedDate: function getFixedDate(string) {
    return dayjs(string, ['YYYY-M-DD', 'YYYY-MM-DD']);
  },
  getEndDate: function getEndDate(date) {
    return date.endOf('month');
  },
  getWeekDay: function getWeekDay(date) {
    var clone = date.locale('id');
    return clone.weekday() + clone.localeData().firstDayOfWeek();
  },
  getYear: function getYear(date) {
    return date.year();
  },
  getMonth: function getMonth(date) {
    return date.month();
  },
  getDate: function getDate(date) {
    return date.date();
  },
  getHour: function getHour(date) {
    return date.hour();
  },
  getMinute: function getMinute(date) {
    return date.minute();
  },
  getSecond: function getSecond(date) {
    return date.second();
  },
  // set
  addYear: function addYear(date, diff) {
    return date.add(diff, 'year');
  },
  addMonth: function addMonth(date, diff) {
    return date.add(diff, 'month');
  },
  addDate: function addDate(date, diff) {
    return date.add(diff, 'day');
  },
  setYear: function setYear(date, year) {
    return date.year(year);
  },
  setMonth: function setMonth(date, month) {
    return date.month(month);
  },
  setDate: function setDate(date, num) {
    return date.date(num);
  },
  setHour: function setHour(date, hour) {
    return date.hour(hour);
  },
  setMinute: function setMinute(date, minute) {
    return date.minute(minute);
  },
  setSecond: function setSecond(date, second) {
    return date.second(second);
  },
  // Compare
  isAfter: function isAfter(date1, date2) {
    return date1.isAfter(date2);
  },
  isValidate: function isValidate(date) {
    return date.isValid();
  },
  locale: {
    getWeekFirstDay: function getWeekFirstDay(locale) {
      return dayjs().locale(parseLocale(locale)).localeData().firstDayOfWeek();
    },
    getWeekFirstDate: function getWeekFirstDate(locale, date) {
      return date.locale(parseLocale(locale)).weekday(0);
    },
    getWeek: function getWeek(locale, date) {
      return date.locale(parseLocale(locale)).week();
    },
    getShortWeekDays: function getShortWeekDays(locale) {
      return dayjs().locale(parseLocale(locale)).localeData().weekdaysMin();
    },
    getShortMonths: function getShortMonths(locale) {
      return dayjs().locale(parseLocale(locale)).localeData().monthsShort();
    },
    format: function format(locale, date, _format) {
      return date.locale(parseLocale(locale)).format(_format);
    },
    parse: function parse(locale, text, formats) {
      var localeStr = parseLocale(locale);
      for (var i = 0; i < formats.length; i += 1) {
        var format = formats[i];
        var formatText = text;
        if (format.includes('wo') || format.includes('Wo')) {
          // parse Wo
          var year = formatText.split('-')[0];
          var weekStr = formatText.split('-')[1];
          var firstWeek = dayjs(year, 'YYYY').startOf('year').locale(localeStr);
          for (var j = 0; j <= 52; j += 1) {
            var nextWeek = firstWeek.add(j, 'week');
            if (nextWeek.format('Wo') === weekStr) {
              return nextWeek;
            }
          }
          parseNoMatchNotice();
          return null;
        }
        var date = dayjs(formatText, format).locale(localeStr);
        if (date.isValid()) {
          return date;
        }
      }
      if (text) {
        parseNoMatchNotice();
      }
      return null;
    }
  }
};
var locale = {
  locale: 'id_ID',
  today: 'Hari ini',
  now: 'Saat ini',
  backToToday: 'Kembali ke hari ini',
  ok: 'Terapkan',
  clear: 'Bersih',
  month: 'Bulan',
  year: 'Tahun',
  timeSelect: 'pilih waktu',
  dateSelect: 'pilih tanggal',
  weekSelect: 'Pilih satu minggu',
  monthSelect: 'Pilih satu bulan',
  yearSelect: 'Pilih satu tahun',
  decadeSelect: 'Pilih satu dekade',
  yearFormat: 'YYYY',
  dateFormat: 'DD/MM/YYYY',
  dayFormat: 'DD',
  dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Bulan sebelumnya (PageUp)',
  nextMonth: 'Bulan selanjutnya (PageDown)',
  previousYear: 'Tahun lalu (Control + kiri)',
  nextYear: 'Tahun selanjutnya (Kontrol + kanan)',
  previousDecade: 'Dekade terakhir',
  nextDecade: 'Dekade berikutnya',
  previousCentury: 'Abad terakhir',
  nextCentury: 'Abad berikutnya',
  shortWeekDays: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab']
};
var Styles = function (_ref) {
  var size = _ref.size;
  return React.createElement(Global, {
    styles: function styles(theme) {
      var variants = get(theme, "forms.input.normal");
      var input = get(theme, "forms.input." + size);
      var container = get(theme, "forms.input.container");
      var containerSize = get(theme, "forms.input.container." + size);
      var btnType = get(theme, "buttons.btn-primary");
      var btnSizes = get(theme, "buttons.sm");
      var btnVariants = get(theme, "buttons.outline");
      var btnTransparent = get(theme, "buttons.transparent");
      var iconTop;
      var iconHorizontal = 8;
      switch (size) {
        case 'sm':
          iconTop = 10;
          break;
        case 'lg':
          iconTop = 20;
          iconHorizontal = 12;
          break;
        default:
          iconTop = 12;
          break;
      }
      return {
        '.legion-picker': _extends({}, get(theme, 'datepicker.wrapper'), container, containerSize),
        '.legion-picker-rtl': get(theme, 'datepicker.rtl'),
        '.legion-picker-focused > .legion-picker-input': get(theme, 'datepicker.focusedInput'),
        '.legion-picker-panel': get(theme, 'datepicker.panel'),
        '.legion-picker-panel-focused': get(theme, 'datepicker.focusedPanel'),
        '.legion-picker-panel-rtl': get(theme, 'datepicker.rtl'),
        '.legion-picker-decade-panel,.legion-picker-year-panel,.legion-picker-month-panel,.legion-picker-week-panel,.legion-picker-date-panel,.legion-picker-time-panel': get(theme, 'datepicker.panelContainer'),
        '.legion-picker-decade-panel table, .legion-picker-year-panel table, .legion-picker-month-panel table,.legion-picker-week-panel table,.legion-picker-date-panel table,.legion-picker-time-panel table': get(theme, 'datepicker.table'),
        '.legion-picker-header': get(theme, 'datepicker.header'),
        '.legion-picker-header > *': get(theme, 'datepicker.headerFlex'),
        '.legion-picker-header-view': get(theme, 'datepicker.headerView'),
        '.legion-picker-header-view > button': get(theme, 'datepicker.headerViewButton'),
        '.legion-picker-cell': get(theme, 'datepicker.tableCell'),
        '.legion-picker-cell-disabled': get(theme, 'datepicker.disabledCell'),
        '.legion-picker-cell-inner': get(theme, 'datepicker.cellInner'),
        '.legion-picker-cell-inner:hover': get(theme, 'datepicker.cellInnerHover'),
        // '.legion-picker-cell-in-view': {
        //   color: 'inherit',
        // },
        '.legion-picker-cell-in-range:not(.legion-picker-cell-range-start):not(.legion-picker-cell-range-end) > .legion-picker-cell-inner': get(theme, 'datepicker.inRangeCell'),
        '.legion-picker-cell-range-hover-start,.legion-picker-cell-range-hover-end,.legion-picker-cell-range-hover': get(theme, 'datepicker.rangeHoverContainer'),
        '.legion-picker-cell-range-hover-start::after,.legion-picker-cell-range-hover-end::after,.legion-picker-cell-range-hover::after': get(theme, 'datepicker.rangeHoverBorder'),
        '.legion-picker-cell-range-hover-start::after': get(theme, 'datepicker.rangeHoverStart'),
        '.legion-picker-cell-range-hover-end::after': get(theme, 'datepicker.rangeHoverEnd'),
        '.legion-picker-cell-today > .legion-picker-cell-inner': get(theme, 'datepicker.cellToday'),
        '.legion-picker-cell-range-start > .legion-picker-cell-inner,.legion-picker-cell-range-end > .legion-picker-cell-inner,.legion-picker-cell-selected > .legion-picker-cell-inner': get(theme, 'datepicker.selectedCell'),
        '.legion-picker-presets': get(theme, 'datepicker.presetContainer'),
        '.legion-picker-presets ul': get(theme, 'datepicker.presetList'),
        '.legion-picker-presets ul li': get(theme, 'datepicker.presetListItem'),
        '.legion-picker-presets ul li:hover': get(theme, 'datepicker.presetListItemHover'),
        '.legion-picker-footer': get(theme, 'datepicker.footer'),
        '.legion-picker-ranges': get(theme, 'datepicker.ranges'),
        '.legion-picker-ranges > li': get(theme, 'datepicker.rangeListItem'),
        '.legion-picker-ok': get(theme, 'datepicker.pickerOk'),
        '.legion-picker-year-panel .legion-picker-cell-inner,.legion-picker-month-panel .legion-picker-cell-inner': get(theme, 'datepicker.widthInnerCell'),
        '.legion-picker-week-panel-row:hover .legion-picker-cell': get(theme, 'datepicker.weekRowHover'),
        '.legion-picker-week-panel-row-selected .legion-picker-cell': get(theme, 'datepicker.weekCellSelected'),
        '.legion-picker-week-panel .legion-picker-cell, .legion-picker-week-panel .legion-picker-cell-inner': get(theme, 'datepicker.weekCellContainer'),
        '.legion-picker-week-panel .legion-picker-cell-inner': get(theme, 'datepicker.cellInnerContainer'),
        '.legion-picker-week-panel .legion-picker-cell-week': get(theme, 'datepicker.weekCell'),
        '.legion-picker-week-panel .legion-picker-cell:hover > .legion-picker-cell-inner,.legion-picker-week-panel .legion-picker-cell-selected > .legion-picker-cell-inner': get(theme, 'datepicker.weekCellHover'),
        '.legion-picker-date-panel .legion-picker-cell-inner': get(theme, 'datepicker.cellInnerContainer'),
        // '.legion-picker-time-panel': {
        //   width: 'auto',
        // },
        '.legion-picker-time-panel .legion-picker-content': get(theme, 'datepicker.timePanelContainer'),
        '.legion-picker-content td': get(theme, 'datepicker.contentCell'),
        '.legion-picker-time-panel-column': get(theme, 'datepicker.timePanelColumn'),
        '.legion-picker-time-panel-column-active': get(theme, 'datepicker.timePanelColumnActive'),
        '.legion-picker-time-panel-column:hover': get(theme, 'datepicker.timePanelColumnHover'),
        '.legion-picker-time-panel-column > li': get(theme, 'datepicker.timePanelColumnListItem'),
        '.legion-picker-time-panel-column > li.legion-picker-time-panel-cell-disabled': get(theme, 'datepicker.timePanelColumnDisabled'),
        '.legion-picker-time-panel-column > li .legion-picker-time-panel-cell-inner': get(theme, 'datepicker.timePanelCellInner'),
        '.legion-picker-panel-rtl .legion-picker-time-panel-column > li .legion-picker-time-panel-cell-inner': get(theme, 'datepicker.timePanelCellInnerRtl'),
        '.legion-picker-datetime-panel': get(theme, 'datepicker.datetimePanel'),
        '.legion-picker-datetime-panel .legion-picker-time-panel': get(theme, 'datepicker.datetimeTimePanel'),
        '.legion-picker-datetime-panel .legion-picker-date-panel,.legion-picker-datetime-panel .legion-picker-time-panel': get(theme, 'datepicker.datetimeTimeContainer'),
        '.legion-picker-datetime-panel-active .legion-picker-date-panel,.legion-picker-datetime-panel-active .legion-picker-time-panel': {
          opacity: 0.3
        },
        '.legion-picker-datetime-panel-active .legion-picker-date-panel-active,.legion-picker-datetime-panel-active .legion-picker-time-panel-active': {
          opacity: 1
        },
        '.legion-picker-input': get(theme, 'datepicker.pickerInput'),
        '.legion-picker-rtl .legion-picker-input': {
          textAlign: 'right'
        },
        '.legion-picker-input > input': _extends({
          fontSize: 'inherit',
          lineHeight: 'inherit',
          margin: '0 24px'
        }, variants, input),
        '.legion-picker-input > input::-moz-placeholder': {
          opacity: 1
        },
        '.legion-picker-input > input::placeholder': get(theme, 'datepicker.pickerInputPlaceholder'),
        '.legion-picker-input > input:placeholder-shown': {
          textOverflow: 'ellipsis'
        },
        '.legion-picker-input-placeholder > input': get(theme, 'datepicker.pickerInputPlaceholder'),
        '.legion-picker-clear': {
          position: 'absolute',
          top: iconTop,
          right: iconHorizontal,
          cursor: 'pointer'
        },
        '.legion-picker-suffix': {
          position: 'absolute',
          top: iconTop,
          left: iconHorizontal,
          cursor: 'pointer'
        },
        '.legion-picker-rtl .legion-picker-clear': {
          right: 'auto',
          left: 4
        },
        '.legion-picker-clear-btn::after': {
          content: '"×"'
        },
        '.legion-picker-dropdown': get(theme, 'datepicker.pickerDropdown'),
        '.legion-picker-dropdown-range': {
          padding: 0
        },
        '.legion-picker-dropdown-range .legion-picker-panel': {
          margin: 0,
          padding: 20,
          paddingBottom: 0
        },
        '.legion-picker-dropdown-hidden': {
          display: 'none'
        },
        '.legion-picker-dropdown-placement-topLeft .legion-picker-range-arrow,.legion-picker-dropdown-placement-topRight .legion-picker-range-arrow': {
          bottom: 6,
          transform: 'rotate(135deg)'
        },
        '.legion-picker-dropdown-placement-bottomLeft .legion-picker-range-arrow,.legion-picker-dropdown-placement-bottomright .legion-picker-range-arrow': {
          top: 6,
          transform: 'rotate(-45deg)'
        },
        '.legion-picker-dropdown .legion-picker-range-arrow': {
          position: 'absolute',
          left: 10,
          zIndex: 1,
          width: 10,
          height: 10,
          marginLeft: 10,
          transition: 'all 0.3s'
        },
        '.legion-picker-dropdown-rtl.legion-picker-dropdown .legion-picker-range-arrow': {
          right: 10,
          left: 'auto',
          marginRight: 10,
          marginLeft: 0
        },
        '.legion-picker-dropdown .legion-picker-range-arrow::before,.legion-picker-dropdown .legion-picker-range-arrow::after': {
          position: 'absolute',
          top: '50%',
          left: '50%',
          boxSizing: 'border-box',
          transform: 'translate(-50%, -50%)',
          content: '""'
        },
        '.legion-picker-dropdown-rtl.legion-picker-dropdown .legion-picker-range-arrow::before,.legion-picker-dropdown-rtl.legion-picker-dropdown .legion-picker-range-arrow::after': {
          right: '50%',
          left: 'auto',
          transform: 'translate(50%, -50%)'
        },
        '.legion-picker-dropdown .legion-picker-range-arrow::before': {
          width: 10,
          height: 10,
          border: '5px solid blue',
          borderColor: 'blue blue transparent transparent'
        },
        '.legion-picker-dropdown .legion-picker-range-arrow::after': {
          width: 8,
          height: 8,
          border: '4px solid blue',
          borderColor: '#fff0ff #fff0ff transparent transparent'
        },
        '.legion-picker-range': get(theme, 'datepicker.pickerRange'),
        '.legion-picker-range .legion-picker-input': {
          border: 'none'
        },
        '.legion-picker-range .legion-picker-input > input': _extends({
          fontSize: 'inherit',
          lineHeight: 'inherit'
        }, variants, input),
        '.legion-picker-range .legion-picker-input:nth-of-type(1) > input': {
          margin: 0,
          marginLeft: 24,
          display: 'block'
        },
        '.legion-picker-range .legion-picker-input:nth-of-type(3) > input': {
          margin: 0,
          marginRight: 24,
          display: 'block'
        },
        '.legion-picker-range.legion-picker-focused > .legion-picker-input': {
          outline: 'none',
          border: 'none',
          boxShadow: 'none'
        },
        '.legion-picker-range.legion-picker-focused': get(theme, 'datepicker.rangePickerFocused'),
        '.legion-picker-range-wrapper': {
          display: 'flex',
          justifyContent: 'center'
        },
        '.legion-picker-range .legion-picker-active-bar': get(theme, 'datepicker.rangePickerActiveBar'),
        '.legion-picker-range.legion-picker-focused .legion-picker-active-bar': {
          opacity: 1
        },
        '.legion-picker-panel-container': {
          display: 'inline-block',
          verticalAlign: 'top',
          transition: 'margin 0.3s'
        },
        '.legion-picker-panel-layout': {
          display: 'flex',
          flexWrap: 'nowrap',
          alignItems: 'stretch'
        },
        '.legion-picker-header-super-next-btn,.legion-picker-header-super-prev-btn': {
          display: 'none'
        },
        '.legion-picker-month-btn': {
          marginRight: 8
        },
        '.legion-picker-month-btn,.legion-picker-year-btn,.legion-picker-decade-btn': {
          fontSize: 18,
          lineHeight: '28px',
          background: 'none',
          cursor: 'pointer'
        },
        '.legion-picker-range-arrow': {
          display: 'none'
        },
        '.legion-picker-header-prev-btn,.legion-picker-header-next-btn': {
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        },
        '.legion-picker-cell:before': {
          position: 'absolute',
          top: '50%',
          right: 0,
          left: 0,
          zIndex: 1,
          height: 45,
          transform: 'translateY(-50%)',
          transition: 'all .3s',
          content: '""'
        },
        '.legion-picker-cell-range-start:before': {
          left: '50%'
        },
        '.legion-picker-cell-range-end:before': {
          right: '50%'
        },
        '.legion-picker-cell-in-range:before': get(theme, 'datepicker.inRangeBg'),
        '.legion-picker-cell-range-start:not(.legion-picker-cell-range-start-single):before,.legion-picker-cell-range-end:not(.legion-picker-cell-range-end-single):before': get(theme, 'datepicker.inRangeStartEnd'),
        '.legion-picker-decade-panel .legion-picker-cell .legion-picker-cell-inner': {
          padding: 8
        },
        '.legion-picker-range-separator': {
          padding: '0 4px'
        },
        '.legion-picker-date-panel': {
          padding: 20
        },
        '.legion-picker-date-range-wrapper .legion-picker-panel': {
          padding: 0
        },
        '.legion-picker-date-range-wrapper .legion-picker-time-panel': {
          padding: 20
        },
        '.legion-picker-today-btn,.legion-picker-ok > button': _extends({}, btnType, btnVariants, btnSizes, get(theme, 'datepicker.btnOk'), {
          minHeight: 'none'
        }),
        '.legion-picker-now > .legion-picker-now-btn': _extends({}, btnType, btnTransparent, btnSizes, get(theme, 'datepicker.btnNow'), {
          minHeight: 'none'
        })
      };
    }
  });
};
var _excluded$A = ["generateConfig", "locale", "format", "size"];
var Datepicker = function Datepicker(_ref) {
  var _ref$generateConfig = _ref.generateConfig,
    generateConfig$1 = _ref$generateConfig === void 0 ? generateConfig : _ref$generateConfig,
    _ref$locale = _ref.locale,
    locale$1 = _ref$locale === void 0 ? locale : _ref$locale,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? 'DD/MM/YYYY' : _ref$format,
    size = _ref.size,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$A);
  var iconSize;
  var fontSize;
  var textFieldSize;
  switch (size) {
    case 'sm':
      iconSize = 14;
      fontSize = 14;
      textFieldSize = 20;
      break;
    case 'lg':
      iconSize = 18;
      fontSize = 18;
      textFieldSize = 28;
      break;
    case 'md':
      iconSize = 16;
      fontSize = 16;
      textFieldSize = 24;
      break;
    default:
      iconSize = 16;
      fontSize = 16;
      textFieldSize = 24;
      break;
  }
  var dateProps = _extends({
    generateConfig: generateConfig$1,
    locale: locale$1,
    prevIcon: React.createElement(DynamicIcon, {
      name: "ChevronLeft"
    }),
    nextIcon: React.createElement(DynamicIcon, {
      name: "ChevronRight"
    }),
    clearIcon: React.createElement(DynamicIcon, {
      height: iconSize,
      name: "X",
      width: iconSize
    }),
    suffixIcon: React.createElement(DynamicIcon, {
      height: iconSize,
      name: "Calendar",
      width: iconSize
    }),
    format: format
  }, rest, {
    prefixCls: 'legion-picker',
    style: {
      lineHeight: textFieldSize + "px",
      fontSize: fontSize
    },
    placeholder: 'dd/mm/yyyy'
  });
  return React.createElement(React.Fragment, null, React.createElement(Styles, {
    size: size
  }), React.createElement(Picker, Object.assign({}, dateProps)));
};
var _excluded$B = ["generateConfig", "locale", "prefixCls", "format", "size", "ranges", "separator"];
var DateRangePicker = function DateRangePicker(_ref) {
  var _ref$generateConfig = _ref.generateConfig,
    generateConfig$1 = _ref$generateConfig === void 0 ? generateConfig : _ref$generateConfig,
    _ref$locale = _ref.locale,
    locale$1 = _ref$locale === void 0 ? locale : _ref$locale,
    _ref$prefixCls = _ref.prefixCls,
    prefixCls = _ref$prefixCls === void 0 ? 'legion-picker' : _ref$prefixCls,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? 'DD/MM/YYYY' : _ref$format,
    size = _ref.size,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? 'To' : _ref$separator,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$B);
  var iconSize;
  var fontSize;
  var textFieldSize;
  switch (size) {
    case 'sm':
      iconSize = 14;
      fontSize = 14;
      textFieldSize = 20;
      break;
    case 'lg':
      iconSize = 18;
      fontSize = 18;
      textFieldSize = 28;
      break;
    case 'md':
      iconSize = 16;
      fontSize = 16;
      textFieldSize = 24;
      break;
    default:
      iconSize = 16;
      fontSize = 16;
      textFieldSize = 24;
      break;
  }
  var rangePickerRef = React.useRef(null);
  var props = _extends({
    generateConfig: generateConfig$1,
    locale: locale$1,
    prefixCls: prefixCls,
    prevIcon: React.createElement(DynamicIcon, {
      name: "ChevronLeft"
    }),
    nextIcon: React.createElement(DynamicIcon, {
      name: "ChevronRight"
    }),
    clearIcon: React.createElement(DynamicIcon, {
      height: iconSize,
      name: "X",
      width: iconSize
    }),
    suffixIcon: React.createElement(DynamicIcon, {
      height: iconSize,
      name: "Calendar",
      width: iconSize
    }),
    format: format,
    separator: separator
  }, rest, {
    style: {
      lineHeight: textFieldSize + "px",
      fontSize: fontSize
    },
    placeholder: ['dd/mm/yyyy', 'dd/mm/yyyy']
  });
  return React.createElement(React.Fragment, null, React.createElement(Styles, {
    size: size
  }), React.createElement(RangePicker, Object.assign({
    ref: rangePickerRef
  }, props)));
};
function objectValues(obj) {
  return Object.keys(obj).map(function (objKey) {
    return obj[objKey];
  });
}
function objectKeys(obj) {
  return Object.keys(obj).map(function (objKey) {
    return objKey;
  });
}
function isPrimitive(value) {
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'symbol';
}
function sortName(category, props) {
  return props.onSortUp(category);
}
function handleClick(index, props) {
  return props.onNestedTable(index);
}
function DataTable(props) {
  var _React$useState = React.useState({
      indexing: -1,
      showNested: false
    }),
    indexNested = _React$useState[0],
    setIndex = _React$useState[1];
  var context = useThemeUI();
  var dataTables = get(context.theme, "dataTable");
  var wrappSearch = get(context.theme, "dataTable.search");
  var wrappFilter = get(context.theme, "dataTable.filter");
  var wrappTable = get(context.theme, "dataTable.table");
  var tableHeads = get(context.theme, "dataTable.tableHead");
  var tableCells = get(context.theme, "dataTable.tableCell");
  var tablRows = get(context.theme, "dataTable.tableRow");
  var wrappSorts = get(context.theme, "dataTable.wrappSort");
  var headWithoutActions = get(context.theme, "dataTable.headWithoutAction");
  var headWithActions = get(context.theme, "dataTable.headWithAction");
  function renderRow(item, index) {
    var indexing = indexNested.indexing,
      showNested = indexNested.showNested;
    return jsx(React.Fragment, null, jsx("tr", {
      sx: _extends({}, tablRows)
    }, objectKeys(item).map(function (itemProperty, idx, value) {
      var _props$customRenderer;
      var customRenderer = (_props$customRenderer = props.customRenderers) == null ? void 0 : _props$customRenderer[itemProperty];
      if (customRenderer) {
        return jsx("td", {
          sx: _extends({}, tableCells)
        }, customRenderer(item));
      }
      return jsx(React.Fragment, {
        key: idx
      }, jsx("td", {
        colSpan: idx + 1 === (value && value.length) ? 2 : 1,
        key: idx,
        sx: _extends({}, tableCells)
      }, isPrimitive(item[itemProperty]) ? item[itemProperty] : ''), idx + 1 === (value && value.length) && jsx("td", {
        sx: _extends({}, tableCells)
      }, index === indexing ? jsx(ChevronDown, {
        onClick: function onClick() {
          return setIndex({
            indexing: -1,
            showNested: !showNested
          });
        },
        size: 14,
        sx: {
          '&:hover': {
            cursor: 'pointer'
          }
        }
      }) : jsx(ChevronRight, {
        color: "grey",
        onClick: function onClick() {
          return setIndex({
            indexing: index,
            showNested: !showNested
          });
        },
        size: 14,
        sx: {
          '&:hover': {
            cursor: 'pointer'
          }
        }
      })));
    })), index === indexing && handleClick(indexing, props));
  }
  return jsx("div", {
    sx: _extends({}, dataTables)
  }, jsx("div", {
    sx: _extends({}, wrappSearch)
  }, jsx("span", {
    sx: {
      marginBottom: 30
    }
  }, jsx("select", {
    onChange: props.onFilterCategory,
    sx: _extends({}, wrappFilter)
  }, objectValues(props.headers).map(function (headerValue, idx) {
    return jsx("option", {
      key: idx,
      value: headerValue
    }, headerValue);
  }))), jsx("span", null, jsx(Textfield, {
    iconLeft: jsx(Search, null),
    onChange: props.onSearch,
    placeholder: "Cari",
    value: props.search
  }))), jsx("table", {
    sx: _extends({}, wrappTable)
  }, jsx("thead", null, objectValues(props.headers).map(function (headerValue, idx, value) {
    return jsx("th", {
      colSpan: idx + 1 === (value && value.length) ? 3 : 1,
      key: idx,
      sx: _extends({}, tableHeads)
    }, jsx("span", {
      sx: idx + 1 === (value && value.length) ? _extends({}, headWithoutActions) : _extends({}, headWithActions)
    }, headerValue, jsx("span", {
      sx: _extends({}, wrappSorts)
    }, jsx(ChevronUp, {
      onClick: function onClick() {
        return sortName(headerValue + ' Latest', props);
      },
      size: 12,
      sx: {
        '&:hover': {
          cursor: 'pointer'
        }
      }
    }), jsx(ChevronDown, {
      onClick: function onClick() {
        return sortName(headerValue + ' Longest', props);
      },
      size: 12,
      sx: {
        '&:hover': {
          cursor: 'pointer'
        }
      }
    }))));
  })), jsx("tbody", null, props.items.map(renderRow))));
}
var _excluded$C = ["children", "header", "footer", "isCollapsible", "isHidden"];
var SidebarWrapper$1 = function SidebarWrapper(_ref) {
  var children = _ref.children,
    header = _ref.header,
    footer = _ref.footer,
    _ref$isCollapsible = _ref.isCollapsible,
    isCollapsible = _ref$isCollapsible === void 0 ? true : _ref$isCollapsible,
    _ref$isHidden = _ref.isHidden,
    isHidden = _ref$isHidden === void 0 ? false : _ref$isHidden,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$C);
  var SidebarWrapperContext = useThemeUI();
  var sidebarWrapper = get(SidebarWrapperContext.theme, 'SidebarWrapper');
  var additionalStyle = Object.keys(_extends({}, rest)).includes('style');
  var sidebarBodyOnly = header === undefined && footer === undefined;
  return jsx("div", Object.assign({
    sx: _extends({
      textAlign: 'left'
    }, sidebarWrapper)
  }, rest), jsx("input", {
    type: "checkbox",
    className: "openSidebarMenu",
    id: "openSidebarMenu",
    defaultChecked: !isHidden
  }), isCollapsible && jsx("label", {
    htmlFor: "openSidebarMenu",
    className: "sidebarIconToggle"
  }, jsx("div", {
    className: "spinner hamburger"
  }, jsx(DynamicIcon, {
    name: "Menu",
    size: 16
  })), jsx("div", {
    className: "spinner close"
  }, jsx(DynamicIcon, {
    name: "X",
    size: 16
  }))), jsx("div", Object.assign({
    id: "sidebarMenu"
  }, additionalStyle ? rest : {}), header && jsx("div", {
    className: "sidebarHeader"
  }, header), jsx("div", {
    className: "sidebarBody",
    style: sidebarBodyOnly ? {
      maxHeight: '96vh'
    } : {}
  }, children), footer && jsx("div", Object.assign({
    className: "sidebarFooter"
  }, additionalStyle ? rest : {}), footer)));
};
SidebarWrapper$1.displayName = 'SidebarWrapper';
var _excluded$D = ["borderRadius", "boxShadow", "children", "isOpen", "onClose", "position", "space", "trigger"];
var Dropdown = function Dropdown(_ref) {
  var borderRadius = _ref.borderRadius,
    _ref$boxShadow = _ref.boxShadow,
    boxShadow = _ref$boxShadow === void 0 ? '0 0 8px rgba(0, 0, 0, 0.125)' : _ref$boxShadow,
    children = _ref.children,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    position = _ref.position,
    _ref$space = _ref.space,
    space = _ref$space === void 0 ? 40 : _ref$space,
    trigger = _ref.trigger,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$D);
  var dropdownRef = React.useRef(null);
  React.useEffect(function () {
    var closeDropdown = function closeDropdown(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', closeDropdown);
    return function () {
      document.removeEventListener('mousedown', closeDropdown);
    };
  }, [onClose]);
  return jsx("div", {
    sx: {
      display: 'inline-block'
    }
  }, jsx("div", {
    ref: dropdownRef,
    sx: {
      width: '100%',
      display: 'flex',
      justifyContent: position === 'left' ? 'left' : position === 'center' ? 'center' : position === 'right' ? 'right' : 'left'
    }
  }, trigger, isOpen && jsx(Box, Object.assign({}, rest, {
    sx: {
      background: 'white',
      borderRadius: borderRadius,
      boxShadow: boxShadow,
      marginTop: space,
      position: 'absolute',
      zIndex: 99999
    }
  }), children)));
};
var _excluded$E = ["steps"];
var Onboarding = function Onboarding(_ref) {
  var steps = _ref.steps,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$E);
  return React.createElement(React.Fragment, null, React.createElement(Joyride, Object.assign({
    steps: steps
  }, rest)));
};
var _excluded$F = ["children", "modalId", "title", "isActive", "iconName", "footer", "onClose", "width", "height"];
var Modal$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$modalId = _ref.modalId,
    modalId = _ref$modalId === void 0 ? "modal-1" : _ref$modalId,
    title = _ref.title,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    iconName = _ref.iconName,
    footer = _ref.footer,
    onClose = _ref.onClose,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '50%' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'auto' : _ref$height,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$F);
  var ModalContext = useThemeUI();
  var Modal = get(ModalContext.theme, 'Modal');
  var modalRef = React.useRef(null);
  var toggleModalStateClass = function toggleModalStateClass(e) {
    if (e.target.checked) {
      e.target.classList.toggle('active');
    }
  };
  React.useEffect(function () {
    var modalState = document.getElementById(modalId);
    var modalWrapper = document.querySelector("#" + modalId + "+.modal");
    var modalInner = document.querySelector("#" + modalId + "+.modal .modal__inner");
    var modalInnerCurrentStyle = modalInner == null ? void 0 : modalInner.getAttribute('style');
    var closeModal = function closeModal(e) {
      if (modalState != null && modalState.checked && modalRef.current && !modalRef.current.contains(e.target)) {
        onClose(false);
      }
    };
    if (modalState != null && modalState.checked) {
      document.addEventListener('mousedown', closeModal);
      modalWrapper == null ? void 0 : modalWrapper.setAttribute('style', 'opacity:1; visibility: visible;');
      modalInner == null ? void 0 : modalInner.setAttribute('style', modalInnerCurrentStyle + " top:50%;");
    }
    return function () {
      modalWrapper == null ? void 0 : modalWrapper.removeAttribute('style');
      modalInner == null ? void 0 : modalInner.setAttribute('style', "" + modalInnerCurrentStyle);
      document.removeEventListener('mousedown', closeModal);
    };
  });
  return jsx("div", {
    ref: ref,
    sx: _extends({
      textAlign: 'left'
    }, Modal)
  }, jsx("input", {
    className: "modal-state",
    id: modalId,
    type: "checkbox",
    checked: isActive,
    onChange: function onChange() {
      return toggleModalStateClass;
    }
  }), jsx("div", {
    className: "modal"
  }, jsx("label", {
    className: "modal__bg",
    htmlFor: modalId
  }), jsx("div", {
    className: "modal__inner",
    style: {
      width: "" + width,
      height: "" + height
    }
  }, (title || iconName) && jsx("label", {
    className: "modal__close",
    htmlFor: modalId
  }, jsx(DynamicIcon, {
    name: "X",
    size: 16
  })), jsx("div", {
    ref: modalRef,
    className: "modal__inner_wrapper"
  }, (title || iconName) && jsx("div", {
    className: "modal__title"
  }, iconName && jsx(DynamicIcon, {
    name: iconName,
    size: 16
  }), title && jsx("span", null, title)), jsx("div", Object.assign({
    className: "modal__content"
  }, rest), children), footer && jsx("div", {
    className: "modal__footer " + (height !== 'auto' ? ' fixed' : '')
  }, footer)))));
});
var _excluded$G = ["label", "variant", "size", "color", "onClick", "avatar", "leftIcon", "rightIcon"];
var Chip$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "soft" : _ref$variant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "md" : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "primary" : _ref$color,
    onClick = _ref.onClick,
    avatar = _ref.avatar,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$G);
  var ChipContext = useThemeUI();
  var ChipStyle = get(ChipContext.theme, 'Chip');
  var chipRef = React.useRef(null);
  var setActiveChip = function setActiveChip() {
    var _chipRef$current;
    (_chipRef$current = chipRef.current) == null ? void 0 : _chipRef$current.click();
  };
  var isDisabled = onClick === undefined;
  var isIconOnly = label === undefined;
  return jsx("div", Object.assign({
    ref: ref,
    sx: _extends({}, ChipStyle)
  }, rest), jsx("input", {
    type: "checkbox",
    ref: chipRef,
    onChange: onClick,
    disabled: isDisabled
  }), jsx(Badge$1, {
    className: "chip chip--" + size + " " + variant + " " + variant + "--" + color,
    onClick: setActiveChip
  }, leftIcon && jsx("span", {
    className: "chip--prefix " + (isIconOnly ? 'icon-only' : '')
  }, leftIcon), avatar && jsx("span", {
    className: "chip--prefix " + (isIconOnly ? 'icon-only' : '')
  }, avatar), label, rightIcon && jsx("span", {
    className: "chip--postfix " + (isIconOnly ? 'icon-only' : '')
  }, rightIcon)));
});
var Carousel = function Carousel(_ref) {
  var autoPlay = _ref.autoPlay,
    autoplay = _ref.autoplay,
    data = _ref.data,
    descSize = _ref.descSize,
    ratio = _ref.ratio,
    showControl = _ref.showControl,
    showIndicator = _ref.showIndicator,
    titleSize = _ref.titleSize;
  var _React$useState = React.useState(0),
    activeIndex = _React$useState[0],
    setActiveIndex = _React$useState[1];
  var _React$useState2 = React.useState(false),
    paused = _React$useState2[0],
    setPaused = _React$useState2[1];
  var updateIndex = function updateIndex(newIndex) {
    if (newIndex < 0) {
      newIndex = data.length - 1;
    } else if (newIndex >= data.length) {
      newIndex = 0;
    }
    setActiveIndex(newIndex);
  };
  var onControl = function onControl(position, newIndex) {
    updateIndex(position === 'left' ? newIndex - 1 : newIndex + 1);
  };
  React.useEffect(function () {
    var interval = setInterval(function () {
      if (!paused && autoPlay || autoplay) {
        updateIndex(activeIndex + 1);
      }
    }, 3000);
    return function () {
      if (interval) {
        clearInterval(interval);
      }
    };
  });
  var carouselContext = useThemeUI();
  var primary50 = get(carouselContext.theme, "carousel.primary50.backgroundColor");
  var primary500 = get(carouselContext.theme, "carousel.primary500.backgroundColor");
  var tertiary100 = get(carouselContext.theme, "carousel.tertiary100.backgroundColor");
  var carouselImageTitle = get(carouselContext.theme, "carousel.imageTitle");
  var carouselImageDesc = get(carouselContext.theme, "carousel.imageDesc");
  return jsx("div", {
    sx: {
      overflow: 'hidden',
      position: 'relative'
    },
    onMouseEnter: autoPlay || autoplay ? function () {
      return setPaused(true);
    } : undefined,
    onMouseLeave: autoPlay || autoplay ? function () {
      return setPaused(false);
    } : undefined
  }, jsx("div", {
    sx: {
      whiteSpace: 'nowrap',
      transition: 'transform 0.3s',
      transform: "translateX(-" + activeIndex * 100 + "%)"
    }
  }, data.map(function (item, index) {
    return jsx("div", {
      key: index,
      sx: {
        display: 'inline-block',
        width: '100%'
      }
    }, jsx(Image, {
      src: item.imageURL,
      ratio: ratio,
      alt: item.alt
    }), item.title && item.desc ? jsx(React.Fragment, null, jsx("div", {
      sx: _extends({
        fontSize: titleSize
      }, carouselImageTitle)
    }, item.title), jsx("div", {
      sx: _extends({
        fontSize: descSize
      }, carouselImageDesc)
    }, item.desc)) : null);
  })), showControl ? jsx("div", {
    sx: {
      width: '100%',
      position: 'absolute',
      top: 0,
      bottom: 0,
      marginTop: data.filter(function (item) {
        return item.title !== undefined;
      }).length > 0 ? -25 : 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, jsx("div", {
    sx: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      paddingX: 16
    }
  }, jsx("button", {
    sx: {
      background: primary50,
      border: 'transparent',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      borderRadius: 4,
      width: 25,
      height: 25
    },
    onClick: function onClick() {
      return onControl('left', activeIndex);
    }
  }, jsx(DynamicIcon, {
    name: "ArrowLeft",
    width: 15,
    height: 15,
    color: primary500
  })), jsx("button", {
    sx: {
      background: primary50,
      border: 'transparent',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      borderRadius: 4,
      width: 25,
      height: 25
    },
    onClick: function onClick() {
      return onControl('right', activeIndex);
    }
  }, jsx(DynamicIcon, {
    name: "ArrowRight",
    width: 15,
    height: 15,
    color: primary500
  })))) : null, jsx("div", {
    sx: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      bottom: data.filter(function (item) {
        return item.title !== undefined;
      }).length > 0 ? '35px' : 2
    }
  }, showIndicator ? data.map(function (_, index) {
    return jsx("div", {
      sx: {
        width: 8,
        height: 8,
        margin: 1,
        cursor: 'pointer',
        borderRadius: '50%',
        backgroundColor: index === activeIndex ? primary500 : tertiary100
      },
      onClick: function onClick() {
        updateIndex(index);
      },
      key: index
    });
  }) : null));
};
var Megamenu = function Megamenu(_ref) {
  var _ref$action = _ref.action,
    action = _ref$action === void 0 ? 'hover' : _ref$action,
    data = _ref.data,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    space = _ref.space,
    trigger = _ref.trigger,
    width = _ref.width;
  var _React$useState = React.useState(0),
    currentIndex = _React$useState[0],
    setCurrentIndex = _React$useState[1];
  var onAction = function onAction(type, newIndex) {
    if (action === type) {
      setCurrentIndex(newIndex);
    }
    return null;
  };
  React.useEffect(function () {
    if (!isOpen) {
      setCurrentIndex(0);
    }
  });
  var megamenuContext = useThemeUI();
  var megamenuPrimary50 = get(megamenuContext.theme, "megamenu.primary50.backgroundColor");
  var megamenuPrimary500 = get(megamenuContext.theme, "megamenu.primary500.color");
  var megamenuTertiary800 = get(megamenuContext.theme, "megamenu.tertiary800.color");
  var flexWrapper = get(megamenuContext.theme, "megamenu.flexWrapper");
  var leftWrapper = get(megamenuContext.theme, "megamenu.leftWrapper");
  var leftWrapperItem = get(megamenuContext.theme, "megamenu.leftWrapper.item");
  var leftWrapperItemTitle = get(megamenuContext.theme, "megamenu.leftWrapper.item.title");
  var rightWrapper = get(megamenuContext.theme, "megamenu.rightWrapper");
  var rightWrapperItem = get(megamenuContext.theme, "megamenu.rightWrapper.item");
  var rightWrapperItemTitle = get(megamenuContext.theme, "megamenu.rightWrapper.item.title");
  var rightWrapperLayout = get(megamenuContext.theme, "megamenu.rightWrapper.layoutWrapper");
  var rightWrapperLayoutChildrenLayout = get(megamenuContext.theme, "megamenu.rightWrapper.item.children.layout");
  var rightWrapperLayoutChildrenLayoutTitle = get(megamenuContext.theme, "megamenu.rightWrapper.item.children.layout.title");
  var rightWrapperLayoutChildrenDesc = get(megamenuContext.theme, "megamenu.rightWrapper.item.children.layout.desc");
  return jsx(Dropdown, {
    onClose: onClose,
    isOpen: isOpen,
    space: space,
    trigger: trigger
  }, jsx("div", {
    sx: _extends({
      width: width
    }, flexWrapper)
  }, jsx("div", {
    sx: _extends({}, leftWrapper)
  }, data.map(function (item, index) {
    return jsx("div", {
      key: index,
      sx: _extends({
        backgroundColor: item.title === data[currentIndex].title ? "" + megamenuPrimary50 : 'transparent'
      }, leftWrapperItem),
      onClick: function onClick() {
        return onAction('click', index);
      },
      onPointerEnter: function onPointerEnter() {
        return onAction('hover', index);
      }
    }, jsx("div", {
      sx: _extends({
        color: item.title === data[currentIndex].title ? "" + megamenuPrimary500 : "" + megamenuTertiary800
      }, leftWrapperItemTitle)
    }, item.title));
  })), jsx("div", {
    sx: _extends({}, rightWrapper)
  }, jsx("div", {
    sx: _extends({}, rightWrapperItem)
  }, jsx(DynamicIcon, {
    sx: {
      marginRight: '5px'
    },
    name: data[currentIndex].icon,
    size: 20
  }), jsx("div", {
    sx: _extends({}, rightWrapperItemTitle)
  }, data[currentIndex].title)), jsx("div", {
    sx: _extends({}, rightWrapperLayout)
  }, data[currentIndex].items.map(function (items, index) {
    return jsx("div", {
      sx: _extends({}, rightWrapperLayoutChildrenLayout),
      key: index
    }, jsx("div", {
      sx: _extends({}, rightWrapperLayoutChildrenLayoutTitle)
    }, items.title), items.item.map(function (item, index) {
      return jsx("div", {
        sx: {
          marginBottom: 10
        },
        key: index
      }, jsx(Anchor, {
        href: item.url,
        size: "sm",
        sx: _extends({}, rightWrapperLayoutChildrenDesc)
      }, item.label));
    }));
  })))));
};
var _templateObject, _templateObject2, _templateObject3;
var Stepper = function Stepper(_ref) {
  var steps = _ref.steps,
    currentStep = _ref.currentStep,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
    borderColor = _ref.borderColor,
    backgroundColor = _ref.backgroundColor,
    showBoxShadow = _ref.showBoxShadow,
    _ref$showTextOn = _ref.showTextOn,
    showTextOn = _ref$showTextOn === void 0 ? 'right' : _ref$showTextOn,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'success' : _ref$variant;
  var context = useThemeUI();
  var stepItem = get(context.theme, "stepper.stepItem");
  var stepItemActive = get(context.theme, "stepper.stepItemActive");
  var stepTitle = get(context.theme, "stepper.stepTitle");
  var stepDescription = get(context.theme, "stepper.stepDescription");
  var stepVariant = get(context.theme, "stepper." + variant);
  var isOrientationHorizontal = orientation === 'horizontal';
  var isShowTextOnRight = showTextOn === 'right';
  var scaleBackwards = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  0% {\n\t\ttransform: scale(1.2);\n\t}\n\n\t100% {\n\t\ttransform: scale(1);\n\t}"])));
  var verticalTopAnimation = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  0% {\n\t\ttransform: translateX(calc(clamp(1.5rem, 5vw, 3rem) / 2)) scaleY(0.1);\n\t\ttransform-origin: 2rem -0.3rem;\n\t}\n\n\t100% {\n\t\ttransform: translateX(calc(clamp(1.5rem, 5vw, 3rem) / 2)) scaleY(1);\n\t\ttransform-origin: 2rem -0.3rem;\n\t}"])));
  var horizontalLeftAnimation = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  0% {\n\t\ttransform: scaleX(0.1);\n\t\ttransform-origin: 0% 0%;\n\t}\n\n\t100% {\n\t\ttransform: scaleX(1);\n\t\ttransform-origin: 0% 0%;\n\t}"])));
  return jsx(Flex, {
    sx: {
      flexDirection: isOrientationHorizontal ? 'row' : 'column',
      justifyContent: 'space-evenly'
    }
  }, steps.map(function (step, index) {
    var isStepPassed = index < currentStep;
    var isStepActive = index == currentStep;
    return jsx(Flex, {
      key: index,
      sx: {
        position: orientation === 'vertical' ? 'relative' : null,
        gap: orientation === 'vertical' ? '1rem' : null,
        paddingBottom: orientation === 'vertical' ? '4rem' : null,
        alignItems: 'center',
        '&:not(:last-child)': {
          flex: 1,
          '&::after': {
            content: '""',
            position: isOrientationHorizontal ? 'relative' : 'absolute',
            left: !isOrientationHorizontal ? '-0.3rem' : null,
            top: !isOrientationHorizontal ? '2rem' : null,
            bottom: !isOrientationHorizontal ? 0 : !isShowTextOnRight ? '1.2rem' : null,
            zIndex: '0',
            height: isOrientationHorizontal ? '2px' : null,
            transform: !isOrientationHorizontal ? 'translateX(calc(clamp(1.5rem, 5vw, 3rem) / 2))' : null,
            backgroundColor: isStepPassed ? backgroundColor || stepVariant.backgroundColor : '#CACFD4',
            flex: isOrientationHorizontal && isShowTextOnRight ? 1 : null,
            width: !isOrientationHorizontal ? '2px' : isShowTextOnRight ? null : 'calc(100% - clamp(1.5rem, 5vw, 3rem) + 90px)',
            animation: isStepPassed ? isOrientationHorizontal ? horizontalLeftAnimation + " 1s ease 0s 1 normal none" : verticalTopAnimation + " 1s ease 0s 1 normal none" : null
          }
        }
      }
    }, jsx(Flex, {
      sx: {
        flexDirection: isOrientationHorizontal ? isShowTextOnRight ? 'row' : 'column' : 'row',
        mb: orientation === 'vertical' ? 20 : 0,
        alignItems: !isShowTextOnRight ? 'center' : null,
        textAlign: isOrientationHorizontal && !isShowTextOnRight ? 'center' : null
      }
    }, jsx(Box, {
      bg: isStepPassed ? stepVariant.backgroundColor : '#fff',
      sx: _extends({}, stepItem, isStepPassed ? _extends({}, stepItemActive, stepVariant, {
        animation: scaleBackwards + " 1s ease 0s 1 normal none"
      }) : {}, isStepActive ? _extends({}, stepItemActive, {
        borderColor: borderColor || stepVariant.borderColor,
        animation: scaleBackwards + " 1s ease 0s 1 normal none"
      }) : {}, showBoxShadow ? {
        boxShadow: 'default'
      } : {
        boxShadow: 'none'
      }, {
        borderColor: isStepPassed || isStepActive ? borderColor || stepVariant.borderColor : null,
        backgroundColor: isStepPassed ? backgroundColor : null,
        zIndex: 2
      })
    }, step.icon || isStepPassed ? jsx(DynamicIcon, {
      color: isStepPassed ? '#fff' : '#000',
      name: (isStepPassed ? 'Check' : step.icon) || 'Check',
      size: 28
    }) : jsx(Text, null, index + 1)), jsx(Flex, {
      sx: {
        flexDirection: 'column',
        marginLeft: isShowTextOnRight || !isOrientationHorizontal ? 10 : 0,
        marginTop: !isShowTextOnRight ? 2 : 0,
        justifyContent: isShowTextOnRight ? 'center' : null,
        marginRight: isShowTextOnRight ? 10 : 0
      }
    }, jsx(Text, {
      sx: stepTitle
    }, step.label.title), step.label.description && jsx(Text, {
      sx: stepDescription
    }, step.label.description))));
  }));
};
Stepper.displayName = 'Stepper';
var _excluded$H = ["children", "variant", "tabName"];
var TabWrapper = function TabWrapper(_ref) {
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "horizontal" : _ref$variant,
    _ref$tabName = _ref.tabName,
    tabName = _ref$tabName === void 0 ? "legionTabs" : _ref$tabName,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$H);
  var TabWrapperContext = useThemeUI();
  var tabbarCtx = get(TabWrapperContext.theme, "tabbar");
  var tabbarWrapper = get(TabWrapperContext.theme, "tabbar.wrapper");
  var tabbarVariant = get(TabWrapperContext.theme, "tabbar." + variant);
  return jsx(Box, Object.assign({
    sx: _extends({}, tabbarCtx)
  }, rest), jsx("div", {
    sx: _extends({}, tabbarWrapper, tabbarVariant),
    role: "tablist",
    id: tabName
  }, children));
};
TabWrapper.displayName = 'TabWrapper';
var _excluded$I = ["children", "id", "label", "icon", "isActive", "isDisabled", "onClick", "badgeNumber"];
var TabItem = function TabItem(_ref) {
  var children = _ref.children,
    id = _ref.id,
    label = _ref.label,
    icon = _ref.icon,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    onClick = _ref.onClick,
    badgeNumber = _ref.badgeNumber,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$I);
  var TabItemContext = useThemeUI();
  var tabbarTabItem = get(TabItemContext.theme, "tabbar.tabItem");
  var tabItemRef = React.useRef(null);
  var tabInputRef = React.useRef(null);
  var handleClickTab = function handleClickTab() {
    var _tabInputRef$current;
    (_tabInputRef$current = tabInputRef.current) == null ? void 0 : _tabInputRef$current.click();
  };
  React.useEffect(function () {
    var _tabInputRef$current2;
    if (!((_tabInputRef$current2 = tabInputRef.current) != null && _tabInputRef$current2.getAttribute('name'))) {
      var _tabItemRef$current, _tabItemRef$current$p, _tabInputRef$current3;
      var uniqueTabName = (_tabItemRef$current = tabItemRef.current) == null ? void 0 : (_tabItemRef$current$p = _tabItemRef$current.parentElement) == null ? void 0 : _tabItemRef$current$p.id;
      (_tabInputRef$current3 = tabInputRef.current) == null ? void 0 : _tabInputRef$current3.setAttribute('name', "" + uniqueTabName);
    }
  }, []);
  return jsx("div", Object.assign({
    ref: tabItemRef,
    sx: _extends({}, tabbarTabItem)
  }, rest, {
    className: "tab-item"
  }), jsx("input", {
    ref: tabInputRef,
    type: "radio",
    id: "legionTab_" + id,
    defaultChecked: isActive,
    onChange: onClick,
    disabled: isDisabled
  }), jsx("label", {
    htmlFor: "legionTab_" + id,
    role: "tab",
    "aria-selected": "true",
    "aria-controls": "panel1",
    onClick: handleClickTab
  }, icon && jsx("span", {
    className: 'prefix'
  }, jsx(DynamicIcon, {
    name: icon,
    size: 16
  })), label, badgeNumber && jsx("span", {
    className: 'tab-badges'
  }, badgeNumber)), children && jsx("div", {
    id: "legionTabContent_" + id,
    className: "tab-content",
    role: "tabpanel",
    "aria-labelledby": "description",
    "aria-hidden": "false"
  }, children));
};
TabItem.displayName = 'TabItem';
export { Accordion, Alert, Anchor, Avatar, Badge, Body, Button, Caption, Card, CardBody, CardFooter, CardHeader, Carousel, Checkbox, Chip$1 as Chip, ColorsCard, DataTable, DateRangePicker, Datepicker, Dropdown, DynamicIcon, HeadCell, Heading, Image, LoginPage, Megamenu, Modal$1 as Modal, Navbar, NavbarBrand, NavbarCollapse, NavbarContent, NavbarItem, NavbarToggle, Navigation, Onboarding, PaymentCard, Radio, Select, SidebarNavLink, SidebarWrapper$1 as SidebarWrapper, Spinner, Stepper, Switch, TabItem, TabWrapper, Table, TableBody, TableCell, TableHead, TableRow, Textarea, Textfield, Tooltip, calculateSvgWeight, isValidEmail, isValidURL, radius, spacer, text, theme, useScrollDirection };